(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("keymirror"), require("react-dom"), require("lwr-client"), require("react"), require("prop-types"), require("react-bootstrap"), require("react-virtualized"), require("react-beautiful-dnd"), require("react-quill"), require("react-quill-css"), require("./react"));
	else if(typeof define === 'function' && define.amd)
		define(["keymirror", "react-dom", "lwr-client", "react", "prop-types", "react-bootstrap", "react-virtualized", "react-beautiful-dnd", "react-quill", "react-quill-css", "react"], factory);
	else if(typeof exports === 'object')
		exports["liferay-widgets-react-web"] = factory(require("keymirror"), require("react-dom"), require("lwr-client"), require("react"), require("prop-types"), require("react-bootstrap"), require("react-virtualized"), require("react-beautiful-dnd"), require("react-quill"), require("react-quill-css"), require("./react"));
	else
		root["liferay-widgets-react-web"] = factory(root["keymirror"], root["react-dom"], root["lwr-client"], root["react"], root["prop-types"], root["react-bootstrap"], root["react-virtualized"], root["react-beautiful-dnd"], root["react-quill"], root["react-quill-css"], root["react"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_73__, __WEBPACK_EXTERNAL_MODULE_80__, __WEBPACK_EXTERNAL_MODULE_83__, __WEBPACK_EXTERNAL_MODULE_109__, __WEBPACK_EXTERNAL_MODULE_110__, __WEBPACK_EXTERNAL_MODULE_111__, __WEBPACK_EXTERNAL_MODULE_137__, __WEBPACK_EXTERNAL_MODULE_139__, __WEBPACK_EXTERNAL_MODULE_143__, __WEBPACK_EXTERNAL_MODULE_144__, __WEBPACK_EXTERNAL_MODULE_157__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(63);


/***/ }),
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FluxContainer = exports.ReduceStore = exports.AsyncState = exports.DataNames = exports.ActionTypesCommon = exports.translation = exports.detectIE = exports.warning = exports.debounce = exports.loadModuleByClassName = exports.amdDefine = exports.amdRequire = exports.deepMerge = exports.deepEqual = exports.equalArray = exports.shallowEqual = exports.FormDataUtil = exports.ApiUtil = exports.RoleUtil = exports.DataUtil = exports.BoolUtil = exports.UidUtil = exports.AmdRequireComponent = exports.DataLinkContainer = exports.ContextContainer = exports.PdfViewer = exports.Header = exports.WYSIWYGEditor = exports.FaIcon = exports.Title = exports.LiferayFormComponent = exports.FlagComponent = exports.flagHOC = exports.DraggableList = exports.ScrollableDataListRV = exports.ScrollableDataList = exports.ConfirmFormContainer = exports.wrapWithCommonFormContainer = exports.wrapWithFormContainer = exports.PluginComponent = exports.PortletComponent = exports.ValidationMessage = exports.TimeSeriesRemoteDataStore = exports.DEFAULT_DATA_LIST = exports.DEFAULT_DATA_ITEM = exports.isAttachedList = exports.isList = exports.RemoteDataStore = exports.ClassRemoteDataStore = exports.ComputedQueryParamsDataStore = exports.ConfigStore = exports.RemoteDataActions = exports.ConfigActions = exports.FormActions = exports.AppContext = exports.imageAvailable = exports.FormValidationUtil = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _formValidationUtil = __webpack_require__(64);
	
	Object.defineProperty(exports, 'FormValidationUtil', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_formValidationUtil).default;
	    }
	});
	
	var _imageAvailable = __webpack_require__(65);
	
	Object.defineProperty(exports, 'imageAvailable', {
	    enumerable: true,
	    get: function get() {
	        return _imageAvailable.imageAvailable;
	    }
	});
	
	var _FormActions = __webpack_require__(66);
	
	Object.defineProperty(exports, 'FormActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FormActions).default;
	    }
	});
	
	var _ConfigActions = __webpack_require__(81);
	
	Object.defineProperty(exports, 'ConfigActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ConfigActions).default;
	    }
	});
	
	var _RemoteDataActions = __webpack_require__(76);
	
	Object.defineProperty(exports, 'RemoteDataActions', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RemoteDataActions).default;
	    }
	});
	
	var _ConfigStore = __webpack_require__(85);
	
	Object.defineProperty(exports, 'ConfigStore', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ConfigStore).default;
	    }
	});
	
	var _ComputedQueryParamsDataStore = __webpack_require__(97);
	
	Object.defineProperty(exports, 'ComputedQueryParamsDataStore', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ComputedQueryParamsDataStore).default;
	    }
	});
	
	var _ClassRemoteDataStore = __webpack_require__(102);
	
	Object.defineProperty(exports, 'ClassRemoteDataStore', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ClassRemoteDataStore).default;
	    }
	});
	
	var _RemoteDataStore = __webpack_require__(98);
	
	Object.defineProperty(exports, 'RemoteDataStore', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_RemoteDataStore).default;
	    }
	});
	Object.defineProperty(exports, 'isList', {
	    enumerable: true,
	    get: function get() {
	        return _RemoteDataStore.isList;
	    }
	});
	Object.defineProperty(exports, 'isAttachedList', {
	    enumerable: true,
	    get: function get() {
	        return _RemoteDataStore.isAttachedList;
	    }
	});
	Object.defineProperty(exports, 'DEFAULT_DATA_ITEM', {
	    enumerable: true,
	    get: function get() {
	        return _RemoteDataStore.DEFAULT_DATA_ITEM;
	    }
	});
	Object.defineProperty(exports, 'DEFAULT_DATA_LIST', {
	    enumerable: true,
	    get: function get() {
	        return _RemoteDataStore.DEFAULT_DATA_LIST;
	    }
	});
	
	var _TimeSeriesRemoteDataStore = __webpack_require__(103);
	
	Object.defineProperty(exports, 'TimeSeriesRemoteDataStore', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_TimeSeriesRemoteDataStore).default;
	    }
	});
	
	var _StoreFactory = __webpack_require__(104);
	
	Object.keys(_StoreFactory).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _StoreFactory[key];
	        }
	    });
	});
	
	var _ValidationMessage = __webpack_require__(108);
	
	Object.defineProperty(exports, 'ValidationMessage', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ValidationMessage).default;
	    }
	});
	
	var _PortletComponent = __webpack_require__(112);
	
	Object.defineProperty(exports, 'PortletComponent', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_PortletComponent).default;
	    }
	});
	
	var _PluginComponent = __webpack_require__(114);
	
	Object.defineProperty(exports, 'PluginComponent', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_PluginComponent).default;
	    }
	});
	
	var _FormContainer = __webpack_require__(116);
	
	Object.defineProperty(exports, 'wrapWithFormContainer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FormContainer).default;
	    }
	});
	
	var _CommonFormContainer = __webpack_require__(117);
	
	Object.defineProperty(exports, 'wrapWithCommonFormContainer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_CommonFormContainer).default;
	    }
	});
	
	var _ConfirmFormContainer = __webpack_require__(124);
	
	Object.defineProperty(exports, 'ConfirmFormContainer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ConfirmFormContainer).default;
	    }
	});
	
	var _ScrollableDataList = __webpack_require__(126);
	
	Object.defineProperty(exports, 'ScrollableDataList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ScrollableDataList).default;
	    }
	});
	
	var _ScrollableDataListRV = __webpack_require__(136);
	
	Object.defineProperty(exports, 'ScrollableDataListRV', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ScrollableDataListRV).default;
	    }
	});
	
	var _DraggableList = __webpack_require__(138);
	
	Object.defineProperty(exports, 'DraggableList', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DraggableList).default;
	    }
	});
	
	var _FlagHOC = __webpack_require__(128);
	
	Object.defineProperty(exports, 'flagHOC', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FlagHOC).default;
	    }
	});
	Object.defineProperty(exports, 'FlagComponent', {
	    enumerable: true,
	    get: function get() {
	        return _FlagHOC.FlagComponent;
	    }
	});
	
	var _LiferayFormComponent = __webpack_require__(140);
	
	Object.defineProperty(exports, 'LiferayFormComponent', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_LiferayFormComponent).default;
	    }
	});
	
	var _CustomModalComponents = __webpack_require__(118);
	
	Object.keys(_CustomModalComponents).forEach(function (key) {
	    if (key === "default" || key === "__esModule") return;
	    Object.defineProperty(exports, key, {
	        enumerable: true,
	        get: function get() {
	            return _CustomModalComponents[key];
	        }
	    });
	});
	
	var _Title = __webpack_require__(125);
	
	Object.defineProperty(exports, 'Title', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_Title).default;
	    }
	});
	
	var _FaIcon = __webpack_require__(141);
	
	Object.defineProperty(exports, 'FaIcon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_FaIcon).default;
	    }
	});
	
	var _WYSIWYGEditor = __webpack_require__(142);
	
	Object.defineProperty(exports, 'WYSIWYGEditor', {
	    enumerable: true,
	    get: function get() {
	        return _WYSIWYGEditor.WYSIWYGEditor;
	    }
	});
	
	var _Header = __webpack_require__(147);
	
	Object.defineProperty(exports, 'Header', {
	    enumerable: true,
	    get: function get() {
	        return _Header.Header;
	    }
	});
	
	var _PdfViewer = __webpack_require__(150);
	
	Object.defineProperty(exports, 'PdfViewer', {
	    enumerable: true,
	    get: function get() {
	        return _PdfViewer.PdfViewer;
	    }
	});
	
	var _ContextContainer = __webpack_require__(151);
	
	Object.defineProperty(exports, 'ContextContainer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ContextContainer).default;
	    }
	});
	
	var _DataLinkContainer = __webpack_require__(154);
	
	Object.defineProperty(exports, 'DataLinkContainer', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DataLinkContainer).default;
	    }
	});
	
	var _amdUtils = __webpack_require__(115);
	
	Object.defineProperty(exports, 'AmdRequireComponent', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_amdUtils).default;
	    }
	});
	
	var _translation = __webpack_require__(123);
	
	Object.defineProperty(exports, 'translation', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_translation).default;
	    }
	});
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	Object.defineProperty(exports, 'ActionTypesCommon', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_ActionTypesCommon).default;
	    }
	});
	
	var _DataNames = __webpack_require__(159);
	
	Object.defineProperty(exports, 'DataNames', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_DataNames).default;
	    }
	});
	
	var _AsyncState = __webpack_require__(72);
	
	Object.defineProperty(exports, 'AsyncState', {
	    enumerable: true,
	    get: function get() {
	        return _interopRequireDefault(_AsyncState).default;
	    }
	});
	
	var _detectIE = __webpack_require__(160);
	
	var _detectIE2 = _interopRequireDefault(_detectIE);
	
	__webpack_require__(161);
	
	var _appContext = __webpack_require__(67);
	
	__webpack_require__(162);
	
	var _uidUtil = __webpack_require__(100);
	
	var UidUtil = _interopRequireWildcard(_uidUtil);
	
	var _boolUtil = __webpack_require__(163);
	
	var BoolUtil = _interopRequireWildcard(_boolUtil);
	
	var _dataUtil = __webpack_require__(134);
	
	var DataUtil = _interopRequireWildcard(_dataUtil);
	
	var _apiUtil = __webpack_require__(77);
	
	var ApiUtil = _interopRequireWildcard(_apiUtil);
	
	var _roleUtil = __webpack_require__(164);
	
	var RoleUtil = _interopRequireWildcard(_roleUtil);
	
	var _formDataUtil = __webpack_require__(165);
	
	var FormDataUtil = _interopRequireWildcard(_formDataUtil);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _deepEqual = __webpack_require__(79);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _deepMerge = __webpack_require__(101);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _debounce = __webpack_require__(135);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _FluxReduceStore = __webpack_require__(87);
	
	var _FluxReduceStore2 = _interopRequireDefault(_FluxReduceStore);
	
	var _FluxContainer = __webpack_require__(155);
	
	var _FluxContainer2 = _interopRequireDefault(_FluxContainer);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _reactBootstrap2 = _interopRequireDefault(_reactBootstrap);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	if (false) {
	    console.warn('############ ***************** ####################');
	    console.warn('############ ***************** ####################');
	    console.warn('############ DEVELOPMENT BUILD ####################');
	    console.warn('############ ***************** ####################');
	    console.warn('############ ***************** ####################');
	}
	window.__DEBUG__ = localStorage.REACT_WEB_DEBUG;
	window.LOGS = _extends({
	    DISPATCHER: false
	}, localStorage.LOGS);
	
	if (__DEBUG__) {
	    console.warn('############  __DEBUG__ MODE   ####################');
	}
	
	//Utils
	exports.AppContext = _appContext.AppContext;
	
	// Actions
	
	if (__DEBUG__) {
	    // if (!(detectIE() <= 11)) AsyncListComponent();
	}
	
	_appContext.AppContext.registerBundle({
	    webApis: {},
	    contextElements: {}
	});
	
	// Components
	exports.UidUtil = UidUtil;
	exports.BoolUtil = BoolUtil;
	exports.DataUtil = DataUtil;
	exports.RoleUtil = RoleUtil;
	exports.ApiUtil = ApiUtil;
	exports.FormDataUtil = FormDataUtil;
	exports.shallowEqual = _shallowEqual2.default;
	exports.equalArray = _shallowEqual.equalArray;
	exports.deepEqual = _deepEqual2.default;
	exports.deepMerge = _deepMerge2.default;
	exports.amdRequire = _amdUtils.amdRequire;
	exports.amdDefine = _amdUtils.amdDefine;
	exports.loadModuleByClassName = _amdUtils.loadModuleByClassName;
	exports.debounce = _debounce2.default;
	exports.warning = _warning2.default;
	exports.detectIE = _detectIE2.default;
	exports.ReduceStore = _FluxReduceStore2.default;
	exports.FluxContainer = _FluxContainer2.default;
	
	/*
	For JournalListWidget special style 'selection-on' : 'selection-off' -> better use react-bootstrap ToogleButton*/
	
	console.info('UTILS', _reactBootstrap.utils, _reactBootstrap2.default);

/***/ }),
/* 64 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 23.08.2018
	 * Copyright: xdot GmbH 2018
	 */
	
	var isFormValid = function isFormValid(formValidation) {
	    var formValid = true;
	    if (formValidation) {
	        Object.keys(formValidation).forEach(function (propName) {
	            if (formValidation[propName]) {
	                formValid = false;
	            }
	        });
	    }
	    return formValid;
	};
	
	exports.default = {
	    isFormValid: isFormValid
	};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * User: n.gorte
	 * Date: 11.04.2019
	 * Time: 16:59
	 */
	'use strict';
	
	exports.__esModule = true;
	var imageAvailable = exports.imageAvailable = function imageAvailable(url) {
	  return new Promise(function (resolve, reject) {
	    var img = document.createElement('img');
	    img.onload = resolve;
	    img.onerror = reject;
	    img.src = url;
	  });
	};

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Hibbeler on 07.01.2016.
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	var _appContext = __webpack_require__(67);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    startEditFormItem: function startEditFormItem(formId) {
	        var item = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.START_EDIT_IN_FORM,
	            payload: item,
	            meta: {
	                formId: formId
	            }
	        });
	    },
	    stopEditFormItem: function stopEditFormItem(formId) {
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.END_EDIT_IN_FORM,
	            meta: {
	                formId: formId
	            }
	        });
	    },
	    changedEditFormItem: function changedEditFormItem(formId, item, validation) {
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.EDIT_IN_FORM,
	            payload: {
	                item: item,
	                validation: validation
	            },
	            meta: {
	                formId: formId
	
	            }
	        });
	    },
	    resetForm: function resetForm(formId) {
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.RESET_FORM,
	            meta: {
	                formId: formId
	            }
	        });
	    },
	    submitForm: function submitForm(apiFn, item, formId) {
	        var closeForm = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	        var options = arguments[4];
	
	        var o = options || {};
	        o.meta = _extends({}, o.meta, { formId: formId, closeForm: closeForm });
	
	        return _appContext.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypesCommon2.default.SUBMIT_FORM_ASYNC, apiFn, item, o);
	    }
	};

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 13.11.2015
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.AppContext = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _LwrDispatcher = __webpack_require__(68);
	
	var _LwrDispatcher2 = _interopRequireDefault(_LwrDispatcher);
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var AppContextClass = function () {
	    function AppContextClass() {
	        _classCallCheck(this, AppContextClass);
	
	        this.DEFAULT_LIST_SIZE = 25;
	        this.stores = [];
	        this.dispatcher = new _LwrDispatcher2.default();
	        this.webApis = {};
	        this.websocketUnsupported = false;
	        this.contextElements = {};
	        if (window.app_context_DO_NOT_USE) {
	            console.error('Second app context!', window.app_context_DO_NOT_USE);
	        }
	        window.app_context_DO_NOT_USE = this;
	    }
	
	    AppContextClass.prototype.registerBundle = function registerBundle(bundle) {
	        var _this = this;
	
	        console.log('Register bundle', bundle);
	        this.webApis = _extends({}, this.webApis, bundle.webApis);
	
	        if (bundle.contextElements) {
	            Object.keys(bundle.contextElements).forEach(function (key) {
	                _this.addContextElement(bundle.contextElements[key], key);
	            });
	        }
	    };
	
	    AppContextClass.prototype.createStore = function createStore(StoreClass) {
	        var store = new StoreClass(this.getDispatcher());
	        this.stores.push(store);
	        return store;
	    };
	
	    AppContextClass.prototype.getStores = function getStores() {
	        return this.stores;
	    };
	
	    AppContextClass.prototype.getDispatcher = function getDispatcher() {
	        return this.dispatcher;
	    };
	
	    AppContextClass.prototype.getWebApis = function getWebApis() {
	        return this.webApis;
	    };
	
	    AppContextClass.prototype.addContextElement = function addContextElement(element, divId) {
	        var contextEl = document.getElementById(divId);
	        if (!contextEl) {
	            contextEl = document.createElement('div');
	            contextEl.id = divId;
	            document.body.appendChild(contextEl);
	        }
	        //ToDO maybe we can implement this with Portals?
	        return _reactDom2.default.render(element, contextEl);
	    };
	
	    AppContextClass.prototype.getScopeGroupId = function getScopeGroupId() {
	        return parseInt(Liferay.ThemeDisplay.getScopeGroupId());
	    };
	
	    AppContextClass.prototype.getUserId = function getUserId() {
	        return parseInt(Liferay.ThemeDisplay.getUserId());
	    };
	
	    AppContextClass.prototype.setWebsocketUnsupported = function setWebsocketUnsupported(val) {
	        this.websocketUnsupported = val;
	    };
	
	    AppContextClass.prototype.getWebsocketUnsupported = function getWebsocketUnsupported() {
	        return this.websocketUnsupported;
	    };
	
	    AppContextClass.prototype.setWebsocketConnected = function setWebsocketConnected(isWsActiveFktn) {
	        this.isWsActiveFktn = isWsActiveFktn;
	    };
	
	    AppContextClass.prototype.isWebsocketConnected = function isWebsocketConnected() {
	        return this.isWsActiveFktn && this.isWsActiveFktn();
	    };
	
	    return AppContextClass;
	}();
	
	var AppContext = exports.AppContext = new AppContextClass();

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isError = isError;
	
	var _flux = __webpack_require__(69);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	var _DataUpdateHandler = __webpack_require__(74);
	
	var _RemoteDataActions = __webpack_require__(76);
	
	var _RemoteDataActions2 = _interopRequireDefault(_RemoteDataActions);
	
	var _deepEqual = __webpack_require__(79);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 30.09.2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var isInRemoteDataHandling = false;
	
	var n = 0;
	var asyncKey = function asyncKey() {
	    return 'ASY:' + n++;
	};
	
	var waitingQueue = [];
	
	function checkAsyncDone(key) {
	    if (__DEBUG__) {
	        (0, _RemoteDataActions.activeStores)().forEach(function (store) {
	            store.getRemoteState && Object.keys(store.getRemoteState()).map(function (name) {
	                return store.getRemoteState()[name];
	            }).forEach(function (d) {
	                if (d._asyncKey === key && d._loading) {
	                    console.error('Async: ' + key + ' done but data is', d);
	                    debugger;
	                }
	            });
	        });
	    }
	}
	
	/**
	 *
	 * Custom Dispatcher extended for the Liferay-Widget-React-Framework (Lwr-Framework).
	 * Implements Actions of type: https://github.com/acdlite/flux-standard-action
	 * Implements dispatches and asnyc dispatches for actions including callbacks, etc.
	 *
	 */
	
	var LwrDispatcher = function (_Dispatcher) {
	    _inherits(LwrDispatcher, _Dispatcher);
	
	    /*
	     * @ref https://github.com/acdlite/flux-standard-action
	     *
	     * ## Actions
	     *
	     * An action MUST
	     * - be a plain JavaScript object.
	     * - have a `type` property.
	     *
	     * An action MAY
	     * - have a `error` property.
	     * - have a `payload` property.
	     * - have a `meta` property.
	     *
	     * An action MUST NOT include properties other than `type`, `payload`, and `error`, and `meta`.
	     *
	     * ### `type`
	     *
	     * The `type` of an action identifies to the consumer the nature of the action that has occurred.
	     * Two actions with the same `type` MUST be strictly equivalent (using `===`).
	     * By convention, `type` is usually string constant or a Symbol.
	     *
	     * ### `payload`
	     *
	     * The optional `payload` property MAY be any type of value.
	     * It represents the payload of the action.
	     * Any information about the action that is not the `type` or status of the action should be part of the `payload` field.
	     *
	     * By convention, if `error` is `true`, the `payload` SHOULD be an error object.
	     * This is akin to rejecting a promise with an error object.
	     *
	     * ### `error`
	     *
	     * The optional `error` property MAY be set to `true` if the action represents an error.
	     *
	     * An action whose `error` is true is analogous to a rejected Promise.
	     * By convention, the `payload` SHOULD be an error object.
	     *
	     * If `error` has any other value besides `true`,
	     * including `undefined` and `null`, the action MUST NOT be interpreted as an error.
	     *
	     * ### `meta`
	     *
	     * The optional `meta` property MAY be any type of value.
	     * It is intended for any extra information that is not part of the payload.
	     *
	     */
	
	    function LwrDispatcher() {
	        _classCallCheck(this, LwrDispatcher);
	
	        var _this = _possibleConstructorReturn(this, _Dispatcher.call(this));
	
	        _this._afterDispatchListener = null;
	        return _this;
	    }
	
	    /**
	     * @param type
	     * @param fn
	     * @param data
	     * @param {Object} options
	     * @param options.meta the action meta
	     * @param options.payload the action.payload
	     * @param options.beforeSuccess
	     * @param options.afterSuccess
	     * @param options.beforeError
	     * @param options.afterError
	     * @returns {*}
	     */
	
	
	    LwrDispatcher.prototype.dispatchAsyncOperation = function dispatchAsyncOperation(type, fn, data, options) {
	        var _this2 = this,
	            _arguments = arguments;
	
	        if (this.isDispatching()) {
	            console.warn("Dispatch Async until dispatch ");
	            waitingQueue.push({ asyncDispatch: true, args: arguments });
	            return;
	        }
	
	        var key = asyncKey();
	
	        var toAction = function toAction(asyncState) {
	            var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	            return {
	                type: type,
	                payload: _extends({}, payload, options.payload),
	                meta: _extends({
	                    asyncState: asyncState,
	                    key: key
	                }, options.meta)
	            };
	        };
	
	        var handler = function handler(asyncState, callbackName, result, meta) {
	            if (_this2.isDispatching()) {
	                console.error('Error in async-handler with arguments', _arguments);
	            }
	
	            var action = toAction(asyncState, result);
	            if (asyncState === _AsyncState2.default.ERROR) {
	                console.warn(result);
	                action = asError(action, result);
	            }
	            action = options['before' + callbackName] && options['before' + callbackName](action) || action;
	            _this2.dispatch(action);
	            options['after' + callbackName] && options['after' + callbackName](action);
	            (0, _DataUpdateHandler.handleDataUpdate)(meta);
	        };
	
	        if (fn) {
	            this.dispatch(toAction(_AsyncState2.default.REQUESTED, data));
	            var apiCall = fn(data);
	            (apiCall.promise || apiCall).then(function (result) {
	                handler(_AsyncState2.default.SUCCESS, 'Success', result, apiCall.meta);
	                checkAsyncDone(key);
	            }).catch(function (result) {
	                console.error(result);
	                handler(_AsyncState2.default.ERROR, 'Error', result, apiCall.meta);
	                checkAsyncDone(key);
	            });
	        } else {
	            console.error('API METHOD expected!');
	            handler(_AsyncState2.default.ERROR, 'Error');
	            checkAsyncDone(key);
	        }
	
	        return key;
	    };
	
	    LwrDispatcher.prototype.dispatch = function dispatch(payload) {
	        if (this.isDispatching()) {
	            var idx = waitingQueue.findIndex(function (p) {
	                return (0, _deepEqual2.default)(p, payload);
	            });
	            if (idx < 0) {
	                console.warn("Dispatch until dispatch ");
	                waitingQueue.push(payload);
	            } else {
	                console.warn("Dispatch until dispatch (existing payload)");
	            }
	            return;
	        }
	        if (!isFSA(payload)) {
	            console.warn('DISPATCH NO FSA', payload);
	        }
	        try {
	            if (LOGS.DISPATCHER) {
	                if (isDataAction(payload)) {
	                    console.group('DISPATCH', payload, payload && payload.meta && payload.meta.name);
	                } else {
	                    console.group('DISPATCH', payload);
	                }
	            }
	            _Dispatcher.prototype.dispatch.call(this, payload);
	            if (this._afterDispatchListener) {
	                this._afterDispatchListener();
	            }
	            this.handleRemoteData();
	        } finally {
	            console.groupEnd();
	        }
	        this.handleQueue();
	    };
	
	    LwrDispatcher.prototype.handleQueue = function handleQueue() {
	        var _this3 = this;
	
	        if (waitingQueue.length > 0) {
	            if (waitingQueue.length > 1) {
	                console.error('Large queue ', waitingQueue);
	            }
	            var waiting = waitingQueue;
	            waitingQueue = [];
	            setTimeout(function () {
	                for (var i = waiting.length - 1; i >= 0; i--) {
	                    var p = waiting[i];
	                    if (p.asyncDispatch) {
	                        console.warn("Dispatch queued async payload ", p.args);
	                        _this3.dispatchAsyncOperation.apply(_this3, p.args);
	                    } else {
	                        console.warn("Dispatch queued payload ", p);
	                        _this3.dispatch(p);
	                    }
	                }
	            });
	        }
	    };
	
	    LwrDispatcher.prototype.handleRemoteData = function handleRemoteData() {
	        if (!isInRemoteDataHandling) {
	            try {
	                isInRemoteDataHandling = true;
	                _RemoteDataActions2.default.refreshRemoteData();
	            } catch (e) {
	                console.error(e);
	            } finally {
	                isInRemoteDataHandling = false;
	            }
	        }
	    };
	
	    LwrDispatcher.prototype.isDispatching = function isDispatching() {
	        if (this._isDispatching && typeof this._isDispatching === 'function') {
	            return this._isDispatching();
	        }
	        return this._isDispatching;
	    };
	
	    LwrDispatcher.prototype.registerAfterDispatchListener = function registerAfterDispatchListener(listener) {
	        this._afterDispatchListener = listener;
	    };
	
	    return LwrDispatcher;
	}(_flux.Dispatcher);
	
	exports.default = LwrDispatcher;
	
	
	var validKeys = ['type', 'payload', 'error', 'meta'];
	
	function isValidKey(key) {
	    return validKeys.indexOf(key) > -1;
	}
	
	function isFSA(action) {
	    return isPlainObject(action) && typeof action.type !== 'undefined' && Object.keys(action).every(isValidKey);
	}
	
	function isDataAction(action) {
	    return action.type.indexOf('DATA_') === 0;
	}
	
	function isError(action) {
	    return action.error === true;
	}
	
	function asError(action, result) {
	    action.error = true;
	    if (result && result.message || action.payload.error) {
	        action.payload.error = { message: result.message || result.error.message };
	    }
	    return action;
	}
	
	//from lodash
	function isPlainObject(value) {
	    if (!(!!value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object')) {
	        return false;
	    }
	    var proto = Object.prototype;
	    if (typeof value.constructor === 'function') {
	        proto = Object.getPrototypeOf(value);
	    }
	    if (proto === null) {
	        return true;
	    }
	    var Ctor = proto.constructor;
	    return typeof Ctor === 'function' && Ctor instanceof Ctor && Function.prototype.toString.call(Ctor) === Function.prototype.toString.call(Object);
	}

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	module.exports.Dispatcher = __webpack_require__(70);


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Dispatcher
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var invariant = __webpack_require__(71);
	var _prefix = 'ID_';
	
	/**
	 * Dispatcher is used to broadcast payloads to registered callbacks. This is
	 * different from generic pub-sub systems in two ways:
	 *
	 *   1) Callbacks are not subscribed to particular events. Every payload is
	 *      dispatched to every registered callback.
	 *   2) Callbacks can be deferred in whole or part until other callbacks have
	 *      been executed.
	 *
	 * For example, consider this hypothetical flight destination form, which
	 * selects a default city when a country is selected:
	 *
	 *   var flightDispatcher = new Dispatcher();
	 *
	 *   // Keeps track of which country is selected
	 *   var CountryStore = {country: null};
	 *
	 *   // Keeps track of which city is selected
	 *   var CityStore = {city: null};
	 *
	 *   // Keeps track of the base flight price of the selected city
	 *   var FlightPriceStore = {price: null}
	 *
	 * When a user changes the selected city, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'city-update',
	 *     selectedCity: 'paris'
	 *   });
	 *
	 * This payload is digested by `CityStore`:
	 *
	 *   flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'city-update') {
	 *       CityStore.city = payload.selectedCity;
	 *     }
	 *   });
	 *
	 * When the user selects a country, we dispatch the payload:
	 *
	 *   flightDispatcher.dispatch({
	 *     actionType: 'country-update',
	 *     selectedCountry: 'australia'
	 *   });
	 *
	 * This payload is digested by both stores:
	 *
	 *   CountryStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       CountryStore.country = payload.selectedCountry;
	 *     }
	 *   });
	 *
	 * When the callback to update `CountryStore` is registered, we save a reference
	 * to the returned token. Using this token with `waitFor()`, we can guarantee
	 * that `CountryStore` is updated before the callback that updates `CityStore`
	 * needs to query its data.
	 *
	 *   CityStore.dispatchToken = flightDispatcher.register(function(payload) {
	 *     if (payload.actionType === 'country-update') {
	 *       // `CountryStore.country` may not be updated.
	 *       flightDispatcher.waitFor([CountryStore.dispatchToken]);
	 *       // `CountryStore.country` is now guaranteed to be updated.
	 *
	 *       // Select the default city for the new country
	 *       CityStore.city = getDefaultCityForCountry(CountryStore.country);
	 *     }
	 *   });
	 *
	 * The usage of `waitFor()` can be chained, for example:
	 *
	 *   FlightPriceStore.dispatchToken =
	 *     flightDispatcher.register(function(payload) {
	 *       switch (payload.actionType) {
	 *         case 'country-update':
	 *         case 'city-update':
	 *           flightDispatcher.waitFor([CityStore.dispatchToken]);
	 *           FlightPriceStore.price =
	 *             getFlightPriceStore(CountryStore.country, CityStore.city);
	 *           break;
	 *     }
	 *   });
	 *
	 * The `country-update` payload will be guaranteed to invoke the stores'
	 * registered callbacks in order: `CountryStore`, `CityStore`, then
	 * `FlightPriceStore`.
	 */
	var Dispatcher = /*#__PURE__*/function () {
	  function Dispatcher() {
	    _defineProperty(this, "_callbacks", void 0);
	    _defineProperty(this, "_isDispatching", void 0);
	    _defineProperty(this, "_isHandled", void 0);
	    _defineProperty(this, "_isPending", void 0);
	    _defineProperty(this, "_lastID", void 0);
	    _defineProperty(this, "_pendingPayload", void 0);
	    this._callbacks = {};
	    this._isDispatching = false;
	    this._isHandled = {};
	    this._isPending = {};
	    this._lastID = 1;
	  }
	
	  /**
	   * Registers a callback to be invoked with every dispatched payload. Returns
	   * a token that can be used with `waitFor()`.
	   */
	  var _proto = Dispatcher.prototype;
	  _proto.register = function register(callback) {
	    var id = _prefix + this._lastID++;
	    this._callbacks[id] = callback;
	    return id;
	  }
	
	  /**
	   * Removes a callback based on its token.
	   */;
	  _proto.unregister = function unregister(id) {
	    !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.unregister(...): `%s` does not map to a registered callback.', id) : invariant(false) : void 0;
	    delete this._callbacks[id];
	  }
	
	  /**
	   * Waits for the callbacks specified to be invoked before continuing execution
	   * of the current callback. This method should only be used by a callback in
	   * response to a dispatched payload.
	   */;
	  _proto.waitFor = function waitFor(ids) {
	    !this._isDispatching ?  false ? invariant(false, 'Dispatcher.waitFor(...): Must be invoked while dispatching.') : invariant(false) : void 0;
	    for (var ii = 0; ii < ids.length; ii++) {
	      var id = ids[ii];
	      if (this._isPending[id]) {
	        !this._isHandled[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): Circular dependency detected while ' + 'waiting for `%s`.', id) : invariant(false) : void 0;
	        continue;
	      }
	      !this._callbacks[id] ?  false ? invariant(false, 'Dispatcher.waitFor(...): `%s` does not map to a registered callback.', id) : invariant(false) : void 0;
	      this._invokeCallback(id);
	    }
	  }
	
	  /**
	   * Dispatches a payload to all registered callbacks.
	   */;
	  _proto.dispatch = function dispatch(payload) {
	    !!this._isDispatching ?  false ? invariant(false, 'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.') : invariant(false) : void 0;
	    this._startDispatching(payload);
	    try {
	      for (var id in this._callbacks) {
	        if (this._isPending[id]) {
	          continue;
	        }
	        this._invokeCallback(id);
	      }
	    } finally {
	      this._stopDispatching();
	    }
	  }
	
	  /**
	   * Is this Dispatcher currently dispatching.
	   */;
	  _proto.isDispatching = function isDispatching() {
	    return this._isDispatching;
	  }
	
	  /**
	   * Call the callback stored with the given id. Also do some internal
	   * bookkeeping.
	   *
	   * @internal
	   */;
	  _proto._invokeCallback = function _invokeCallback(id) {
	    this._isPending[id] = true;
	    this._callbacks[id](this._pendingPayload);
	    this._isHandled[id] = true;
	  }
	
	  /**
	   * Set up bookkeeping needed when dispatching.
	   *
	   * @internal
	   */;
	  _proto._startDispatching = function _startDispatching(payload) {
	    for (var id in this._callbacks) {
	      this._isPending[id] = false;
	      this._isHandled[id] = false;
	    }
	    this._pendingPayload = payload;
	    this._isDispatching = true;
	  }
	
	  /**
	   * Clear bookkeeping used for dispatching.
	   *
	   * @internal
	   */;
	  _proto._stopDispatching = function _stopDispatching() {
	    delete this._pendingPayload;
	    this._isDispatching = false;
	  };
	  return Dispatcher;
	}();
	module.exports = Dispatcher;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	var validateFormat =  false ? function (format) {
	  if (format === undefined) {
	    throw new Error('invariant(...): Second argument must be a string.');
	  }
	} : function (format) {};
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments to provide
	 * information about what broke and what you were expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant will
	 * remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format) {
	  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return String(args[argIndex++]);
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // Skip invariant's own stack frame.
	
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(73);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	
	  REQUESTED: null,
	  SUCCESS: null,
	  ERROR: null
	
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 22.10.2015
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 73 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_73__;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                   * User: c.buehler on 14.11.2016
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	exports.handleDataUpdate = handleDataUpdate;
	
	var _appContext = __webpack_require__(67);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function handleDataUpdate(meta) {
	    if (!_appContext.AppContext.isWebsocketConnected() && meta && meta.className) {
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.DATA_UPDATE_MESSAGE,
	            payload: _extends({}, meta)
	        });
	    }
	}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(73);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	
	    DATA_REMOVE: null,
	    DATA_LIST_INIT: null,
	    DATA_ITEM_INIT: null,
	    DATA_INVALIDATE: null,
	
	    DATA_REQUESTED: null,
	    DATA_SUCCESS: null,
	    DATA_ERROR: null,
	
	    CREATE_ASYNC: null,
	    UPDATE_ASYNC: null,
	    DELETE_ASYNC: null,
	
	    DATA_ASYNC: null,
	
	    RESET_FORM: null,
	    EDIT_IN_FORM: null,
	    START_EDIT_IN_FORM: null,
	    END_EDIT_IN_FORM: null,
	    SUBMIT_FORM_ASYNC: null,
	
	    MORE_ITEMS: null,
	
	    DATA_UPDATE_MESSAGE: null,
	
	    CONFIG_LOAD_ASYNC: null,
	    CONFIG_UPDATE_ASYNC: null,
	    CONFIG_SET: null,
	    CONFIG_LOCAL_UPDATE: null,
	
	    PAGE_SELECTED: null
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 22.10.2015
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Carsten Hibbeler on 07.01.2016.
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                   */
	
	exports.activeStores = activeStores;
	
	var _appContext = __webpack_require__(67);
	
	var _apiUtil = __webpack_require__(77);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function requestData(data) {
	    try {
	        //new style is to use api for api and method
	        var api = data.api,
	            apiMethod = data.apiMethod,
	            s = api && api.split('.');
	
	        if (s && s.length > 1) {
	            api = s[0];
	            apiMethod = s[1];
	        }
	        var apiFktn = _appContext.AppContext.getWebApis()[api] && _appContext.AppContext.getWebApis()[api][apiMethod];
	
	        if (typeof apiFktn !== 'function') {
	            console.error(apiFktn + (' apiFktn: ' + api + '/' + apiMethod + ' not found! ') + JSON.stringify(_appContext.AppContext.getWebApis(), null, 3) + ' \n More: ' + JSON.stringify(data, null, 3));
	            return;
	        }
	
	        //we call the api with the query a parameter
	        var callApiWithQuery = function callApiWithQuery(data) {
	            return apiFktn(data.query, data);
	        };
	
	        _appContext.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypesCommon2.default.DATA_ASYNC, callApiWithQuery, data, {
	            meta: {
	                className: data.className,
	                name: data.name
	            }
	        });
	    } catch (e) {
	        console.error('requestData', data, e);
	    }
	}
	
	function activeStores() {
	    var stores = _appContext.AppContext.getStores();
	    return Object.keys(stores).filter(function (key) {
	        return !stores[key].isActive || stores[key].isActive();
	    }).map(function (key) {
	        return stores[key];
	    });
	}
	
	var isRefreshingRemoteData = false;
	
	exports.default = {
	    refreshRemoteData: function refreshRemoteData() {
	
	        if (!isRefreshingRemoteData) {
	            try {
	                isRefreshingRemoteData = true;
	                var invalidLists = [];
	                activeStores().forEach(function (store) {
	                    return store.getRequiredRemoteDataUpdates && invalidLists.push.apply(invalidLists, store.getRequiredRemoteDataUpdates());
	                });
	                if (invalidLists.length > 0) {
	                    try {
	                        console.groupCollapsed('Request RemoteData:', invalidLists);
	                        invalidLists.forEach(requestData);
	                    } finally {
	                        console.groupEnd();
	                    }
	                }
	            } catch (e) {
	                console.error(e);
	            } finally {
	                isRefreshingRemoteData = false;
	            }
	        }
	    },
	
	
	    /**
	     * payload should look like {className: 'abc', id: 4711}
	     *
	     * We use a very generic method because in the future we possibly want to do something like:
	     * payload: [
	     *  {className: 'abc', id: 4711},
	     *  {className: 'abc', id: 99},
	     *  {className: 'efg', id: 1234}
	     * ]
	     */
	    pageSelected: function pageSelected(className, query, api) {
	        this.dispatchRemoteDataAction(_ActionTypesCommon2.default.PAGE_SELECTED, null, className, query, (0, _apiUtil.apiName)(api));
	    },
	    attachedList: function attachedList(name, className, api, byId, byClassName) {
	        var query = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	
	        return this.list(name, className, _extends({}, query, {
	            byId: byId,
	            byClassName: byClassName
	        }), (0, _apiUtil.apiName)(api));
	    },
	    attachedItem: function attachedItem(name, className, api, byId, byClassName) {
	        var query = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
	
	        return this.item(name, className, _extends({}, query, {
	            byId: byId,
	            byClassName: byClassName
	        }), (0, _apiUtil.apiName)(api));
	    },
	
	
	    //if api and apiMethod are null the default action for class is used
	    list: function list(name, className, query) {
	        var api = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	        (0, _warning2.default)(query, 'todo is empty list init a good idea?');
	        this.dispatchRemoteDataAction(_ActionTypesCommon2.default.DATA_LIST_INIT, name, className, query, (0, _apiUtil.apiName)(api));
	    },
	    item: function item(name, className, query) {
	        var api = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	        (0, _warning2.default)(query, 'todo is empty item init a good idea?');
	        this.dispatchRemoteDataAction(_ActionTypesCommon2.default.DATA_ITEM_INIT, name, className, query, (0, _apiUtil.apiName)(api));
	    },
	    moreItems: function moreItems(name, className, query) {
	        this.dispatchRemoteDataAction(_ActionTypesCommon2.default.MORE_ITEMS, name, className, query);
	    },
	    invalidate: function invalidate(name, className) {
	        this.dispatchRemoteDataAction(_ActionTypesCommon2.default.DATA_INVALIDATE, name, className);
	    },
	    remove: function remove(name, className) {
	        var _this = this;
	
	        if (Array.isArray(name)) {
	            name.forEach(function (n) {
	                return _this.remove(n, className);
	            });
	        } else {
	            this.dispatchRemoteDataAction(_ActionTypesCommon2.default.DATA_REMOVE, name, className);
	        }
	    },
	
	
	    /**
	     * Optimistic inits are supported by passing for Items: {item: {...}} or for Lists: {item: [...], query: {}}.
	     * Optimistic inits are intialized as invalid!
	     *
	     * @param type action type
	     * @param name target list name optional
	     * @param className target className
	     * @param querOrData
	     *      1. query like {id: 3} or {foo: 'bar'}
	     *      2. existing remote data
	     *      3. optimistic inits for Items {item: {id:23, ...}}
	     *      4. optimistic inits for Lists {item: [], query: {...}}
	     * @param api for an api different the default list and get
	     */
	    dispatchRemoteDataAction: function dispatchRemoteDataAction(type, name, className, querOrData /*query or data*/) {
	        var api = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
	
	        var payload = void 0;
	
	        if (querOrData && querOrData.item) {
	            payload = _extends({}, querOrData);
	        } else {
	            if (querOrData) {
	                (0, _warning2.default)(Object.keys(querOrData).length <= 6, 'query seems to be raw item object!');
	            } else if (type !== _ActionTypesCommon2.default.DATA_INVALIDATE && type !== _ActionTypesCommon2.default.DATA_REMOVE) {
	                console.warn('QueryOrData emtpy', querOrData);
	            }
	
	            payload = querOrData ? { query: querOrData } : {};
	        }
	
	        api = (0, _apiUtil.apiName)(api);
	
	        if (payload.api || api) {
	            payload.api = api || payload.api;
	        }
	
	        _appContext.AppContext.getDispatcher().dispatch({
	            type: type,
	            payload: payload,
	            meta: {
	                className: className,
	                name: name
	            }
	        });
	    }
	};

/***/ }),
/* 77 */
/***/ (function(module, exports) {

	/**
	 * Created by Carsten Hibbeler on 22.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.namedApi = namedApi;
	exports.apiName = apiName;
	exports.apiCall = apiCall;
	exports.asUrlCall = asUrlCall;
	var supportFunctionNameRenameing = false;
	try {
	    var supportFn = Object.getOwnPropertyDescriptor(function () {}, 'name');
	    supportFunctionNameRenameing = supportFn && supportFn.configurable;
	} catch (e) {
	    console.error(e);
	}
	
	function namedApi(namespace, api) {
	    try {
	        Object.keys(api).forEach(function (fn) {
	            if (supportFunctionNameRenameing) {
	                Object.defineProperty(api[fn], 'name', {
	                    value: namespace + '.' + fn
	                });
	            }
	            api[fn].__name = namespace + '.' + fn;
	        });
	    } catch (e) {
	        console.error(e);
	    }
	}
	
	function apiName(api) {
	    return api && (api.__name || api);
	}
	
	function apiCall(promise, meta) {
	    return { promise: promise, meta: meta };
	}
	
	function asUrlCall(service, method, methodParms, urlParams) {
	    var url = service + '/' + method + '/';
	
	    for (var property in methodParms) {
	        if (methodParms.hasOwnProperty(property)) {
	            var param = methodParms[property];
	            if (Array.isArray(param)) {
	                url += property + '/' + encodeURIComponent(param, '') + '/';
	            } else if ((typeof param === 'undefined' ? 'undefined' : _typeof(param)) === 'object') {
	                url += property + '/' + JSON.stringify(param, '') + '/';
	            } else {
	                url += property + '/' + param + '/';
	            }
	        }
	    }
	
	    url += '?p_auth=' + Liferay.authToken;
	    if (urlParams && urlParams.length > 0) {
	        url += '&' + urlParams;
	    }
	
	    return url;
	}

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule warning
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function warning() {};
	
	if (false) {
	    console.warn('NODE ENVIRONMENT IS: ', process.env.NODE_ENV);
	    warning = function warning(condition, format) {
	        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	            args[_key - 2] = arguments[_key];
	        }
	
	        if (format === undefined) {
	            throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	        }
	
	        if (format.indexOf('Failed Composite propType: ') === 0) {
	            return; // Ignore CompositeComponent proptype check.
	        }
	
	        if (!condition) {
	            var argIndex = 0;
	            var message = 'Warning: ' + format.replace(/%s/g, function () {
	                return args[argIndex++];
	            });
	            if (typeof console !== 'undefined') {
	                console.error(message);
	            }
	            try {
	                // --- Welcome to debugging React ---
	                // This error was thrown as a convenience so that you can use this stack
	                // to find the callsite that caused this warning to fire.
	                throw new Error(message);
	            } catch (x) {
	                //ignore
	            }
	        }
	    };
	}
	
	module.exports = warning;

/***/ }),
/* 79 */
/***/ (function(module, exports) {

	/**
	 * https://github.com/epoberezkin/fast-deep-equal
	 *
	 */
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	
	module.exports = function deepEqual(a, b) {
	    if (a === b) return true;
	
	    if (a && b && (typeof a === 'undefined' ? 'undefined' : _typeof(a)) == 'object' && (typeof b === 'undefined' ? 'undefined' : _typeof(b)) == 'object') {
	        var arrA = isArray(a),
	            arrB = isArray(b),
	            i,
	            length,
	            key;
	
	        if (arrA && arrB) {
	            length = a.length;
	            if (length != b.length) return false;
	            for (i = length; i-- !== 0;) {
	                if (!deepEqual(a[i], b[i])) return false;
	            }return true;
	        }
	
	        if (arrA != arrB) return false;
	
	        var dateA = a instanceof Date,
	            dateB = b instanceof Date;
	        if (dateA != dateB) return false;
	        if (dateA && dateB) return a.getTime() == b.getTime();
	
	        var regexpA = a instanceof RegExp,
	            regexpB = b instanceof RegExp;
	        if (regexpA != regexpB) return false;
	        if (regexpA && regexpB) return a.toString() == b.toString();
	
	        var keys = keyList(a);
	        length = keys.length;
	
	        if (length !== keyList(b).length) return false;
	
	        for (i = length; i-- !== 0;) {
	            if (!hasProp.call(b, keys[i])) return false;
	        }for (i = length; i-- !== 0;) {
	            key = keys[i];
	            if (!deepEqual(a[key], b[key])) return false;
	        }
	
	        return true;
	    }
	
	    return a !== a && b !== b;
	};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_80__;

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                   * Date: 28.01.2016
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	var _appContext = __webpack_require__(67);
	
	var _ConfigWebApi = __webpack_require__(82);
	
	var _ConfigWebApi2 = _interopRequireDefault(_ConfigWebApi);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    loadConfig: function loadConfig( /*long*/scopeGroupId, /*long*/plid, /*String*/portletId, options) {
	        var params = { scopeGroupId: scopeGroupId, plid: plid, portletId: portletId };
	        options.meta = _extends({}, options.meta, params);
	        return _appContext.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypesCommon2.default.CONFIG_LOAD_ASYNC, _ConfigWebApi2.default.getPortletProperties, params, options);
	    },
	    updateConfig: function updateConfig( /*long*/scopeGroupId, /*long*/plid, /*String*/portletId, config, options) {
	        var params = { scopeGroupId: scopeGroupId, plid: plid, portletId: portletId, properties: config };
	        options.meta = _extends({}, options.meta, params);
	        return _appContext.AppContext.getDispatcher().dispatchAsyncOperation(_ActionTypesCommon2.default.CONFIG_UPDATE_ASYNC, _ConfigWebApi2.default.savePortletProperties, params, options);
	    },
	    setConfig: function setConfig( /*long*/scopeGroupId, /*long*/plid, /*String*/portletId, config, callBack) {
	        var params = { scopeGroupId: scopeGroupId, plid: plid, portletId: portletId, config: config };
	        var result = _appContext.AppContext.getDispatcher().dispatch({
	            type: _ActionTypesCommon2.default.CONFIG_SET,
	            meta: _extends({}, params),
	            payload: _extends({}, config)
	        });
	        callBack && callBack(config);
	        return result;
	    },
	    updateLocalConfig: function updateLocalConfig(key, config) {
	        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        var params = { key: key, properties: config };
	
	        options.meta = _extends({}, options.meta, params);
	        return _appContext.AppContext.getDispatcher().dispatch({
	            'type': _ActionTypesCommon2.default.CONFIG_LOCAL_UPDATE,
	            'payload': params,
	            'meta': _extends({}, options, params)
	        });
	    }
	};

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                   * Date: 28.01.2016
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	var _lwrClient = __webpack_require__(83);
	
	var _portletConfigUtil = __webpack_require__(84);
	
	var liferayWidgetsPortletService = function liferayWidgetsPortletService(m, o) {
	    return _lwrClient.Client.invoke('/liferay_widgets.widget/' + m, o);
	};
	//const liferayWidgetsPortletServiceWithContext = (m, o, c) => Client.invokeWithContext('/liferay_widgets.widget/' + m, o, c);
	
	exports.default = {
	    getPortletProperties: function getPortletProperties(_ref) {
	        var scopeGroupId = _ref.scopeGroupId,
	            plid = _ref.plid,
	            portletId = _ref.portletId;
	
	        return liferayWidgetsPortletService('get-portlet-properties.3', {
	            scopeGroupId: scopeGroupId,
	            plid: plid,
	            portletId: portletId
	        }).then(_portletConfigUtil.parsePortletConfig);
	    },
	    savePortletProperties: function savePortletProperties(_ref2) {
	        var scopeGroupId = _ref2.scopeGroupId,
	            plid = _ref2.plid,
	            portletId = _ref2.portletId,
	            properties = _ref2.properties;
	
	        var p = _extends({}, properties);
	        p && Object.keys(p).forEach(function (key) {
	            var value = p[key];
	            // Portlet properties only allow strings as values.
	            if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
	                try {
	                    p[key] = JSON.stringify(value);
	                } catch (e) {
	                    console.warn('Failed to parse config property ' + key + ': ', value);
	                }
	            }
	        });
	        return liferayWidgetsPortletService('save-portlet-properties.4', {
	            scopeGroupId: scopeGroupId,
	            plid: plid,
	            portletId: portletId,
	            properties: JSON.stringify(p)
	        }).then(_portletConfigUtil.parsePortletConfig);
	    }
	};

/***/ }),
/* 83 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_83__;

/***/ }),
/* 84 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var REGEX = /{*}/i;
	
	var parsePortletConfig = exports.parsePortletConfig = function parsePortletConfig(config) {
	    config && Object.keys(config).forEach(function (key) {
	        var value = config[key];
	        // Portlet properties only allow strings as values. If objects are stored as stringified values, they are parsed here.
	        if (REGEX.test(value)) {
	            try {
	                config[key] = JSON.parse(value);
	            } catch (e) {
	                console.warn("Failed to parse config property " + key + ": ", value);
	            }
	        }
	    });
	    return config;
	};

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _KeyStateStore2 = __webpack_require__(86);
	
	var _KeyStateStore3 = _interopRequireDefault(_KeyStateStore2);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 28.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ConfigStore = function (_KeyStateStore) {
	    _inherits(ConfigStore, _KeyStateStore);
	
	    function ConfigStore() {
	        _classCallCheck(this, ConfigStore);
	
	        return _possibleConstructorReturn(this, _KeyStateStore.apply(this, arguments));
	    }
	
	    ConfigStore.prototype.getConfig = function getConfig(scopeGroupId, plid, portletId) {
	        return this.getStateByKey(scopeGroupId + plid + portletId);
	    };
	
	    ConfigStore.prototype.getLocalConfig = function getLocalConfig(scopeGroupId, plid, portletId) {
	        return localStorage[this.getStateByKey(scopeGroupId + plid + portletId)];
	    };
	
	    ConfigStore.prototype.getKeyFromAction = function getKeyFromAction(action) {
	        return action.meta && action.meta.scopeGroupId && action.meta.plid && action.meta.portletId && action.meta.scopeGroupId + action.meta.plid + action.meta.portletId;
	    };
	
	    ConfigStore.prototype.getReducer = function getReducer(action) {
	        var key = this.getKeyFromAction(action);
	        switch (action.type) {
	            case _ActionTypesCommon2.default.CONFIG_SET:
	                return this.setConfigFromAction(key);
	            case _ActionTypesCommon2.default.CONFIG_UPDATE_ASYNC:
	            case _ActionTypesCommon2.default.CONFIG_LOAD_ASYNC:
	                if (action.meta.asyncState === _AsyncState2.default.SUCCESS) {
	                    return this.setConfigFromAction(key);
	                }
	                break;
	        }
	    };
	
	    ConfigStore.prototype.setConfigFromAction = function setConfigFromAction(key) {
	        var _this2 = this;
	
	        return function (state, action) {
	            var localConfig = _this2.getLocalConfig(key);
	            if (localConfig) {
	                return _extends({}, action.payload, {
	                    localConfig: localConfig
	                });
	            }
	            return _extends({}, action.payload);
	        };
	    };
	
	    return ConfigStore;
	}(_KeyStateStore3.default);
	
	exports.default = ConfigStore;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _FluxReduceStore2 = __webpack_require__(87);
	
	var _FluxReduceStore3 = _interopRequireDefault(_FluxReduceStore2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 28.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//TODO Unused test -> delete if not useful
	var KeyStateStore = function (_FluxReduceStore) {
	    _inherits(KeyStateStore, _FluxReduceStore);
	
	    function KeyStateStore() {
	        _classCallCheck(this, KeyStateStore);
	
	        return _possibleConstructorReturn(this, _FluxReduceStore.apply(this, arguments));
	    }
	
	    KeyStateStore.prototype.getKeyFromAction = function getKeyFromAction(action) {
	        //implement
	    };
	
	    KeyStateStore.prototype.getReducer = function getReducer(state, action) {
	        //implement
	    };
	
	    KeyStateStore.prototype.subStateSet = function subStateSet(state, key, subState) {
	        var newState = _extends({}, state);
	        if (!subState) {
	            delete newState.stateByKey[key];
	        } else {
	            newState.stateByKey[key] = subState;
	        }
	        return newState;
	    };
	
	    KeyStateStore.prototype.getStateByKey = function getStateByKey(key) {
	        return this.getState().stateByKey[key];
	    };
	
	    KeyStateStore.prototype.getInitialState = function getInitialState() {
	        return {
	            stateByKey: {}
	        };
	    };
	
	    KeyStateStore.prototype.reduce = function reduce(state, action) {
	        var reducer = this.getReducer(action);
	
	        if (reducer) {
	            var key = this.getKeyFromAction(action);
	            if (key) {
	                var subState = state[key],
	                    newSubState = reducer(subState, action);
	
	                if (subState !== newSubState) {
	                    state = this.subStateSet(state, key, newSubState);
	                }
	            } else {
	                console.warn('Invalid state key for ', action);
	            }
	        }
	
	        return state;
	    };
	
	    return KeyStateStore;
	}(_FluxReduceStore3.default);
	
	exports.default = KeyStateStore;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxReduceStore
	 * 
	 */
	
	'use strict';
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var FluxStore = __webpack_require__(88);
	var abstractMethod = __webpack_require__(96);
	var invariant = __webpack_require__(71);
	
	/**
	 * This is the basic building block of a Flux application. All of your stores
	 * should extend this class.
	 *
	 *   class CounterStore extends FluxReduceStore<number> {
	 *     getInitialState(): number {
	 *       return 1;
	 *     }
	 *
	 *     reduce(state: number, action: Object): number {
	 *       switch(action.type) {
	 *         case: 'add':
	 *           return state + action.value;
	 *         case: 'double':
	 *           return state * 2;
	 *         default:
	 *           return state;
	 *       }
	 *     }
	 *   }
	 */
	var FluxReduceStore = /*#__PURE__*/function (_FluxStore) {
	  _inheritsLoose(FluxReduceStore, _FluxStore);
	  function FluxReduceStore(dispatcher) {
	    var _this;
	    _this = _FluxStore.call(this, dispatcher) || this;
	    _defineProperty(_assertThisInitialized(_this), "_state", void 0);
	    _this._state = _this.getInitialState();
	    return _this;
	  }
	
	  /**
	   * Getter that exposes the entire state of this store. If your state is not
	   * immutable you should override this and not expose _state directly.
	   */
	  var _proto = FluxReduceStore.prototype;
	  _proto.getState = function getState() {
	    return this._state;
	  }
	
	  /**
	   * Constructs the initial state for this store. This is called once during
	   * construction of the store.
	   */;
	  _proto.getInitialState = function getInitialState() {
	    return abstractMethod('FluxReduceStore', 'getInitialState');
	  }
	
	  /**
	   * Used to reduce a stream of actions coming from the dispatcher into a
	   * single state object.
	   */;
	  _proto.reduce = function reduce(state, action) {
	    return abstractMethod('FluxReduceStore', 'reduce');
	  }
	
	  /**
	   * Checks if two versions of state are the same. You do not need to override
	   * this if your state is immutable.
	   */;
	  _proto.areEqual = function areEqual(one, two) {
	    return one === two;
	  };
	  _proto.__invokeOnDispatch = function __invokeOnDispatch(action) {
	    this.__changed = false;
	
	    // Reduce the stream of incoming actions to state, update when necessary.
	    var startingState = this._state;
	    var endingState = this.reduce(startingState, action);
	
	    // This means your ending state should never be undefined.
	    !(endingState !== undefined) ?  false ? invariant(false, '%s returned undefined from reduce(...), did you forget to return ' + 'state in the default case? (use null if this was intentional)', this.constructor.name) : invariant(false) : void 0;
	    if (!this.areEqual(startingState, endingState)) {
	      this._state = endingState;
	
	      // `__emitChange()` sets `this.__changed` to true and then the actual
	      // change will be fired from the emitter at the end of the dispatch, this
	      // is required in order to support methods like `hasChanged()`
	      this.__emitChange();
	    }
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  };
	  return FluxReduceStore;
	}(FluxStore);
	module.exports = FluxReduceStore;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStore
	 * 
	 */
	
	'use strict';
	
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var _require = __webpack_require__(89),
	  EventEmitter = _require.EventEmitter;
	var invariant = __webpack_require__(71);
	
	/**
	 * This class represents the most basic functionality for a FluxStore. Do not
	 * extend this store directly; instead extend FluxReduceStore when creating a
	 * new store.
	 */
	var FluxStore = /*#__PURE__*/function () {
	  // private
	
	  // protected, available to subclasses
	
	  function FluxStore(dispatcher) {
	    var _this = this;
	    _defineProperty(this, "_dispatchToken", void 0);
	    _defineProperty(this, "__changed", void 0);
	    _defineProperty(this, "__changeEvent", void 0);
	    _defineProperty(this, "__className", void 0);
	    _defineProperty(this, "__dispatcher", void 0);
	    _defineProperty(this, "__emitter", void 0);
	    this.__className = this.constructor.name;
	    this.__changed = false;
	    this.__changeEvent = 'change';
	    this.__dispatcher = dispatcher;
	    this.__emitter = new EventEmitter();
	    this._dispatchToken = dispatcher.register(function (payload) {
	      _this.__invokeOnDispatch(payload);
	    });
	  }
	  var _proto = FluxStore.prototype;
	  _proto.addListener = function addListener(callback) {
	    return this.__emitter.addListener(this.__changeEvent, callback);
	  };
	  _proto.getDispatcher = function getDispatcher() {
	    return this.__dispatcher;
	  }
	
	  /**
	   * This exposes a unique string to identify each store's registered callback.
	   * This is used with the dispatcher's waitFor method to declaratively depend
	   * on other stores updating themselves first.
	   */;
	  _proto.getDispatchToken = function getDispatchToken() {
	    return this._dispatchToken;
	  }
	
	  /**
	   * Returns whether the store has changed during the most recent dispatch.
	   */;
	  _proto.hasChanged = function hasChanged() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.hasChanged(): Must be invoked while dispatching.', this.__className) : invariant(false) : void 0;
	    return this.__changed;
	  };
	  _proto.__emitChange = function __emitChange() {
	    !this.__dispatcher.isDispatching() ?  false ? invariant(false, '%s.__emitChange(): Must be invoked while dispatching.', this.__className) : invariant(false) : void 0;
	    this.__changed = true;
	  }
	
	  /**
	   * This method encapsulates all logic for invoking __onDispatch. It should
	   * be used for things like catching changes and emitting them after the
	   * subclass has handled a payload.
	   */;
	  _proto.__invokeOnDispatch = function __invokeOnDispatch(payload) {
	    this.__changed = false;
	    this.__onDispatch(payload);
	    if (this.__changed) {
	      this.__emitter.emit(this.__changeEvent);
	    }
	  }
	
	  /**
	   * The callback that will be registered with the dispatcher during
	   * instantiation. Subclasses must override this method. This callback is the
	   * only way the store receives new data.
	   */;
	  _proto.__onDispatch = function __onDispatch(payload) {
	     true ?  false ? invariant(false, '%s has not overridden FluxStore.__onDispatch(), which is required', this.__className) : invariant(false) : void 0;
	  };
	  return FluxStore;
	}();
	module.exports = FluxStore;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	var fbemitter = {
	  EventEmitter: __webpack_require__(90),
	  EmitterSubscription : __webpack_require__(91)
	};
	
	module.exports = fbemitter;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BaseEventEmitter
	 * @typechecks
	 */
	var EmitterSubscription = __webpack_require__(91);
	
	var EventSubscriptionVendor = __webpack_require__(93);
	
	var invariant = __webpack_require__(94);
	
	var emptyFunction = __webpack_require__(95);
	/**
	 * @class BaseEventEmitter
	 * @description
	 * An EventEmitter is responsible for managing a set of listeners and publishing
	 * events to them when it is told that such events happened. In addition to the
	 * data for the given event it also sends a event control object which allows
	 * the listeners/handlers to prevent the default behavior of the given event.
	 *
	 * The emitter is designed to be generic enough to support all the different
	 * contexts in which one might want to emit events. It is a simple multicast
	 * mechanism on top of which extra functionality can be composed. For example, a
	 * more advanced emitter may use an EventHolder and EventFactory.
	 */
	
	
	var BaseEventEmitter = /*#__PURE__*/function () {
	  /**
	   * @constructor
	   */
	  function BaseEventEmitter() {
	    this._subscriber = new EventSubscriptionVendor();
	    this._currentSubscription = null;
	  }
	  /**
	   * Adds a listener to be invoked when events of the specified type are
	   * emitted. An optional calling context may be provided. The data arguments
	   * emitted will be passed to the listener function.
	   *
	   * TODO: Annotate the listener arg's type. This is tricky because listeners
	   *       can be invoked with varargs.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	
	
	  var _proto = BaseEventEmitter.prototype;
	
	  _proto.addListener = function addListener(eventType, listener, context) {
	    return this._subscriber.addSubscription(eventType, new EmitterSubscription(this._subscriber, listener, context));
	  }
	  /**
	   * Similar to addListener, except that the listener is removed after it is
	   * invoked once.
	   *
	   * @param {string} eventType - Name of the event to listen to
	   * @param {function} listener - Function to invoke only once when the
	   *   specified event is emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	  ;
	
	  _proto.once = function once(eventType, listener, context) {
	    var emitter = this;
	    return this.addListener(eventType, function () {
	      emitter.removeCurrentListener();
	      listener.apply(context, arguments);
	    });
	  }
	  /**
	   * Removes all of the registered listeners, including those registered as
	   * listener maps.
	   *
	   * @param {?string} eventType - Optional name of the event whose registered
	   *   listeners to remove
	   */
	  ;
	
	  _proto.removeAllListeners = function removeAllListeners(eventType) {
	    this._subscriber.removeAllSubscriptions(eventType);
	  }
	  /**
	   * Provides an API that can be called during an eventing cycle to remove the
	   * last listener that was invoked. This allows a developer to provide an event
	   * object that can remove the listener (or listener map) during the
	   * invocation.
	   *
	   * If it is called when not inside of an emitting cycle it will throw.
	   *
	   * @throws {Error} When called not during an eventing cycle
	   *
	   * @example
	   *   var subscription = emitter.addListenerMap({
	   *     someEvent: function(data, event) {
	   *       console.log(data);
	   *       emitter.removeCurrentListener();
	   *     }
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   *   emitter.emit('someEvent', 'def'); // does not log anything
	   */
	  ;
	
	  _proto.removeCurrentListener = function removeCurrentListener() {
	    !!!this._currentSubscription ?  false ? invariant(false, 'Not in an emitting cycle; there is no current subscription') : invariant(false) : void 0;
	
	    this._subscriber.removeSubscription(this._currentSubscription);
	  }
	  /**
	   * Returns an array of listeners that are currently registered for the given
	   * event.
	   *
	   * @param {string} eventType - Name of the event to query
	   * @return {array}
	   */
	  ;
	
	  _proto.listeners = function listeners(eventType)
	  /* TODO: Array<EventSubscription> */
	  {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	
	    return subscriptions ? subscriptions.filter(emptyFunction.thatReturnsTrue).map(function (subscription) {
	      return subscription.listener;
	    }) : [];
	  }
	  /**
	   * Emits an event of the given type with the given data. All handlers of that
	   * particular type will be notified.
	   *
	   * @param {string} eventType - Name of the event to emit
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   *
	   * @example
	   *   emitter.addListener('someEvent', function(message) {
	   *     console.log(message);
	   *   });
	   *
	   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
	   */
	  ;
	
	  _proto.emit = function emit(eventType) {
	    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);
	
	    if (subscriptions) {
	      var keys = Object.keys(subscriptions);
	
	      for (var ii = 0; ii < keys.length; ii++) {
	        var key = keys[ii];
	        var subscription = subscriptions[key]; // The subscription may have been removed during this event loop.
	
	        if (subscription) {
	          this._currentSubscription = subscription;
	
	          this.__emitToSubscription.apply(this, [subscription].concat(Array.prototype.slice.call(arguments)));
	        }
	      }
	
	      this._currentSubscription = null;
	    }
	  }
	  /**
	   * Provides a hook to override how the emitter emits an event to a specific
	   * subscription. This allows you to set up logging and error boundaries
	   * specific to your environment.
	   *
	   * @param {EmitterSubscription} subscription
	   * @param {string} eventType
	   * @param {*} Arbitrary arguments to be passed to each registered listener
	   */
	  ;
	
	  _proto.__emitToSubscription = function __emitToSubscription(subscription, eventType) {
	    var args = Array.prototype.slice.call(arguments, 2);
	    subscription.listener.apply(subscription.context, args);
	  };
	
	  return BaseEventEmitter;
	}();
	
	module.exports = BaseEventEmitter;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EmitterSubscription
	 * @typechecks
	 */
	'use strict';
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var EventSubscription = __webpack_require__(92);
	/**
	 * EmitterSubscription represents a subscription with listener and context data.
	 */
	
	
	var EmitterSubscription = /*#__PURE__*/function (_EventSubscription) {
	  _inheritsLoose(EmitterSubscription, _EventSubscription);
	
	  /**
	   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
	   *   this subscription
	   * @param {function} listener - Function to invoke when the specified event is
	   *   emitted
	   * @param {*} context - Optional context object to use when invoking the
	   *   listener
	   */
	  function EmitterSubscription(subscriber, listener, context) {
	    var _this;
	
	    _this = _EventSubscription.call(this, subscriber) || this;
	    _this.listener = listener;
	    _this.context = context;
	    return _this;
	  }
	
	  return EmitterSubscription;
	}(EventSubscription);
	
	module.exports = EmitterSubscription;

/***/ }),
/* 92 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventSubscription
	 * @typechecks
	 */
	'use strict';
	/**
	 * EventSubscription represents a subscription to a particular event. It can
	 * remove its own subscription.
	 */
	
	var EventSubscription = /*#__PURE__*/function () {
	  /**
	   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
	   *   this subscription.
	   */
	  function EventSubscription(subscriber) {
	    this.subscriber = subscriber;
	  }
	  /**
	   * Removes this subscription from the subscriber that controls it.
	   */
	
	
	  var _proto = EventSubscription.prototype;
	
	  _proto.remove = function remove() {
	    if (this.subscriber) {
	      this.subscriber.removeSubscription(this);
	      this.subscriber = null;
	    }
	  };
	
	  return EventSubscription;
	}();
	
	module.exports = EventSubscription;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventSubscriptionVendor
	 * @typechecks
	 */
	'use strict';
	
	var invariant = __webpack_require__(94);
	/**
	 * EventSubscriptionVendor stores a set of EventSubscriptions that are
	 * subscribed to a particular event type.
	 */
	
	
	var EventSubscriptionVendor = /*#__PURE__*/function () {
	  function EventSubscriptionVendor() {
	    this._subscriptionsForType = {};
	    this._currentSubscription = null;
	  }
	  /**
	   * Adds a subscription keyed by an event type.
	   *
	   * @param {string} eventType
	   * @param {EventSubscription} subscription
	   */
	
	
	  var _proto = EventSubscriptionVendor.prototype;
	
	  _proto.addSubscription = function addSubscription(eventType, subscription) {
	    !(subscription.subscriber === this) ?  false ? invariant(false, 'The subscriber of the subscription is incorrectly set.') : invariant(false) : void 0;
	
	    if (!this._subscriptionsForType[eventType]) {
	      this._subscriptionsForType[eventType] = [];
	    }
	
	    var key = this._subscriptionsForType[eventType].length;
	
	    this._subscriptionsForType[eventType].push(subscription);
	
	    subscription.eventType = eventType;
	    subscription.key = key;
	    return subscription;
	  }
	  /**
	   * Removes a bulk set of the subscriptions.
	   *
	   * @param {?string} eventType - Optional name of the event type whose
	   *   registered supscriptions to remove, if null remove all subscriptions.
	   */
	  ;
	
	  _proto.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
	    if (eventType === undefined) {
	      this._subscriptionsForType = {};
	    } else {
	      delete this._subscriptionsForType[eventType];
	    }
	  }
	  /**
	   * Removes a specific subscription. Instead of calling this function, call
	   * `subscription.remove()` directly.
	   *
	   * @param {object} subscription
	   */
	  ;
	
	  _proto.removeSubscription = function removeSubscription(subscription) {
	    var eventType = subscription.eventType;
	    var key = subscription.key;
	    var subscriptionsForType = this._subscriptionsForType[eventType];
	
	    if (subscriptionsForType) {
	      delete subscriptionsForType[key];
	    }
	  }
	  /**
	   * Returns the array of subscriptions that are currently registered for the
	   * given event type.
	   *
	   * Note: This array can be potentially sparse as subscriptions are deleted
	   * from it when they are removed.
	   *
	   * TODO: This returns a nullable array. wat?
	   *
	   * @param {string} eventType
	   * @return {?array}
	   */
	  ;
	
	  _proto.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
	    return this._subscriptionsForType[eventType];
	  };
	
	  return EventSubscriptionVendor;
	}();
	
	module.exports = EventSubscriptionVendor;

/***/ }),
/* 94 */
71,
/* 95 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	
	
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule abstractMethod
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(71);
	function abstractMethod(className, methodName) {
	   true ?  false ? invariant(false, 'Subclasses of %s must override %s() with their own implementation.', className, methodName) : invariant(false) : void 0;
	}
	module.exports = abstractMethod;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _RemoteDataStore2 = __webpack_require__(98);
	
	var _RemoteDataStore3 = _interopRequireDefault(_RemoteDataStore2);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _deepMerge = __webpack_require__(101);
	
	var _deepMerge2 = _interopRequireDefault(_deepMerge);
	
	var _appContext = __webpack_require__(67);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Hibbeler on 21.01.2016.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	function findStoreForCQP(cqp) {
	    var idx = _appContext.AppContext.getStores().findIndex(function (s) {
	        return s.containsRemoteData && s.containsRemoteData(cqp.sourceName, cqp.sourceClassName);
	    });
	    return idx > -1 && _appContext.AppContext.getStores()[idx];
	}
	
	function findStoreForCQPByClass(cqp) {
	    var idx = _appContext.AppContext.getStores().findIndex(function (s) {
	        return s.className && s.className === cqp.sourceClassName;
	    });
	    return idx > -1 && _appContext.AppContext.getStores()[idx];
	}
	
	function findDispatchTokensForCQPs(cqps, curStore, fallbackToClassSearch) {
	    var token = cqps.map(findStoreForCQP).filter(function (s) {
	        return s && s !== curStore;
	    }).map(function (s) {
	        return s.getDispatchToken();
	    });
	    if (fallbackToClassSearch && token.length === 0) {
	        token = cqps.map(findStoreForCQPByClass).filter(function (s) {
	            return s && s !== curStore;
	        }).map(function (s) {
	            return s.getDispatchToken();
	        });
	    }
	    return token;
	}
	
	function findDataForCQPs(cqp) {
	    var store = findStoreForCQP(cqp),
	        data = store && store.getRemoteData(cqp.sourceName);
	    return data && (!cqp.sourceClassName || cqp.sourceClassName === data.className) && data;
	}
	
	function calculateDataUpdate(cqps, existingQuery) {
	    var update = null;
	    cqps.forEach(function (cqp) {
	        var data = findDataForCQPs(cqp);
	
	        //calculate current cqp value
	        var v = void 0;
	        if (data && !data._invalid && !data._loading && !data._error) {
	            v = data.item[cqp.sourceProp];
	        }
	        if (!v && data && cqp.sourceProp === 'id') {
	            //special handling for id
	            v = data.query.id;
	        }
	
	        if (v && existingQuery && existingQuery[cqp.param] === v) {
	            console.log('Unchanged calculateQueryParam', cqp, existingQuery, data);
	        } else {
	            update = update || { query: (0, _deepMerge2.default)({}, existingQuery) };
	            if (v) {
	                update.query[cqp.param] = v;
	            } else if (!v && !data) {
	                console.warn('Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is not yet initialized.', cqp, data);
	                update._error = 'Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is not yet initialized.';
	            } else if (!v && data && data._invalid) {
	                console.warn('Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is invalid.', cqp, data);
	                update._error = 'Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is invalid.';
	            } else if (!v && data && data._loading) {
	                console.warn('Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is still loading.', cqp, data);
	                update._error = 'Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is still loading.';
	            } else if (!v && data && data._error) {
	                console.warn('Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is still erroneous.', cqp, data);
	                update._error = 'Cannot calculate calculateQueryParam! ' + cqp.sourceName + ' is still erroneous.';
	            } else {
	                console.warn('Cannot calculate calculateQueryParam!', cqp, data);
	                update._error = 'Cannot calculate calculateQueryParam!';
	            }
	        }
	
	        if (update && v && existingQuery && existingQuery[cqp.param] !== v) {
	            update.query.changesSince && (update.query.changesSince = undefined);
	            update.query.start && (update.query.start = 0);
	            update.query.end && (update.query.end = _appContext.AppContext.DEFAULT_LIST_SIZE);
	        }
	    });
	
	    return update;
	}
	
	/**
	 * Parsing computed props from query
	 * @param name data name
	 * @param query
	 * @returns {*|Array} of cqps
	 */
	function parseCqps(name, query) {
	    /*
	     query example:
	     const linkedListQuery = {
	        $byId: ClassNames.CriticalObject + '/' + this.DATA.SELECTED_CRITICAL_OBJECT + '/id',
	        byClassName: ClassNames.CriticalObject,
	        start: 0,
	        end: AppContext.DEFAULT_LIST_SIZE
	     };
	     */
	    return query && Object.keys(query).filter(function (p) {
	        return p[0] === '$';
	    }).map(function (p) {
	        var s = query[p].split('/');
	        return {
	            name: name, // list name
	            param: p.substring(1, p.length),
	            sourceClassName: s.length > 2 && s[0], // optional
	            sourceName: s[s.length - 2], // referenced list
	            sourceProp: s[s.length - 1]
	        };
	    }) || [];
	}
	
	var ComputedQueryParamsDataStore = function (_RemoteDataStore) {
	    _inherits(ComputedQueryParamsDataStore, _RemoteDataStore);
	
	    function ComputedQueryParamsDataStore(dispatcher) {
	        _classCallCheck(this, ComputedQueryParamsDataStore);
	
	        //myCqpsBySourceName[this.DATA.SELECTED_FRB]=[this.DATA.FRB_DETAILS,this.DATA.FRB_MAP_SELECTED]
	        var _this = _possibleConstructorReturn(this, _RemoteDataStore.call(this, dispatcher));
	
	        _this.myCqpsBySourceName = {};
	        return _this;
	    }
	
	    ComputedQueryParamsDataStore.prototype.doSetRemoteState = function doSetRemoteState(state, remote) {
	        var _this2 = this;
	
	        var forceCqps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	        var oldRemote = this.getRemoteState();
	        Object.keys(remote).forEach(function (name) {
	            var data = remote[name],
	                oldData = oldRemote[name];
	
	            if (oldData !== data) {
	                forceCqps[name] = true;
	                _this2.getMyCqpsSourceOf(name, data.className).forEach(function (cqp) {
	                    return forceCqps[cqp.name] = true;
	                });
	            }
	        });
	
	        Object.keys(forceCqps).forEach(function (name) {
	            var data = remote[name],
	                cqps = parseCqps(name, data.query);
	
	            _this2.cacheMyCqps(name, cqps);
	
	            if (cqps.length > 0) {
	                _this2.getDispatcher().waitFor(findDispatchTokensForCQPs(cqps, _this2));
	                var dataUpdate = calculateDataUpdate(cqps, data.query);
	                if (dataUpdate) {
	                    remote[name] = _RemoteDataStore3.default.updateData(data, dataUpdate);
	                }
	            }
	        });
	
	        //Handle Removed
	        Object.keys(oldRemote).filter(function (name) {
	            return !remote[name];
	        }).forEach(function (name) {
	            _this2.removeMyCqpsSourceOf(name);
	        });
	
	        return _RemoteDataStore.prototype.doSetRemoteState.call(this, state, remote);
	    };
	
	    ComputedQueryParamsDataStore.prototype.getMyCqpsSourceOf = function getMyCqpsSourceOf(name, className) {
	        return this.myCqpsBySourceName[name] && this.myCqpsBySourceName[name].filter(function (cqp) {
	            return !cqp.sourceClassName || cqp.sourceClassName === className;
	        }) || [];
	    };
	
	    ComputedQueryParamsDataStore.prototype.removeMyCqpsSourceOf = function removeMyCqpsSourceOf(name) {
	        var _this3 = this;
	
	        Object.keys(this.myCqpsBySourceName).forEach(function (sourceName) {
	            _this3.myCqpsBySourceName[sourceName] = _this3.myCqpsBySourceName[sourceName].filter(function (cqp) {
	                return cqp.name !== name;
	            });
	            if (_this3.myCqpsBySourceName[sourceName].length === 0) {
	                delete _this3.myCqpsBySourceName[sourceName];
	            }
	        });
	    };
	
	    // cache own cpqs
	    // update already existing cached cqps
	
	
	    ComputedQueryParamsDataStore.prototype.cacheMyCqps = function cacheMyCqps(name, cqps) {
	        var _this4 = this;
	
	        // filter for cqps where cqp.name !== name
	        Object.keys(this.myCqpsBySourceName).forEach(function (sourceName) {
	            _this4.myCqpsBySourceName[sourceName] = _this4.myCqpsBySourceName[sourceName].filter(function (cqp) {
	                return cqp.name !== name;
	            });
	        });
	        // add/update
	        cqps.forEach(function (cqp) {
	            (_this4.myCqpsBySourceName[cqp.sourceName] || (_this4.myCqpsBySourceName[cqp.sourceName] = [])).push(cqp);
	        });
	    };
	
	    ComputedQueryParamsDataStore.prototype.reduce = function reduce(state, action) {
	        var name = void 0,
	            className = void 0;
	
	        switch (action.type) {
	
	            case _ActionTypesCommon2.default.DATA_LIST_INIT:
	                var _action$meta = action.meta;
	                name = _action$meta.name;
	                className = _action$meta.className;
	
	
	                if (this.className !== className) {
	                    //nothing to do
	                }
	
	                break;
	            case _ActionTypesCommon2.default.DATA_ASYNC:
	                var _action$meta2 = action.meta;
	                name = _action$meta2.name;
	                className = _action$meta2.className;
	
	                if (action.meta.asyncState === _AsyncState2.default.SUCCESS) {
	                    state = this.handleCqpUpdates(name, className, action, state);
	                }
	                break;
	
	            case _ActionTypesCommon2.default.DATA_ITEM_INIT:
	                {
	
	                    //   if (this.className != className) { //should always be true
	                    //get all of my remotedata's with queries that contain cqp with the source 'name' and 'className'
	                    var _action$meta3 = action.meta;
	                    name = _action$meta3.name;
	                    className = _action$meta3.className;
	                    state = this.handleCqpUpdates(name, className, action, state);
	                    //     }
	                }
	        }
	
	        return _RemoteDataStore.prototype.reduce.call(this, state, action);
	    };
	
	    ComputedQueryParamsDataStore.prototype.handleCqpUpdates = function handleCqpUpdates(name, className, action, state) {
	        var cqps = this.getMyCqpsSourceOf(name, className);
	
	        if (cqps && cqps.length > 0) {
	            //    let remote;
	            this.getDispatcher().waitFor(findDispatchTokensForCQPs(cqps, this, true));
	            var cqpsByName = cqps.reduce(function (byName, cqp) {
	                byName[cqp.name] = byName[cqp.name] || [];
	                byName[cqp.name].push(cqp);
	                return byName;
	            }, {});
	
	            console.log(this.constructor.name, 'handle', action, state.remote, '');
	            state = this.doSetRemoteState(state, state.remote, cqpsByName);
	        }
	        return state;
	    };
	
	    return ComputedQueryParamsDataStore;
	}(_RemoteDataStore3.default);
	
	exports.default = ComputedQueryParamsDataStore;

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_DATA_LIST = exports.DEFAULT_DATA_ITEM = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
	                                                                                                                                                                                                                                                                               * Created by Carsten Hibbeler on 21.01.2016.
	                                                                                                                                                                                                                                                                               * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                               */
	
	
	exports.isData = isData;
	exports.isList = isList;
	exports.isAttachedList = isAttachedList;
	exports.isItem = isItem;
	exports.checkValidData = checkValidData;
	exports.checkValidDataStore = checkValidDataStore;
	exports.checkValidList = checkValidList;
	exports.checkValidItem = checkValidItem;
	
	var _appContext = __webpack_require__(67);
	
	var _FluxReduceStore2 = __webpack_require__(87);
	
	var _FluxReduceStore3 = _interopRequireDefault(_FluxReduceStore2);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _uidUtil = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/* there are dependecy problems with StoreFactory
	 import { getAsyncOperationStore } from './StoreFactory';
	 const AsyncOperationStore = getAsyncOperationStore(AppContext);*/
	
	var deepFreeze = function deepFreeze(o) {
	    Object.freeze(o);
	    Object.getOwnPropertyNames(o).forEach(function (prop) {
	        if (o.hasOwnProperty(prop) && o[prop] !== null && (_typeof(o[prop]) === 'object' || typeof o[prop] === 'function') && !Object.isFrozen(o[prop])) {
	            deepFreeze(o[prop]);
	        }
	    });
	    return o;
	};
	
	//######################### DEBUG #########################
	window.REMOTE_STORES = [];
	window.DEBUG_REMOTE_STORES = function (contains) {
	    window.REMOTE_STORES.filter(function (s) {
	        return !contains || s.storeId.indexOf(contains) >= 0;
	    }).forEach(function (s) {
	        var remote = s.getState().remote,
	            lists = {},
	            items = {},
	            names = Object.keys(remote);
	        names.forEach(function (name) {
	            var d = remote[name],
	                i = _extends({}, d);
	            delete i['name'];
	            (isList(d) ? lists : items)[name] = i;
	        });
	        console.group('########### Remote Store ' + s.constructor.name + ' (' + (s.className || 'no className') + ') Num data: ' + names.length);
	        console.info(s);
	        if (Object.keys(lists).length > 0) {
	            console.table ? console.table(lists) : console.debug(lists);
	        }
	
	        if (Object.keys(items).length > 0) {
	            console.table ? console.table(items) : console.debug(items);
	        }
	        console.groupEnd();
	    });
	};
	
	var DEFAULT_DATA = {
	    __STORE: null,
	    name: null,
	    className: null,
	    api: null,
	    query: {},
	    //apiMethod: null, deprecated
	    _loading: false,
	    _asyncKey: false, //string if set
	    _invalid: true,
	    _error: null
	};
	
	var DEFAULT_DATA_ITEM = exports.DEFAULT_DATA_ITEM = _extends({}, DEFAULT_DATA, {
	    item: null, //todo this should be init with null but it will break most item checks :(
	    _deleted: false
	});
	
	var DEFAULT_DATA_LIST = exports.DEFAULT_DATA_LIST = _extends({}, DEFAULT_DATA, {
	    item: [],
	    _count: 0,
	    _start: 0,
	    _end: 0,
	    _more: false
	});
	
	function isData(data) {
	    return !!data.__STORE;
	}
	
	function isList(data) {
	    return Array.isArray(data.item);
	}
	
	function isAttachedList(data, wsUpdate) {
	    if (wsUpdate.meta && wsUpdate.meta.attachedClassName && wsUpdate.meta.attachedClassPK) {
	        return isList(data) && data.query.byClassName === wsUpdate.meta.attachedClassName && data.query.byId === wsUpdate.meta.attachedClassPK;
	    } else {
	        return isList(data) && data.query.byClassName === wsUpdate.type && data.query.byId == wsUpdate.id;
	    }
	}
	
	function isItem(data) {
	    return !isList(data);
	}
	
	function checkValidData(data) {
	    if (isList(data)) {
	        checkValidList(data);
	    } else {
	        checkValidItem(data);
	    }
	    return data;
	}
	
	function checkValidDataStore(data, store) {
	    (0, _warning2.default)(store.storeId === data.__STORE, 'Item:%s is from different store:%s !', data.__STORE, store.storeId);
	}
	
	function _checkValidData(data) {
	    (0, _warning2.default)(data.__STORE, 'Store id not set');
	    (0, _warning2.default)(data._invalid || data.item, 'Item is not set');
	    (0, _warning2.default)(typeof data.name === 'string', 'name %s is invalid', data.name);
	    (0, _warning2.default)(typeof data.api === 'string', 'api %s is invalid', data.api);
	    Object.keys(data.query).forEach(function (p) {
	        (0, _warning2.default)(p.indexOf('_') !== 0, 'flag property in query: %s', p); //this may valid but currently we better warn
	    });
	    (0, _warning2.default)(!(data._loading && data._error), 'Data is loading and error at the same time');
	    (0, _warning2.default)(!data._loading || data._loading && data._asyncKey, 'Data is loading and error at the same time');
	}
	
	function checkValidList(data) {
	    _checkValidData(data);
	    Object.keys(DEFAULT_DATA_LIST).forEach(function (p) {
	        (0, _warning2.default)(typeof data[p] !== 'undefined', 'ListData missing property:%s', p);
	    });
	    Object.keys(data).forEach(function (p) {
	        (0, _warning2.default)(DEFAULT_DATA_LIST[p] !== 'undefined', 'Invalid property:%s', p);
	    });
	    (0, _warning2.default)(data._count >= data._end, 'Invalid _end:%s for _count:%s', data._end, data._count);
	    (0, _warning2.default)(data._start >= 0, 'Invalid _start ', data._start);
	    (0, _warning2.default)(data._start <= data._end, 'Invalid _start:%s for _end:%s', data._start, data._end);
	    (0, _warning2.default)(data.item.length === data._end, 'Invalid _end:%s for item.length:%s ', data._end, data.item.length);
	    (0, _warning2.default)(data.item.length <= data._count, 'Invalid item.length:%s for _count:%s', data.item.length, data._count);
	}
	
	function checkValidItem(data) {
	    _checkValidData(data);
	    Object.keys(DEFAULT_DATA_ITEM).forEach(function (p) {
	        (0, _warning2.default)(typeof data[p] !== 'undefined', 'ItemData missing property: ' + p);
	    });
	    Object.keys(data).forEach(function (p) {
	        (0, _warning2.default)(DEFAULT_DATA_ITEM[p] !== 'undefined', 'Invalid property: ' + p);
	    });
	    //warning(data._invalid || ( data.id === data.item.id ), 'Item id is not in sync data.id:%s data.item.id:%s', data.id, data.item.id);
	}
	
	var RemoteDataStore = function (_FluxReduceStore) {
	    _inherits(RemoteDataStore, _FluxReduceStore);
	
	    function RemoteDataStore(dispatcher) {
	        _classCallCheck(this, RemoteDataStore);
	
	        var _this = _possibleConstructorReturn(this, _FluxReduceStore.call(this, dispatcher));
	
	        _this.storeId = (0, _uidUtil.generateId)(_this.constructor.name);
	        _this.containedClassnames = {};
	        _this.defaultListData = _extends({}, DEFAULT_DATA_LIST, { __STORE: _this.storeId });
	        _this.defaultItemData = _extends({}, DEFAULT_DATA_ITEM, { __STORE: _this.storeId });
	        window.REMOTE_STORES.push(_this);
	
	        return _this;
	    }
	
	    RemoteDataStore.handleExisting = function handleExisting(remote, data) {
	        try {
	            var existing = RemoteDataStore.getData(remote, data.name, data.className);
	            if (existing) {
	                if ((0, _shallowEqual2.default)(existing.query, data.query)) {
	                    console.warn('Init existing data with same query found. Invalidate existing...', data, existing);
	                    var newData = RemoteDataStore.invalidateData(existing);
	                    if (data.item && data.item !== newData.item) {
	                        newData = _extends({}, newData, {
	                            item: data.item
	                        });
	                        if (isList(newData)) {
	                            newData._start = data._start;
	                            newData._end = data._end;
	                            newData._count = data._count;
	                        }
	                    }
	                    if (newData === existing) {
	                        data = null;
	                    } else {
	                        data = newData;
	                    }
	                } else if (existing._asyncKey) {
	                    console.warn('Init existing data with running async.', data, existing);
	                }
	            }
	        } catch (e) {
	            console.error(e);
	        }
	        return data;
	    };
	
	    RemoteDataStore.initDataList = function initDataList(name, data) {
	        var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_DATA_LIST;
	        var store = arguments[3];
	
	        (0, _warning2.default)(!data.item || isList(data), 'Cannot init item with object!');
	        (0, _warning2.default)(typeof defaults._start !== 'undefined', 'Invalid list defaults');
	        return this._initData(name, data, defaults, store);
	    };
	
	    RemoteDataStore.initDataItem = function initDataItem(name, data) {
	        var defaults = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_DATA_ITEM;
	        var store = arguments[3];
	
	        (0, _warning2.default)(!data.item || isItem(data), 'Cannot init list with object!');
	        (0, _warning2.default)(typeof defaults._start === 'undefined', 'Invalid item defaults');
	
	        //special case for optimistic inits with existing raw item and without a given query
	        if (data.item && (!data.query || Object.keys(data.query).length === 0)) {
	            console.info('Optimistic init new data from raw item', data);
	            (0, _warning2.default)(data.item.id, 'Cannot optimistic init item from raw item without id!');
	            data = _extends({}, data, {
	                query: { id: data.item.id }
	            });
	        }
	
	        return this._initData(name, data, defaults, store);
	    };
	
	    RemoteDataStore._initData = function _initData(name, data, defaults, store) {
	        if (isData(data)) {
	            //this operation is a data copy from one store to another
	            console.info('Init new data from valid existing data', data);
	            data = _extends({}, data);
	        } else {
	            //console.debug('Init new data', data);
	            data = _extends({}, defaults, data, {
	                query: _extends({}, defaults.query, data.query)
	            });
	        }
	
	        data.name = name;
	        data.__STORE = store.storeId;
	        return checkValidData(data);
	    };
	
	    RemoteDataStore.updateData = function updateData(existing, data) {
	        console.debug('Update data', existing);
	        (0, _warning2.default)(!isData(data), 'update with existing data isn\'t a good idea');
	        var d = _extends({}, existing, {
	            className: data.className || existing.className,
	            api: data.api || existing.api,
	            item: data.item || existing.item, //this is useful for optimistic inits -> data is shown but stated as invalid
	            _error: data._error || null,
	            _loading: false,
	            _invalid: true
	        });
	        if (data.query) {
	            d.query = _extends({}, existing.query, data.query);
	        }
	        return d;
	    };
	
	    RemoteDataStore.getData = function getData(remote, name, className) {
	        var data = remote[name];
	        return data && (!className || data.className === className) && data;
	    };
	
	    RemoteDataStore.setData = function setData(remote, data) {
	        var _extends2;
	
	        (0, _warning2.default)(data.name, 'Named expected');
	        if (__DEBUG__) {
	            if (data !== remote[data.name] && (0, _shallowEqual2.default)(data, remote[data.name])) {
	                console.error('Setting equal data for remote', remote, data);
	            }
	            deepFreeze(data);
	        }
	        return _extends({}, remote, (_extends2 = {}, _extends2[data.name] = data, _extends2));
	    };
	
	    RemoteDataStore.updateFlag = function updateFlag(existing, flags) {
	        console.debug('Update flags of', existing, flags);
	        (0, _warning2.default)(!flags.item, 'should not update item');
	        (0, _warning2.default)(!flags.query, 'should not update query');
	        (0, _warning2.default)(!flags.className, 'should not update className');
	        (0, _warning2.default)(existing._invalid || flags._loading || flags._invalid || flags._deleted, 'flag update but not invalid');
	        if ((0, _shallowEqual.shallowContains)(existing, flags)) {
	            if (__DEBUG__) {
	                if (Object.keys(existing).length !== Object.keys(flags).length) {
	                    console.error('Flag length incorrect', Object.keys(existing), Object.keys(flags));
	                }
	            }
	            return existing;
	        }
	        return _extends({}, existing, flags);
	    };
	
	    RemoteDataStore.updateQuery = function updateQuery(existing, query) {
	        if ((0, _shallowEqual.shallowContains)(existing.query, query)) {
	            return existing;
	        }
	        return _extends({}, existing, {
	            query: _extends({}, existing.query, query)
	        });
	    };
	
	    RemoteDataStore.resoreBackup = function resoreBackup(existing, error) {
	        console.warn('Restore data because of error', existing, error);
	        return existing._backup || this.updateFlag(existing, {
	            _loading: false,
	            _error: error || 'no-data-backup-to-restore' //TODO use translation-util
	        });
	    };
	
	    RemoteDataStore.moreItems = function moreItems(existing) {
	        var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _appContext.AppContext.DEFAULT_LIST_SIZE;
	
	        //query next chunk
	        var newStart = existing._end > existing._count ? existing._count : existing._end;
	        return this.updateQuery(this.invalidateData(existing), {
	            start: newStart,
	            end: newStart + offset
	        });
	    };
	
	    RemoteDataStore.invalidateData = function invalidateData(existing) {
	        if (existing._invalid) {
	            return existing;
	        }
	        if (isList(existing) && (existing._start !== existing.query.start || existing._end !== existing.query.end)) {
	            //for paged lists we want to invalidate the full list not only the current page
	            console.warn('reset list - correct?');
	            existing = this.updateQuery(existing, {
	                start: 0,
	                end: existing._end || _appContext.AppContext.DEFAULT_LIST_SIZE
	            });
	        }
	        return _extends({}, existing, {
	            _invalid: true,
	            _backup: existing
	        });
	    };
	
	    RemoteDataStore.removeRemoteData = function removeRemoteData(remote, name) {
	        remote = _extends({}, remote);
	        delete remote[name];
	        return remote;
	    };
	
	    RemoteDataStore.updateList = function updateList(existing, dataUpdate) {
	        var items = void 0,
	            query = existing.query;
	
	        if (query.end > dataUpdate._count) {
	            query = _extends({}, query, {
	                end: dataUpdate._count
	            });
	        }
	
	        /* TODO this seems not correct: dataUpdate._start > dataUpdate._count is invalid and should be handled on the server
	         if (dataUpdate._start > dataUpdate._count) { //Fix if asked result is above real data
	         const gap = dataUpdate._end - dataUpdate._start;
	         _end = dataUpdate._count;
	         _start = dataUpdate._end - gap > 0 ? dataUpdate._end - gap : 0;
	         }*/
	
	        if (existing && existing.item) {
	            items = existing.item.slice();
	            //todo add validity checks (no gaps etc)
	            //ToDo: Wrong Display in Lists, cause length is e.g. 5 and no item is in array, if no data was fetched.
	            if (items.length < Math.max(existing._end, dataUpdate._end)) {
	                items.length = Math.max(existing._end, dataUpdate._end);
	            }
	
	            if (items.length > dataUpdate._count) {
	                items.length = dataUpdate._count;
	            }
	
	            var i = dataUpdate._start;
	            dataUpdate.item.forEach(function (e) {
	                items[i++] = e;
	            });
	        } else {
	            items = dataUpdate.item;
	        }
	
	        return {
	            name: existing.name,
	            className: existing.className,
	            api: dataUpdate.api || existing.api,
	            query: query,
	            item: items,
	            _count: dataUpdate._count,
	            _start: existing._start,
	            _end: dataUpdate._end,
	            _more: dataUpdate._more,
	            _backup: null,
	            _loading: false,
	            _invalid: false,
	            _asyncKey: false,
	            _error: null,
	            __STORE: existing.__STORE
	        };
	    };
	
	    RemoteDataStore.updateItem = function updateItem(existing, dataUpdate) {
	        return _extends({}, existing, {
	            item: dataUpdate,
	            _backup: null,
	            _loading: false,
	            _invalid: false,
	            _asyncKey: false,
	            _error: null
	        });
	    };
	
	    RemoteDataStore.remoteStatetoDataArray = function remoteStatetoDataArray(remote) {
	        return Object.keys(remote).map(function (name) {
	            return remote[name];
	        });
	    };
	
	    RemoteDataStore.prototype.containsRemoteData = function containsRemoteData(name) {
	        var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	        return !!RemoteDataStore.getData(this.getRemoteState(), name, className);
	    };
	
	    RemoteDataStore.prototype.getInitialState = function getInitialState() {
	        return { remote: {} };
	    };
	
	    RemoteDataStore.prototype.refreshContainedClassNames = function refreshContainedClassNames(remote) {
	        var _this2 = this;
	
	        var classNameMap = {};
	        RemoteDataStore.remoteStatetoDataArray(remote).forEach(function (d) {
	            [].concat(_this2.getDataClassNames(d)).forEach(function (nc) {
	                return classNameMap[nc] = true;
	            });
	        });
	        this.containedClassnames = classNameMap;
	    };
	
	    RemoteDataStore.prototype.getDataClassNames = function getDataClassNames(d) {
	        return d.className;
	    };
	
	    RemoteDataStore.prototype.getContainedClassnames = function getContainedClassnames() {
	        return this.containedClassnames;
	    };
	
	    RemoteDataStore.prototype.getRemoteState = function getRemoteState() {
	        return this.getState().remote;
	    };
	
	    RemoteDataStore.prototype.getRequiredRemoteDataUpdates = function getRequiredRemoteDataUpdates() {
	        return RemoteDataStore.remoteStatetoDataArray(this.getRemoteState()).filter(function (d) {
	            return d._invalid && !d._loading && !d._error;
	        });
	    };
	
	    RemoteDataStore.prototype.isActive = function isActive() {
	        //ToDo: Listeners will be wired by FluxContaienr after super.componentDidMount was called
	        //https://github.com/facebook/flux/blob/master/src/FluxContainer.js
	        //return this.__emitter.listeners('change').length > 0;
	        return true;
	    };
	
	    RemoteDataStore.prototype.getRemoteData = function getRemoteData(name) {
	        (0, _warning2.default)(name, 'getRemoteData without name');
	        return this.getRemoteState()[name];
	    };
	
	    RemoteDataStore.prototype.getDataBackup = function getDataBackup(name) {
	        return this.getRemoteState()[name]._backup;
	    };
	
	    RemoteDataStore.prototype.initList = function initList(state, name, data, defaultListData) {
	        data = RemoteDataStore.initDataList(name, data, defaultListData, this);
	        if (__DEBUG__) {
	            console.debug('RemoteDataStore initList ', {
	                'api': data.api,
	                name: name,
	                data: data,
	                defaultListData: defaultListData,
	                currentListState: state.remote[name]
	            });
	        }
	        data = RemoteDataStore.handleExisting(state.remote, data);
	        if (data) {
	            var remote = RemoteDataStore.setData(state.remote, data);
	            return this.doSetRemoteState(state, remote);
	        } else {
	            return state;
	        }
	    };
	
	    RemoteDataStore.prototype.initItem = function initItem(state, name, data, defaultItemData) {
	        data = RemoteDataStore.initDataItem(name, data, defaultItemData, this);
	        if (__DEBUG__) {
	            console.debug('RemoteDataStore initItem ', {
	                name: name,
	                data: data,
	                defaultItemData: defaultItemData,
	                currentListState: state.remote[name]
	            });
	        }
	        data = RemoteDataStore.handleExisting(state.remote, data);
	        if (data) {
	            var remote = RemoteDataStore.setData(state.remote, data);
	            return this.doSetRemoteState(state, remote);
	        } else {
	            return state;
	        }
	    };
	
	    RemoteDataStore.prototype.removeRemoteData = function removeRemoteData(state, name) {
	        var remote = RemoteDataStore.removeRemoteData(state.remote, name);
	        return this.doSetRemoteState(state, remote);
	    };
	
	    RemoteDataStore.prototype.validateRemoteState = function validateRemoteState(remote) {
	        var _this3 = this;
	
	        RemoteDataStore.remoteStatetoDataArray(remote).forEach(function (data) {
	            _this3.validateRemoteData(data);
	            (0, _warning2.default)(data === remote[data.name], 'invalid data name %s!=%s', data.name, remote[data.name].name);
	        });
	    };
	
	    RemoteDataStore.prototype.validateRemoteData = function validateRemoteData(data) {
	        checkValidData(data);
	        checkValidDataStore(data, this);
	    };
	
	    RemoteDataStore.prototype.doSetRemoteState = function doSetRemoteState(state, remote) {
	        this.validateRemoteState(remote);
	        this.refreshContainedClassNames(remote);
	        return _extends({}, state, {
	            remote: remote
	        });
	    };
	
	    RemoteDataStore.prototype.reduce = function reduce(state, action) {
	        var remote = state.remote,
	            data = void 0,
	            newData = void 0;
	
	        switch (action.type) {
	
	            case _ActionTypesCommon2.default.DATA_ASYNC:
	                data = RemoteDataStore.getData(remote, action.meta.name, action.meta.className);
	
	                if (data) {
	                    // We have dependency problems when we do this!
	                    // this.getDispatcher().waitFor([ AsyncOperationStore.getDispatchToken() ]);
	                    var asyncKey = action.meta.key;
	
	                    switch (action.meta.asyncState) {
	                        case _AsyncState2.default.REQUESTED:
	                            newData = RemoteDataStore.updateFlag(data, { _loading: true, _asyncKey: asyncKey });
	                            break;
	
	                        case _AsyncState2.default.SUCCESS:
	                            if (data._asyncKey === asyncKey) {
	                                newData = this.asyncSuccess(data, action.payload);
	                                (0, _warning2.default)(!newData._loading, 'Loading after success');
	                            } else {
	                                console.error('Ignore invalid async ', data, action);
	                            }
	                            break;
	
	                        case _AsyncState2.default.ERROR:
	                            if (data._asyncKey === asyncKey) {
	                                newData = RemoteDataStore.resoreBackup(data, action.payload);
	                                (0, _warning2.default)(!newData._loading, 'Loading after error');
	                            } else {
	                                console.error('Ignore invalid async ', data, action);
	                            }
	
	                            break;
	                        //no default
	                    }
	                }
	
	                break;
	
	            case _ActionTypesCommon2.default.MORE_ITEMS:
	                data = RemoteDataStore.getData(remote, action.meta.name, action.meta.className);
	                if (data) {
	                    var offset = action && action.payload && action.payload.query && action.payload.query.offset || undefined;
	                    newData = RemoteDataStore.moreItems(data, offset);
	                }
	                break;
	
	            case _ActionTypesCommon2.default.DATA_UPDATE_MESSAGE:
	                remote = this.websocketModelUpdate(remote, action.payload);
	                break;
	
	            case _ActionTypesCommon2.default.DATA_INVALIDATE:
	                data = RemoteDataStore.getData(remote, action.meta.name, action.meta.className);
	                if (data) {
	                    newData = RemoteDataStore.invalidateData(data);
	                }
	                break;
	
	            //no default
	        }
	
	        if (newData) {
	            remote = RemoteDataStore.setData(remote, newData);
	        }
	
	        if (state.remote !== remote) {
	            if (__DEBUG__) {
	                console.debug(this.constructor.name, {
	                    type: action.type,
	                    action: action,
	                    remote: state.remote,
	                    newRemote: remote
	                });
	            }
	            state = this.doSetRemoteState(state, remote);
	        }
	
	        return state;
	    };
	
	    RemoteDataStore.prototype.asyncSuccess = function asyncSuccess(data, dataUpdate) {
	        if (isItem(data)) {
	            return RemoteDataStore.updateItem(data, dataUpdate);
	        } else {
	            return RemoteDataStore.updateList(data, dataUpdate);
	        }
	    };
	
	    RemoteDataStore.prototype.websocketModelUpdate = function websocketModelUpdate(remote, wsUpdate) {
	        var _this4 = this;
	
	        var newRemote = void 0;
	        var wsUpdates = [];
	        if (!Array.isArray(wsUpdate)) {
	            wsUpdates.push(wsUpdate);
	        } else {
	            wsUpdate.forEach(function (wsEvent) {
	                if (wsEvent instanceof String) {
	                    wsUpdates.push(JSON.parse(wsEvent));
	                } else {
	                    wsUpdates.push(wsEvent);
	                }
	            });
	        }
	
	        var processedListNames = [];
	
	        wsUpdates.forEach(function (wsUpdate) {
	
	            if (wsUpdate.eventType === 'POST' || wsUpdate.eventType === 'PUT' || wsUpdate.eventType === 'PATCH' || wsUpdate.eventType === 'PATCH-MERGE' || wsUpdate.eventType === 'DELETE' || wsUpdate.eventType === 'DELETE') {
	                RemoteDataStore.remoteStatetoDataArray(remote).filter(function (d) {
	                    return d.className === wsUpdate.type || wsUpdate.metadata && d.className === wsUpdate.metadata.attachedClassName;
	                }).forEach(function (d) {
	                    var o = d;
	                    var wasProcessed = processedListNames.indexOf(o.name) >= 0;
	                    if (isList(o) && !wasProcessed && _this4.shouldUpdateList(o, wsUpdate)) {
	                        if (__DEBUG__) {
	                            console.debug('Update', wsUpdate, '==> invalidate list', o);
	                        }
	                        d = RemoteDataStore.invalidateData(o);
	                    } else if (o && o.item && o.item.id == wsUpdate.id) {
	                        console.debug('Update', wsUpdate, '==> invalidate corresponding item', o);
	                        if (wsUpdate.eventType === 'POST') {
	                            console.error('Model-Update->', wsUpdate, ' for existing object', wsUpdate, o);
	                        } else if (wsUpdate.eventType === 'DELETE') {
	                            d = RemoteDataStore.updateFlag(o, {
	                                _deleted: true,
	                                _error: null,
	                                _loading: false,
	                                _invalid: false
	                            });
	                        } else {
	                            d = RemoteDataStore.invalidateData(o);
	                        }
	                    } else if (wsUpdate.metadata && o && o.item && o.item.id === wsUpdate.metadata.attachedClassPK) {
	                        console.debug('Update', wsUpdate, '==> invalidate item (attached)', o);
	                        d = RemoteDataStore.invalidateData(o);
	                    }
	
	                    if (o !== d) {
	                        newRemote = newRemote || (newRemote = _extends({}, remote));
	                        newRemote[o.name] = d;
	                        processedListNames.push(o.name);
	                    }
	                });
	
	                RemoteDataStore.remoteStatetoDataArray(remote).filter(function (d) {
	                    return isAttachedList(d, wsUpdate);
	                }).forEach(function (d) {
	                    var o = d;
	                    console.debug('Update', wsUpdate, '==> invalidate item (attached List)', o);
	                    d = RemoteDataStore.invalidateData(o);
	                    if (d !== o) {
	                        newRemote = newRemote || (newRemote = _extends({}, remote));
	                        newRemote[d.name] = d;
	                    }
	                });
	            } else if (!wsUpdate.metric) {
	                console.warn('Unknown update type: ', wsUpdate);
	            }
	        });
	
	        if (this.extendedWebsocketModelUpdate) {
	            newRemote = this.extendedWebsocketModelUpdate(newRemote || remote, wsUpdate);
	        }
	
	        return newRemote || remote;
	    };
	
	    RemoteDataStore.prototype.shouldUpdateList = function shouldUpdateList(d, wsUpdate) {
	        // debugger;
	        //TODO implement
	        if (d.className === wsUpdate.type) {
	            return true;
	        } else if (wsUpdate.metadata && d.className === wsUpdate.metadata.attachedClassName) {
	            return true;
	        }
	        return false;
	    };
	
	    return RemoteDataStore;
	}(_FluxReduceStore3.default);
	
	exports.default = RemoteDataStore;

/***/ }),
/* 99 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shallowEqual
	 * @typechecks
	 *
	 */
	
	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.shallowEqual = shallowEqual;
	exports.equal = equal;
	exports.equalArray = equalArray;
	exports.shallowContains = shallowContains;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	    return equal(objA, objB);
	}
	
	exports.default = shallowEqual;
	function equal(objA, objB) {
	    var equal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if ((typeof objA === 'undefined' ? 'undefined' : _typeof(objA)) !== 'object' || objA === null || (typeof objB === 'undefined' ? 'undefined' : _typeof(objB)) !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if (keysA.length !== keysB.length) {
	        return false;
	    }
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = hasOwnProperty.bind(objB);
	    for (var i = 0; i < keysA.length; i++) {
	        var key = keysA[i];
	        var oA = objA[key];
	        var oB = objB[key];
	        if (!bHasOwnProperty(key) || (equal ? !equal(oA, oB, key) : oB !== oA)) {
	            return false;
	        }
	    }
	
	    return true;
	}
	
	function equalArray(o1, o2) {
	    var equal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	    if (equal) {
	        return o1 && o2 && o1.length === o2.length && o1.findIndex(function (p1, idx) {
	            return !equal(p1, o2[idx]);
	        }) < 0;
	    }
	    return o1 && o2 && o1.length === o2.length && o1.findIndex(function (p1, idx) {
	        return p1 !== o2[idx];
	    }) < 0;
	}
	
	/**
	 * Checks if every prop in b is also existing in a and if it the same value.
	 *
	 * Examples:
	 * a={} b={foo: 'bar'} => shallowContains(a, b) => false
	 * a={foo: 'bar'} b={foo: 'bar'} => shallowContains(a, b) => true
	 * a={foo: 'bar'} b={foo: 'rab'} => shallowContains(a, b) => false
	 */
	function shallowContains(a, b) {
	    return Object.keys(b).findIndex(function (k) {
	        return a[k] !== b[k];
	    }) < 0;
	}

/***/ }),
/* 100 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.generateId = generateId;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 23.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var lastId = 0;
	
	function generateId(prefix) {
	    return (prefix || 'uid_') + lastId++;
	}
	
	exports.default = {
	    generateId: generateId
	};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = deepMerge;
	/**
	 * Created by Carsten Hibbeler on 13.05.2016.
	 * https://github.com/KyleAMathews/deepmerge
	 */
	function deepMerge(target, src) {
	    var array = Array.isArray(src);
	    var dst = array && [] || {};
	    if (array) {
	        target = target || [];
	        dst = dst.concat(target);
	        src.forEach(function (e, i) {
	            if (typeof dst[i] === 'undefined') {
	                dst[i] = e;
	            } else if ((typeof e === 'undefined' ? 'undefined' : _typeof(e)) === 'object') {
	                dst[i] = deepMerge(target[i], e);
	            } else {
	                if (target.indexOf(e) === -1) {
	                    dst.push(e);
	                }
	            }
	        });
	    } else {
	        if (target && (typeof target === 'undefined' ? 'undefined' : _typeof(target)) === 'object') {
	            Object.keys(target).forEach(function (key) {
	                dst[key] = target[key];
	            });
	        }
	        Object.keys(src).forEach(function (key) {
	            if (_typeof(src[key]) !== 'object' || !src[key]) {
	                dst[key] = src[key];
	            } else {
	                if (!target[key]) {
	                    dst[key] = src[key];
	                } else {
	                    dst[key] = deepMerge(target[key], src[key]);
	                }
	            }
	        });
	    }
	
	    return dst;
	}

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ComputedQueryParamsDataStore = __webpack_require__(97);
	
	var _ComputedQueryParamsDataStore2 = _interopRequireDefault(_ComputedQueryParamsDataStore);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _apiUtil = __webpack_require__(77);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Hibbeler on 21.01.2016.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ClassRemoteDataStore = function (_ComputedQueryParamsD) {
	    _inherits(ClassRemoteDataStore, _ComputedQueryParamsD);
	
	    function ClassRemoteDataStore(dispatcher, className, defaultListApi, defaultItemApi) {
	        _classCallCheck(this, ClassRemoteDataStore);
	
	        var _this = _possibleConstructorReturn(this, _ComputedQueryParamsD.call(this, dispatcher));
	
	        _this.className = className;
	        _this.defaultListData = _extends({}, _this.defaultListData, { api: (0, _apiUtil.apiName)(defaultListApi), className: className });
	        _this.defaultItemData = _extends({}, _this.defaultItemData, { api: (0, _apiUtil.apiName)(defaultItemApi), className: className });
	        return _this;
	    }
	
	    ClassRemoteDataStore.prototype.getContainedClassnames = function getContainedClassnames() {
	        var containedClassnames = _ComputedQueryParamsD.prototype.getContainedClassnames.call(this);
	        if (Object.keys(this.getRemoteState()).length > 0) {
	            containedClassnames[this.className] = true;
	            (0, _warning2.default)(Object.keys(containedClassnames).length === 1, 'Invalid classNames found');
	        }
	        return containedClassnames;
	    };
	
	    ClassRemoteDataStore.prototype.validateRemoteData = function validateRemoteData(data) {
	        _ComputedQueryParamsD.prototype.validateRemoteData.call(this, data);
	        (0, _warning2.default)(this.className === data.className, 'Invalid className:%s only %s allowed', data.className, this.className);
	    };
	
	    ClassRemoteDataStore.prototype.reduce = function reduce(state, action) {
	        var name = void 0,
	            className = void 0;
	
	        switch (action.type) {
	
	            case _ActionTypesCommon2.default.DATA_LIST_INIT:
	                var _action$meta = action.meta;
	                name = _action$meta.name;
	                className = _action$meta.className;
	
	                if (this.className === className) {
	                    var data = action.payload;
	                    return this.initList(state, name, data, this.defaultListData);
	                }
	                break;
	            case _ActionTypesCommon2.default.DATA_ITEM_INIT:
	                var _action$meta2 = action.meta;
	                name = _action$meta2.name;
	                className = _action$meta2.className;
	
	                if (this.className === className) {
	                    return this.initItem(state, name, action.payload, this.defaultItemData);
	                }
	                break;
	            case _ActionTypesCommon2.default.DATA_REMOVE:
	                var _action$meta3 = action.meta;
	                name = _action$meta3.name;
	                className = _action$meta3.className;
	
	                if (this.className === className) {
	                    return this.removeRemoteData(state, name);
	                }
	                break;
	        }
	
	        return _ComputedQueryParamsD.prototype.reduce.call(this, state, action);
	    };
	
	    return ClassRemoteDataStore;
	}(_ComputedQueryParamsDataStore2.default);
	
	exports.default = ClassRemoteDataStore;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ClassRemoteDataStore2 = __webpack_require__(102);
	
	var _ClassRemoteDataStore3 = _interopRequireDefault(_ClassRemoteDataStore2);
	
	var _RemoteDataStore = __webpack_require__(98);
	
	var _RemoteDataStore2 = _interopRequireDefault(_RemoteDataStore);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 23.03.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var equalSeries = function equalSeries(s1, s2) {
	    return s1.metric === s2.metric && (0, _shallowEqual2.default)(s1.labels, s2.labels);
	};
	
	function checkDistinctOrder(a) {
	    if (!a.every(function (c, i) {
	        var e = i === 0 || a[i - 1] < c;
	        if (!e) {
	            console.error('checkDistinctOrder no element in a');
	        }
	        return e;
	    })) {
	        console.error('Invalid timestamps');
	    }
	}
	
	var TimeSeriesRemoteDataStore = function (_ClassRemoteDataStore) {
	    _inherits(TimeSeriesRemoteDataStore, _ClassRemoteDataStore);
	
	    function TimeSeriesRemoteDataStore() {
	        _classCallCheck(this, TimeSeriesRemoteDataStore);
	
	        return _possibleConstructorReturn(this, _ClassRemoteDataStore.apply(this, arguments));
	    }
	
	    TimeSeriesRemoteDataStore.prototype.initItem = function initItem() {
	        throw new Error('Only List data supported');
	    };
	
	    TimeSeriesRemoteDataStore.prototype.asyncSuccess = function asyncSuccess(data, update) {
	        (0, _warning2.default)((0, _RemoteDataStore.isList)(data), 'Only List data supported');
	
	        if (!update.changesSince) {
	            //first data
	            data = _RemoteDataStore2.default.updateList(data, update);
	        } else {
	            data = this.updateMetrics(data, update);
	        }
	
	        //TODO: Fix with deep copy ?
	        // data._requestTime = update._requestTime; //remember the request time for updates
	        data.query = _extends({}, data.query, {
	            changesSince: update._requestTime
	        });
	        //data._invalid = true;
	        return data;
	    };
	
	    TimeSeriesRemoteDataStore.prototype.updateMetrics = function updateMetrics(existing, update) {
	        var _this2 = this;
	
	        var newData = _extends({}, existing, {
	            _loading: false,
	            _invalid: false,
	            _backup: null
	        });
	
	        if (update.item.findIndex(function (series) {
	            return series.times.length > 0;
	        }) < 0) {
	            console.info('Empty timeseries update', update);
	            return newData;
	        }
	
	        newData.item = existing.item.slice();
	
	        update.item.forEach(function (m) {
	            var idx = newData.item.findIndex(function (em) {
	                return equalSeries(m, em);
	            });
	            if (idx >= 0) {
	                if (false) {
	                    var temp = _this2.updateMetric(newData.item[idx], m);
	                    checkDistinctOrder(temp.times);
	                }
	
	                newData.item[idx] = _this2.updateMetric(newData.item[idx], m);
	            } else {
	                console.warn('New series', m);
	                newData.item.push(m);
	                newData._count++;
	                newData._end++;
	                update._requestTime = null; //i think in this situation we should update all data to get the full new data
	            }
	        });
	
	        return newData;
	    };
	
	    TimeSeriesRemoteDataStore.prototype.updateMetric = function updateMetric(series, update) {
	        if (update.times.length > 0) {
	
	            if (update.times[0] > series.times[series.times.length - 1]) {
	
	                series = _extends({}, series, {
	                    meta: update.meta,
	                    times: series.times.concat(update.times),
	                    values: series.values.concat(update.values)
	                });
	            } else {
	                series = this._multiUpdate(series, update);
	            }
	        }
	        return series;
	    };
	
	    TimeSeriesRemoteDataStore.prototype._multiUpdate = function _multiUpdate(series, update) {
	        var utimes = update.times,
	            otimes = series.times,
	            uvalues = update.values,
	            ovalues = series.values;
	        var ntimes = [],
	            nvalues = [],
	            ut = utimes[0],
	            ot = otimes[0],
	            unchanged = 0,
	            ni = 0;
	
	        // ntimes.length = nvalues.length = utimes.length + otimes.length;
	
	        for (var ui = 0, oi = 0; ui < utimes.length || oi < otimes.length; ni++) {
	            if (ut < ot) {
	                ntimes[ni] = ut;
	                nvalues[ni] = uvalues[ui];
	                ui++;
	                ut = ui < utimes.length ? utimes[ui] : Number.MAX_VALUE;
	            } else if (ut > ot) {
	                ntimes[ni] = ot;
	                nvalues[ni] = ovalues[oi];
	                oi++;
	                ot = oi < otimes.length ? otimes[oi] : Number.MAX_VALUE;
	            } else {
	                ntimes[ni] = ut;
	                nvalues[ni] = uvalues[ui];
	                ui++;
	                oi++;
	                unchanged++;
	            }
	        }
	
	        (0, _warning2.default)(ni === ntimes.length && ni === utimes.length + otimes.length - unchanged, 'Unexpected update state!');
	
	        if (unchanged === utimes.length) {
	            if ((0, _shallowEqual2.default)(series.meta, update.meta)) {
	                console.warn('Unchanged series update from ', series, 'to', update);
	                return series;
	            } else {
	                ntimes = otimes;
	                nvalues = ovalues;
	            }
	        }
	
	        return _extends({}, series, {
	            meta: update.meta,
	            times: ntimes,
	            values: nvalues
	        });
	    };
	
	    return TimeSeriesRemoteDataStore;
	}(_ClassRemoteDataStore3.default);
	
	exports.default = TimeSeriesRemoteDataStore;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getAsyncOperationStore = getAsyncOperationStore;
	exports.getFormStore = getFormStore;
	exports.getConfigStore = getConfigStore;
	exports.getLocalConfigStore = getLocalConfigStore;
	
	var _AsyncOperationStore = __webpack_require__(105);
	
	var _AsyncOperationStore2 = _interopRequireDefault(_AsyncOperationStore);
	
	var _FormStore = __webpack_require__(106);
	
	var _FormStore2 = _interopRequireDefault(_FormStore);
	
	var _ConfigStore = __webpack_require__(85);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _LocalConfigStore = __webpack_require__(107);
	
	var _LocalConfigStore2 = _interopRequireDefault(_LocalConfigStore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 28.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	
	var asyncOperationStoreInstance = void 0;
	
	function getAsyncOperationStore(AppContext) {
	    return asyncOperationStoreInstance || (asyncOperationStoreInstance = AppContext.createStore(_AsyncOperationStore2.default));
	}
	
	var formStoreInstance = void 0;
	
	function getFormStore(AppContext) {
	    return formStoreInstance || (formStoreInstance = AppContext.createStore(_FormStore2.default));
	}
	
	var configStoreInstance = void 0;
	
	function getConfigStore(AppContext) {
	    return configStoreInstance || (configStoreInstance = AppContext.createStore(_ConfigStore2.default));
	}
	
	var localConfigStoreInstance = void 0;
	
	function getLocalConfigStore(AppContext) {
	    return localConfigStoreInstance || (localConfigStoreInstance = AppContext.createStore(_LocalConfigStore2.default));
	}

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _FluxReduceStore2 = __webpack_require__(87);
	
	var _FluxReduceStore3 = _interopRequireDefault(_FluxReduceStore2);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 05.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var AsyncOperationStore = function (_FluxReduceStore) {
	    _inherits(AsyncOperationStore, _FluxReduceStore);
	
	    function AsyncOperationStore() {
	        _classCallCheck(this, AsyncOperationStore);
	
	        return _possibleConstructorReturn(this, _FluxReduceStore.apply(this, arguments));
	    }
	
	    AsyncOperationStore.prototype.getOperation = function getOperation(key) {
	        return this.getState().operationsByKey[key];
	    };
	
	    AsyncOperationStore.prototype.getOperations = function getOperations() {
	        return this.getState().operations;
	    };
	
	    AsyncOperationStore.prototype.getInitialState = function getInitialState() {
	        return {
	            operations: [],
	            operationsByKey: {}
	        };
	    };
	
	    AsyncOperationStore.prototype.reduce = function reduce(state, action) {
	        var _extends2;
	
	        if (action.meta && action.meta.asyncState) {
	            var _action$meta = action.meta,
	                key = _action$meta.key,
	                asyncState = _action$meta.asyncState;
	
	            (0, _warning2.default)(key, 'Async key expected');
	
	            switch (asyncState) {
	                case _AsyncState2.default.REQUESTED:
	                    //todo use meta.className & meta.name to abort existing operations
	
	                    return this.mutateOperation(state, key, {
	                        requestPayload: _extends({}, action.payload, (_extends2 = {}, _extends2['item'] = null, _extends2)),
	                        key: key,
	                        asyncState: asyncState
	                    });
	
	                case _AsyncState2.default.SUCCESS:
	                    return this.mutateOperation(state, key, {
	                        asyncState: asyncState
	                    });
	
	                case _AsyncState2.default.ERROR:
	                    console.warn('AsyncState.ERROR', action);
	                    return this.mutateOperation(state, key, {
	                        asyncState: asyncState,
	                        error: action.payload
	                    });
	                default:
	                    console.warn('Unkown async state: ', action);
	
	            }
	        }
	
	        return state;
	    };
	
	    AsyncOperationStore.prototype.mutateOperation = function mutateOperation(state, key, source) {
	        var _extends3;
	
	        var current = state.operationsByKey[key],
	            newOp = _extends({}, current, source);
	        return {
	            operations: current ? state.operations.map(function (op) {
	                return op === current ? newOp : op;
	            }) : state.operations.concat(newOp),
	            operationsByKey: _extends({}, state.operationsByKey, (_extends3 = {}, _extends3[key] = newOp, _extends3))
	        };
	    };
	
	    return AsyncOperationStore;
	}(_FluxReduceStore3.default);
	
	exports.default = AsyncOperationStore;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _AsyncState = __webpack_require__(72);
	
	var _AsyncState2 = _interopRequireDefault(_AsyncState);
	
	var _appContext = __webpack_require__(67);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _RemoteDataStore2 = __webpack_require__(98);
	
	var _RemoteDataStore3 = _interopRequireDefault(_RemoteDataStore2);
	
	var _StoreFactory = __webpack_require__(104);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by Carsten Bühler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * User: CBuehler on 05.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright: xdot GmbH 2015
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var AsyncOperationStore = (0, _StoreFactory.getAsyncOperationStore)(_appContext.AppContext);
	
	var FormStore = function (_RemoteDataStore) {
	    _inherits(FormStore, _RemoteDataStore);
	
	    function FormStore(dispatcher) {
	        _classCallCheck(this, FormStore);
	
	        return _possibleConstructorReturn(this, _RemoteDataStore.call(this, dispatcher));
	    }
	
	    FormStore.prototype.isEditing = function isEditing(formId) {
	        var form = this.getEditFormState(formId);
	        return !!(form && form.isEditing);
	    };
	
	    FormStore.prototype.isSaving = function isSaving(formId) {
	        var form = this.getEditFormState(formId);
	        return !!(form && form.isSaving);
	    };
	
	    FormStore.prototype.getEditFormState = function getEditFormState(formId) {
	        return this.getState().editForms[formId];
	    };
	
	    FormStore.prototype.isEdited = function isEdited(formId) {
	        var form = this.getEditFormState(formId);
	        return form && form.editItem !== form.originalItem;
	    };
	
	    FormStore.prototype.hasChangedRemotely = function hasChangedRemotely(formId) {
	        var form = this.getEditFormState(formId),
	            current = form.remoteItemName && this.getRemoteData(form.remoteItemName);
	        return current && form.originalItem !== current.item;
	    };
	
	    FormStore.prototype.getItem = function getItem(formId) {
	        var form = this.getEditFormState(formId);
	        return form && form.editItem;
	    };
	
	    FormStore.prototype.getOriginalItem = function getOriginalItem(formId) {
	        var form = this.getEditFormState(formId);
	        return form && form.originalItem;
	    };
	
	    FormStore.prototype.getValidation = function getValidation(formId) {
	        var form = this.getEditFormState(formId);
	        return form && form.validation;
	    };
	
	    FormStore.prototype.getError = function getError(formId) {
	        var form = this.getEditFormState(formId);
	        return form && form.error;
	    };
	
	    FormStore.prototype.getCurrentOperation = function getCurrentOperation(formId) {
	        var operation = this.getEditFormState(formId).currentOperation;
	        return operation && _appContext.AppContext.getStore('AsyncOperationStore').getOperation(operation);
	    };
	
	    FormStore.prototype.getInitialState = function getInitialState() {
	        return _extends({}, _RemoteDataStore.prototype.getInitialState.call(this), {
	            editForms: {}
	        });
	    };
	
	    FormStore.prototype._isForm = function _isForm(formId) {
	        return !!this.getEditFormState(formId);
	    };
	
	    FormStore.prototype._checkEditing = function _checkEditing(formId, editing) {
	        var form = this.getEditFormState(formId);
	        if (form.isEditing !== editing) {
	            console.error('Form editing is not ' + editing, form);
	        }
	    };
	
	    FormStore.prototype.reduce = function reduce(state, action) {
	
	        switch (action.type) {
	
	            case _ActionTypesCommon2.default.START_EDIT_IN_FORM:
	                return this.constructor.startEditFormItem(state, action, this);
	
	            case _ActionTypesCommon2.default.RESET_FORM:
	                return this.constructor.resetFormItem(state, action);
	
	            case _ActionTypesCommon2.default.END_EDIT_IN_FORM:
	                if (this._isForm(action.meta.formId)) {
	                    this._checkEditing(action.meta.formId, true);
	                    return this.constructor.stopEditFormItem(state, action);
	                }
	                break;
	
	            case _ActionTypesCommon2.default.EDIT_IN_FORM:
	                if (this._isForm(action.meta.formId)) {
	                    this._checkEditing(action.meta.formId, true);
	                    return this.constructor.changedFormItem(state, action);
	                } else {
	                    console.error("Editing non existing Form");
	                }
	                break;
	
	            case _ActionTypesCommon2.default.SUBMIT_FORM_ASYNC:
	                {
	                    var _action$meta = action.meta,
	                        asyncState = _action$meta.asyncState,
	                        key = _action$meta.key,
	                        formId = _action$meta.formId;
	
	
	                    if (this._isForm(formId)) {
	                        this._checkEditing(formId, true);
	                        this.getDispatcher().waitFor([AsyncOperationStore.getDispatchToken()]);
	
	                        switch (asyncState) {
	                            case _AsyncState2.default.REQUESTED:
	                                return this.constructor.mutateForm(state, action, {
	                                    currentOperation: key,
	                                    isSaving: true,
	                                    error: null
	                                });
	                            case _AsyncState2.default.SUCCESS:
	                                if (action.meta.closeForm) {
	                                    return this.constructor.stopEditFormItem(state, action);
	                                } else {
	                                    return this.constructor.mutateForm(state, action, {
	                                        isEditing: true,
	                                        isSaving: false,
	                                        error: null
	                                    });
	                                }
	                            case _AsyncState2.default.ERROR:
	                                return this.constructor.mutateForm(state, action, {
	                                    isEditing: true,
	                                    isSaving: false,
	                                    error: action.payload
	                                });
	                            //no default
	                        }
	                    }
	                    break;
	                }
	
	            default:
	                {
	                    var meta = action.meta;
	
	                    if (meta && meta.formId && this._isForm(meta.formId)) {
	                        this._checkEditing(meta.formId, true);
	                        this.getDispatcher().waitFor([AsyncOperationStore.getDispatchToken()]);
	
	                        switch (meta.asyncState) {
	                            case _AsyncState2.default.SUCCESS:
	                                return this.constructor.mutateForm(state, action, {
	                                    isEditing: !action.meta.closeForm
	                                });
	                            case _AsyncState2.default.ERROR:
	                                return this.constructor.mutateForm(state, action, {
	                                    isEditing: true,
	                                    error: action.payload
	                                });
	                            //no default
	                        }
	                    }
	                    break;
	                }
	
	        }
	
	        return state;
	    };
	
	    FormStore.resetFormItem = function resetFormItem(state, action) {
	        var _extends2;
	
	        var editForms = state.editForms,
	            formId = action.meta.formId,
	            form = editForms[formId];
	
	        return state = _extends({}, state, {
	            editForms: _extends({}, editForms, (_extends2 = {}, _extends2[formId] = _extends({}, form, {
	                editItem: form.originalItem,
	                validation: {}
	            }), _extends2))
	
	        });
	    };
	
	    FormStore.startEditFormItem = function startEditFormItem(state, action, store) {
	        var _extends3;
	
	        var editForms = state.editForms,
	            formId = action.meta.formId,
	            form = editForms[formId],
	            originalItem = action.payload;
	
	        var remote = state.remote,
	            remoteItemName = void 0;
	
	        (0, _warning2.default)(!form || !form.isEditing, 'Form editing is editing');
	
	        if (originalItem.api) {
	            remoteItemName = formId + '_currentRemote';
	            _RemoteDataStore3.default.initDataItem(remoteItemName, originalItem, undefined, store);
	            //remote = RemoteReducer.initOrUpdateItem(state.remote, initAction.data);
	            //var initAction= RemoteDataActions.CommonRemoteActionExtends.item('currentRemote', item);
	        } else {
	            console.warn('No api provided ==> Cannot listen to remote state', action);
	        }
	
	        return _extends({}, state, {
	            remote: remote,
	            editForms: _extends({}, editForms, (_extends3 = {}, _extends3[formId] = {
	                remoteItemName: remoteItemName,
	                originalItem: originalItem.item || originalItem,
	                editItem: originalItem.item || originalItem,
	                validation: {},
	                isEditing: true,
	                isSaving: false
	            }, _extends3))
	
	        });
	    };
	
	    FormStore.stopEditFormItem = function stopEditFormItem(state, action) {
	        var editForms = _extends({}, state.editForms);
	
	        delete editForms[action.meta.formId];
	
	        return _extends({}, state, {
	            editForms: editForms
	        });
	    };
	
	    FormStore.mutateForm = function mutateForm(state, action, source) {
	        var _extends4;
	
	        var editForms = state.editForms,
	            formId = action.meta.formId,
	            form = editForms[formId];
	
	        return _extends({}, state, {
	            editForms: _extends({}, editForms, (_extends4 = {}, _extends4[formId] = _extends({}, form, source), _extends4))
	
	        });
	    };
	
	    FormStore.changedFormItem = function changedFormItem(state, action) {
	        var _extends5;
	
	        var editForms = state.editForms,
	            formId = action.meta.formId,
	            form = editForms[formId],
	            item = action.payload && action.payload.item || action.data && action.data.item,
	            validation = action.payload && action.payload.validation || action.data && action.data.validation;
	
	        return state = _extends({}, state, {
	            editForms: _extends({}, editForms, (_extends5 = {}, _extends5[formId] = _extends({}, form, {
	                editItem: item,
	                validation: validation,
	                isEditing: true,
	                error: null
	            }), _extends5))
	
	        });
	    };
	
	    return FormStore;
	}(_RemoteDataStore3.default);
	
	exports.default = FormStore;

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _KeyStateStore2 = __webpack_require__(86);
	
	var _KeyStateStore3 = _interopRequireDefault(_KeyStateStore2);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 28.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var LocalConfigStore = function (_KeyStateStore) {
	    _inherits(LocalConfigStore, _KeyStateStore);
	
	    function LocalConfigStore() {
	        _classCallCheck(this, LocalConfigStore);
	
	        return _possibleConstructorReturn(this, _KeyStateStore.apply(this, arguments));
	    }
	
	    LocalConfigStore.prototype.getLocalConfig = function getLocalConfig(key) {
	        var v = this.getStateByKey(key);
	        if (!v) {
	            var vJson = localStorage[key];
	            v = vJson && JSON.parse(vJson);
	            if (v) {
	                _KeyStateStore.prototype.subStateSet.call(this, this.getState(), key, v);
	            }
	        }
	        return v;
	    };
	
	    LocalConfigStore.prototype.getKeyFromAction = function getKeyFromAction(action) {
	        return action.meta && action.meta.key;
	    };
	
	    LocalConfigStore.prototype.subStateSet = function subStateSet(state, key, subState) {
	        var nV = JSON.stringify(subState),
	            oV = localStorage[key];
	        if (nV !== oV) {
	            localStorage[key] = nV;
	            return _KeyStateStore.prototype.subStateSet.call(this, state, key, subState);
	        }
	        return state;
	    };
	
	    LocalConfigStore.prototype.getReducer = function getReducer(action) {
	        switch (action.type) {
	            case _ActionTypesCommon2.default.CONFIG_LOCAL_UPDATE:
	                return function (state, action) {
	                    return action.payload;
	                };
	        }
	    };
	
	    return LocalConfigStore;
	}(_KeyStateStore3.default);
	
	exports.default = LocalConfigStore;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = ValidationMessage;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ValidationMessage(props) {
	    var formValidation = props.formValidation,
	        propName = props.propName;
	
	
	    if (formValidation && formValidation[propName]) {
	        return _react2.default.createElement(
	            _reactBootstrap.Form.Text,
	            null,
	            formValidation[propName]
	        );
	    } else {
	        return null;
	    }
	} /**
	   * Created by Carsten Bühler
	   * User: c.buehler on 26.09.2016
	   * Copyright: xdot GmbH 2015
	   */
	
	ValidationMessage.propTypes = {
	    formValidation: _propTypes2.default.object,
	    propName: _propTypes2.default.string
	};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_109__;

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_110__;

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_111__;

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _ErrorBoundary = __webpack_require__(113);
	
	var _ErrorBoundary2 = _interopRequireDefault(_ErrorBoundary);
	
	var _appContext = __webpack_require__(67);
	
	var _ConfigActions = __webpack_require__(81);
	
	var _ConfigActions2 = _interopRequireDefault(_ConfigActions);
	
	var _FormActions = __webpack_require__(66);
	
	var _FormActions2 = _interopRequireDefault(_FormActions);
	
	var _StoreFactory = __webpack_require__(104);
	
	var _portletConfigUtil = __webpack_require__(84);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 28.01.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ConfigStore = (0, _StoreFactory.getConfigStore)(_appContext.AppContext);
	
	function closest(el, fn) {
	    return el && (fn(el) ? el : closest(el.parentNode, fn));
	}
	
	var PortletComponent = function (_React$Component) {
	    _inherits(PortletComponent, _React$Component);
	
	    function PortletComponent(props) {
	        _classCallCheck(this, PortletComponent);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.uid = props.portletId;
	        _this.portletId = props.portletId;
	        _this.plid = props.plid;
	        _this.hasConfig = props.hasConfig;
	        _this.ConfigForm = function (props) {
	            return _this.renderConfigForm(props);
	        };
	        _this.configFormId = _this.withCtx('ConfigForm');
	        _this.state = _this.getStateFromStores(props);
	        return _this;
	    }
	
	    PortletComponent.prototype.getChildContext = function getChildContext() {
	        return { contextId: '' + this.portletId };
	    };
	
	    PortletComponent.prototype.componentDidMount = function componentDidMount() {
	        var _this2 = this;
	
	        var _props = this.props,
	            scopeGroupId = _props.scopeGroupId,
	            plid = _props.plid,
	            portletId = _props.portletId,
	            initialConfig = _props.initialConfig,
	            hasConfig = _props.hasConfig;
	
	        if (hasConfig) {
	            this.removeListener = ConfigStore.addListener(this.onChange.bind(this));
	            if (initialConfig) {
	                //ConfigActions.updateConfig(scopeGroupId, plid, portletId, initialConfig, this._asyncOpt());
	                var prevConfig = ConfigStore.getConfig(scopeGroupId, plid, portletId) || {};
	                _ConfigActions2.default.setConfig(scopeGroupId, plid, portletId, initialConfig, function (initialConfig) {
	                    return _this2.configWillChange(prevConfig, initialConfig);
	                });
	            } else {
	                _ConfigActions2.default.loadConfig(scopeGroupId, plid, portletId, this._asyncOpt());
	            }
	        }
	
	        var widgetParentNode = _reactDom2.default.findDOMNode(this);
	        if (!widgetParentNode) {
	            widgetParentNode = document.getElementById('widget-container_' + portletId);
	        }
	        this.portletContainer = closest(widgetParentNode, function (el) {
	            return el.className && el.className.indexOf('portlet-container') >= 0;
	        });
	
	        if (this.portletContainer != null) {
	            this.setState({ portletContainerRender: true }); //Need to setState for re-rendering. state.portletContainer is used in render!
	        }
	    };
	
	    PortletComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.removeListener) {
	            this.removeListener.remove();
	        }
	    };
	
	    PortletComponent.prototype.onChange = function onChange() {
	        this.setState(this.getStateFromStores(this.props));
	    };
	
	    PortletComponent.prototype.onEditConfigClick = function onEditConfigClick() {
	        _FormActions2.default.startEditFormItem(this.configFormId, this.state.config);
	    };
	
	    PortletComponent.prototype.onConfigActionSuccess = function onConfigActionSuccess(action) {
	        var _props2 = this.props,
	            scopeGroupId = _props2.scopeGroupId,
	            plid = _props2.plid,
	            portletId = _props2.portletId,
	            config = action.payload;
	
	
	        if (this.isConfigurationNeeded(config)) {
	            console.warn('Load invalid configuration: ', config);
	        }
	        this.configWillChange(ConfigStore.getConfig(scopeGroupId, plid, portletId), config);
	    };
	
	    PortletComponent.prototype.onFormSubmit = function onFormSubmit(config) {
	        _ConfigActions2.default.updateConfig(this.props.scopeGroupId, this.props.plid, this.props.portletId, config, this._asyncOpt(this.configFormId));
	    };
	
	    PortletComponent.prototype.getStateFromStores = function getStateFromStores(props) {
	        var config = ConfigStore.getConfig(props.scopeGroupId, props.plid, props.portletId);
	        if (props && props.initialConfig) {
	            var newConfig = (0, _portletConfigUtil.parsePortletConfig)(_extends({}, props.initialConfig, config));
	            return { config: newConfig };
	        } else {
	            return {
	                config: config
	            };
	        }
	    };
	
	    PortletComponent.prototype.withCtx = function withCtx(s) {
	        return this.portletId + '.' + s;
	    };
	
	    PortletComponent.prototype.configWillChange = function configWillChange(prevConfig, nextConfig) {
	        console.warn('Implement configWillChange(prevConfig, nextConfig)', prevConfig, nextConfig);
	    };
	
	    PortletComponent.prototype._asyncOpt = function _asyncOpt(formId) {
	        return {
	            beforeSuccess: this.onConfigActionSuccess.bind(this),
	            meta: {
	                formId: formId,
	                closeForm: true
	            }
	        };
	    };
	
	    PortletComponent.prototype.isConfigurationNeeded = function isConfigurationNeeded(config) {
	        return false;
	    };
	
	    PortletComponent.prototype.render = function render() {
	        var config = this.state.config,
	            configurationNeeded = this.isConfigurationNeeded(config);
	
	
	        if (configurationNeeded && !config) {
	            return _react2.default.createElement(
	                'p',
	                { className: 'bg-warning' },
	                'Konfiguration konnte nicht geladen werden'
	            );
	        }
	
	        var classList = this.portletContainer && this.portletContainer.classList;
	
	        var showConfigPermission = false;
	        if (classList && classList.length > 0) {
	            for (var i in classList) {
	                if (!showConfigPermission) {
	                    showConfigPermission = classList[i] === 'show-config';
	                }
	            }
	        }
	
	        if (localStorage.dev) {
	            return 'Hier kommt später Inhalt';
	        }
	
	        return _react2.default.createElement(
	            _ErrorBoundary2.default,
	            null,
	            !configurationNeeded && this.renderPortlet(config),
	            this.hasConfig && showConfigPermission && configurationNeeded && _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', title: 'Konfigurieren',
	                    onClick: this.onEditConfigClick.bind(this) },
	                'Konfigurieren'
	            ),
	            this.hasConfig && !showConfigPermission && configurationNeeded && _react2.default.createElement(
	                'p',
	                null,
	                'Sie haben nicht das Recht das Widget zu konfigurieren!'
	            ),
	            this.hasConfig && showConfigPermission && _react2.default.createElement(
	                _reactBootstrap.Button,
	                { variant: 'primary', className: 'configOpener', title: 'Konfigurieren',
	                    onClick: this.onEditConfigClick.bind(this) },
	                _react2.default.createElement('span', { className: 'icon-fliwas-gear' })
	            ),
	            this.hasConfig && _react2.default.createElement(this.ConfigForm, { formId: this.configFormId, onFormSubmit: this.onFormSubmit.bind(this) })
	        );
	    };
	
	    return PortletComponent;
	}(_react2.default.Component);
	
	PortletComponent.propTypes = {
	    hasConfig: _propTypes2.default.bool.isRequired,
	
	    scopeGroupId: _propTypes2.default.number,
	    plid: _propTypes2.default.number,
	    portletId: _propTypes2.default.string,
	
	    initialConfig: _propTypes2.default.object,
	    formClassName: _propTypes2.default.string
	};
	
	PortletComponent.childContextTypes = {
	    contextId: _propTypes2.default.string
	};
	
	exports.default = PortletComponent;

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toTitle = function toTitle(error, componentStack) {
	    return error.toString() + '\n\nThis is located at:' + componentStack;
	};
	
	var style = {
	    height: '100%',
	    maxHeight: '100vh',
	    width: '100%',
	    maxWidth: '100vw',
	    display: 'flex',
	    flexDirection: 'column',
	    alignItems: 'center',
	    textAlign: 'center',
	    backgroundColor: '#C00',
	    color: '#FFF',
	    boxSizing: 'border-box',
	    cursor: 'help'
	};
	
	var svgStyle = {
	    fill: 'currentColor',
	    flex: '1 1 auto'
	};
	
	var ErrorBoundary = function (_React$Component) {
	    _inherits(ErrorBoundary, _React$Component);
	
	    function ErrorBoundary(props) {
	        _classCallCheck(this, ErrorBoundary);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = { hasError: false };
	        return _this;
	    }
	
	    ErrorBoundary.prototype.componentDidCatch = function componentDidCatch(error, info) {
	        // Display fallback UI
	        this.setState({ hasError: true, error: error, info: info });
	        // You can also log the error to an error reporting service
	        //console.error(error, info);
	        //logErrorToMyService(error, info);
	    };
	
	    ErrorBoundary.prototype.render = function render() {
	        if (this.state.hasError) {
	            var _state = this.state,
	                info = _state.info,
	                error = _state.error;
	            // You can render any custom fallback UI
	
	            return _react2.default.createElement(
	                _reactBootstrap.Alert,
	                { variant: 'danger' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    'Es ist ein Fehler aufgetreten'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { style: style, title: toTitle(error, info.componentStack) },
	                    _react2.default.createElement(
	                        'svg',
	                        { style: svgStyle, viewBox: '0 0 24 24', preserveAspectRatio: 'xMidYMid' },
	                        _react2.default.createElement('path', { d: 'M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,\n        12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,\n        12M15.5,8C16.3,8 17,8.7 17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,\n        9.5C14,8.7 14.7,8 15.5,8M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,\n        8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M12,14C13.75,14 15.29,14.72 16.19,\n        15.81L14.77,17.23C14.32,16.5 13.25,16 12,16C10.75,16 9.68,16.5 9.23,\n        17.23L7.81,15.81C8.71,14.72 10.25,14 12,14Z' })
	                    )
	                )
	            );
	        }
	        return this.props.children;
	    };
	
	    return ErrorBoundary;
	}(_react2.default.Component);
	
	exports.default = ErrorBoundary;
	
	
	ErrorBoundary.propTypes = {
	    children: _propTypes2.default.node
	};

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _amdUtils = __webpack_require__(115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 08.07.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var optionEq = function optionEq(a, b) {
	    return Array.isArray(a) ? (0, _shallowEqual.equalArray)(a, b) : (0, _shallowEqual.shallowEqual)(a, b);
	};
	
	var eq = function eq(a, b, k) {
	    return k === 'options' ? (0, _shallowEqual.equal)(a, b, optionEq) : a === b;
	};
	
	var PluginComponent = function (_React$Component) {
	    _inherits(PluginComponent, _React$Component);
	
	    function PluginComponent(props, plugins, dependencies) {
	        _classCallCheck(this, PluginComponent);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.state = _extends({}, _this.loadPlugins(plugins || []), _this.loadDependencies(dependencies || []));
	        return _this;
	    }
	
	    PluginComponent.prototype.componentDidMount = function componentDidMount() {
	        this.componentDidUpdate();
	    };
	
	    PluginComponent.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	        if (!(0, _shallowEqual.shallowEqual)(this.props, nextProps)) {
	            return true;
	        }
	        return !(0, _shallowEqual.equal)(this.state, nextState, eq);
	    };
	
	    /**
	     * Props maybe changed by the plugins and than set as options in state.
	     * Plugins should not use the options for updates!
	     */
	
	
	    PluginComponent.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	        if (this.init) {
	            if (!(0, _shallowEqual.equalArray)(this.props.plugins, nextProps.plugins)) {
	                console.warn('Plugins changed', this.props.plugins, nextProps.plugins);
	                this.onPluginsChanged(nextProps.plugins);
	            } else {
	                var options = this.plugins().filter(function (p) {
	                    return p.options;
	                }).reduce(function (o, p) {
	                    return p.options(o) || o;
	                }, _extends({}, nextProps));
	                this._setOptions(options);
	            }
	        }
	    };
	
	    /**
	     * After render react to state changes (init or update)
	     **/
	
	
	    PluginComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	        var o = this.state.options;
	        if (false) {
	            o = o && Object.freeze(o);
	        }
	        if (this.arePluginsLoaded() && this.areDependeciesLoaded()) {
	            if (!this.init) {
	                //Initialisation + initOptions phase
	                this._initWithPlugins();
	            } else {
	                //Update phase
	                this.updateWithPlugins(o);
	            }
	        }
	    };
	
	    /**
	     *  Destroy map and remove from plugin
	     */
	
	
	    PluginComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.plugins().filter(function (p) {
	            return p.remove;
	        }).forEach(function (p) {
	            return p.remove();
	        });
	    };
	
	    PluginComponent.prototype.onPluginsChanged = function onPluginsChanged(newPlugins) {
	        this.plugins().filter(function (p) {
	            return p.remove;
	        }).forEach(function (p) {
	            return p.remove();
	        });
	        this.setState(_extends({}, this.loadPlugins(newPlugins || [])));
	        this.init = false;
	        this.reinit = true;
	    };
	
	    PluginComponent.prototype._initWithPlugins = function _initWithPlugins() {
	        this.init = true;
	        var options = this.plugins().filter(function (p) {
	            if (p.initOptions) {
	                return true;
	            }
	            if (p.options) {
	                console.warn('Plugin overrides options but not initOptions', p);
	            }
	        }).reduce(function (o, p) {
	            return p.initOptions(o) || o;
	        }, _extends({}, this.props));
	        if (this.reinit) {
	            this.reinitWithPlugins(options);
	            this.reinit = false;
	        } else {
	            this.initWithPlugins(options);
	        }
	        this._setOptions(options); //set first or reinit options (will trigger render)
	    };
	
	    PluginComponent.prototype._setOptions = function _setOptions(options) {
	        //console.info('PluginComponent => update options '/*, { before: this.state.options, after: options }*/);
	        this.setState({ options: options });
	    };
	
	    /**
	     * First component initialization.
	     *
	     * Override and:
	     * 1. init this.mycomponent
	     * 2. call this.callPluginsInit(this.mycomponent, o);
	     *
	     * @param o
	     */
	
	
	    PluginComponent.prototype.initWithPlugins = function initWithPlugins(o) {
	        console.warn('Implement initWithPlugins(o)', o);
	    };
	
	    /**
	     * Component reinitialization.
	     *
	     * Override and:
	     * 1. optional reinit this.mycomponent
	     * 2. call this.callPluginsInit(this.mycomponent, o);
	     *
	     * @param o
	     */
	
	
	    PluginComponent.prototype.reinitWithPlugins = function reinitWithPlugins(o) {
	        console.warn('Implement reinitWithPlugins(o)', o);
	    };
	
	    /**
	     * Component update.
	     *
	     * Override and:
	     * 1. update this.mycomponent
	     * 2. call this.callPluginsUpdate(this.mycomponent, o);
	     *
	     * @param o
	     */
	
	
	    PluginComponent.prototype.updateWithPlugins = function updateWithPlugins(o) {
	        console.warn('Implement updateWithPlugins(o)', o);
	    };
	
	    PluginComponent.prototype.callPluginsInit = function callPluginsInit() {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	        }
	
	        var reEvaluate = this.reEvaluate.bind(this);
	        //console.info('PluginComponent => plugin.init()', args);
	        this.plugins().filter(function (p) {
	            return p.init;
	        }).forEach(function (p) {
	            return p.init.apply(p, args.concat(reEvaluate));
	        });
	    };
	
	    PluginComponent.prototype.callPluginsUpdate = function callPluginsUpdate() {
	        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	            args[_key2] = arguments[_key2];
	        }
	
	        //console.info('PluginComponent => plugin.update()', args);
	        this.plugins().filter(function (p) {
	            return p.update;
	        }).forEach(function (p) {
	            return p.update.apply(p, args);
	        });
	    };
	
	    PluginComponent.prototype.arePluginsLoaded = function arePluginsLoaded() {
	        return !this.state.loadPlugins;
	    };
	
	    PluginComponent.prototype.areDependeciesLoaded = function areDependeciesLoaded() {
	        return !this.state.loadDependencies;
	    };
	
	    PluginComponent.prototype.plugins = function plugins() {
	        return this.state.plugins || [];
	    };
	
	    PluginComponent.prototype.reEvaluate = function reEvaluate(additionalProps) {
	        //to check if mounted
	        this.UNSAFE_componentWillReceiveProps(_extends({}, this.props, additionalProps));
	    };
	
	    PluginComponent.prototype.loadDependencies = function loadDependencies(deps) {
	        var _this2 = this;
	
	        var dependencies = {};
	
	        if (!deps || deps.length === 0) {
	            return { loadDependencies: false };
	        }
	
	        deps.forEach(function (depName) {
	            (0, _amdUtils.amdRequire)([depName], function (dep) {
	                dependencies[depName] = dep;
	                var loadedDeps = Object.keys(dependencies).length;
	                _this2.setState({
	                    dependencies: dependencies,
	                    loadDependencies: loadedDeps !== deps.length
	                });
	            });
	        });
	        return { loadDependencies: true };
	    };
	
	    PluginComponent.prototype.loadPlugins = function loadPlugins(plugins) {
	        var _this3 = this;
	
	        var filterAndLogNull = function filterAndLogNull(p) {
	            if (!p) {
	                console.error('Found \'null\' value in plugin props!', _this3);
	            }
	            return !!p;
	        };
	        var async = plugins.map(this.asAsyncPlugin).filter(function (p) {
	            return !!p;
	        }).map(function (p) {
	            return p.path.trim();
	        });
	        if (async.length > 0) {
	            (0, _amdUtils.amdRequire)(async, function () {
	                plugins = plugins.map(function (p) {
	                    try {
	                        var _ref = _this3.asAsyncPlugin(p) || {},
	                            path = _ref.path,
	                            config = _ref.config;
	
	                        if (path) {
	                            try {
	                                p = (0, _amdUtils.amdRequire)(path);
	                            } catch (e) {
	                                console.error(e);
	                                return null;
	                            }
	                        }
	                        return _this3.asPlugin(p, config);
	                    } catch (e) {
	                        console.error('Error loading Plugin ' + p, e);
	                    }
	                }).filter(filterAndLogNull);
	                _this3.setState({ plugins: plugins, loadPlugins: false });
	            }, function (err) {
	                //The error has a list of modules that failed
	                var pluginErrorIds = err.requireModules && err.requireModules;
	                console.error('Error loading plugins', pluginErrorIds);
	                var failPlugin = {};
	                pluginErrorIds.forEach(function (plugin) {
	                    //undef is function only on the global requirejs object.
	                    //Use it to clear internal knowledge of the module. Any modules
	                    //that were dependent on the module and in the middle of loading
	                    //will not be loaded yet, they will wait until a valid the module
	                    //does load.
	                    _amdUtils.amdRequire.undef(plugin);
	                    (0, _amdUtils.amdDefine)(plugin, [], function () {
	                        return failPlugin;
	                    });
	                    (0, _amdUtils.amdRequire)([plugin], function () {});
	                });
	            });
	            return { loadPlugins: true };
	        } else {
	            return { plugins: plugins.map(this.asPlugin.bind(this)).filter(filterAndLogNull), loadPlugins: false };
	        }
	    };
	
	    PluginComponent.prototype.asPlugin = function asPlugin(p, config) {
	        var plugin = typeof p === 'function' ? new p(this.props, config) : Object.create(p);
	        plugin.context = this.context;
	        return plugin;
	    };
	
	    PluginComponent.prototype.asAsyncPlugin = function asAsyncPlugin(p) {
	        if (typeof p === 'string') {
	            return { path: p };
	        } else if (p && typeof p.path === 'string') {
	            return {
	                path: p.path,
	                config: typeof p.config === 'string' ? p.config.trim().length > 0 ? JSON.parse(p.config) : null : p
	            };
	        } else if (typeof p === 'function') {
	            //Do nothing plugin allready loaded
	        } else {
	            console.error('Error loading plugin as async. Plugin is not valid or undefined', p);
	        }
	    };
	
	    return PluginComponent;
	}(_react2.default.Component);
	
	PluginComponent.propTypes = {
	    plugins: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object, _propTypes2.default.string]))
	};
	
	exports.default = PluginComponent;

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 22.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.loadModuleByClassName = exports.amdDefine = exports.amdRequire = undefined;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(99);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var amdRequire = exports.amdRequire = window['req' + 'uire'];
	var amdDefine = exports.amdDefine = window['def' + 'ine'];
	
	var cache = {}; //cache for sync load
	
	var loadModuleByClassName = exports.loadModuleByClassName = function loadModuleByClassName(className, callback) {
	  if (cache[className]) {
	    callback();
	  } else {
	    console.debug('require async module by className', className);
	    amdRequire([className], function () {
	      console.debug('successfully loaded module by className', className);
	      cache[className] = true;
	      callback();
	    });
	  }
	};
	
	var AmdRequireComponent = function (_React$Component) {
	  _inherits(AmdRequireComponent, _React$Component);
	
	  function AmdRequireComponent(props) {
	    _classCallCheck(this, AmdRequireComponent);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {};
	    _this.prevDependencies = null;
	    return _this;
	  }
	
	  AmdRequireComponent.prototype.componentDidMount = function componentDidMount() {
	    this._isMounted = true;
	    this.loadDependency();
	  };
	
	  AmdRequireComponent.prototype.componentWillUnmount = function componentWillUnmount() {
	    this._isMounted = false;
	  };
	
	  AmdRequireComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
	    if (!(0, _shallowEqual.equalArray)(prevProps.dependencies, this.props.dependencies)) {
	      this.loadDependency();
	    }
	  };
	
	  AmdRequireComponent.prototype.loadDependency = function loadDependency() {
	    var _this2 = this;
	
	    var dependencies = this.props.dependencies;
	    var loadedDependencies = dependencies.map(function (d) {
	      return cache[d] && amdRequire(d);
	    }).filter(function (d) {
	      return !!d;
	    });
	
	    if (loadedDependencies.length === dependencies.length) {
	      this.prevDependencies = dependencies;
	      this.setState({ loadedDependencies: loadedDependencies });
	    } else {
	      amdRequire([].concat(dependencies), function () {
	        for (var _len = arguments.length, loadedDependencies = Array(_len), _key = 0; _key < _len; _key++) {
	          loadedDependencies[_key] = arguments[_key];
	        }
	
	        for (var i = 0; i < dependencies.length; i++) {
	          cache[dependencies[i]] = true;
	        }
	        if (_this2._isMounted) {
	          _this2.prevDependencies = dependencies;
	          _this2.setState({ loadedDependencies: loadedDependencies });
	        }
	        _this2.onDependenciesLoaded(loadedDependencies);
	      });
	    }
	  };
	
	  AmdRequireComponent.prototype.onDependenciesLoaded = function onDependenciesLoaded(loadedDependencies) {
	    if (this.props.onDependenciesLoaded) {
	      this.props.onDependenciesLoaded(loadedDependencies);
	    }
	  };
	
	  AmdRequireComponent.prototype.render = function render() {
	    var loadedDependencies = this.state.loadedDependencies;
	
	
	    if (loadedDependencies && (0, _shallowEqual.equalArray)(this.prevDependencies, this.props.dependencies)) {
	      var _props;
	
	      return (_props = this.props).children.apply(_props, loadedDependencies);
	    } else {
	      return _react2.default.createElement(
	        'div',
	        null,
	        'Loading (',
	        this.props.dependencies.toString(),
	        ')...'
	      );
	    }
	  };
	
	  return AmdRequireComponent;
	}(_react2.default.Component);
	
	AmdRequireComponent.propTypes = {
	  dependencies: _propTypes2.default.array,
	  children: _propTypes2.default.func,
	  onDependenciesLoaded: _propTypes2.default.func
	};
	
	exports.default = AmdRequireComponent;

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = wrapWithFormContainer;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _appContext = __webpack_require__(67);
	
	var _StoreFactory = __webpack_require__(104);
	
	var _FormActions = __webpack_require__(66);
	
	var _FormActions2 = _interopRequireDefault(_FormActions);
	
	var _formValidationUtil = __webpack_require__(64);
	
	var _formValidationUtil2 = _interopRequireDefault(_formValidationUtil);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Date: 20.06.2016
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FormStore = (0, _StoreFactory.getFormStore)(_appContext.AppContext);
	
	var formIdCounter = 0;
	
	function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function wrapWithFormContainer(FormComponent) {
	    var FormContainer = function (_React$Component) {
	        _inherits(FormContainer, _React$Component);
	
	        function FormContainer(props) {
	            _classCallCheck(this, FormContainer);
	
	            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	            _this.state = _this.calculateState({
	                formId: props.formId || ++formIdCounter,
	                editRequired: props.editRequired !== false
	            }, props);
	            return _this;
	        }
	
	        FormContainer.prototype.componentDidMount = function componentDidMount() {
	            this.removeListener = FormStore.addListener(this.onChange.bind(this));
	        };
	
	        FormContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	            if (FormStore.isEditing(this.state.formId)) {
	                console.warn('Form component unmounted but form is already editing');
	            }
	            if (this.removeListener) {
	                this.removeListener.remove();
	            }
	        };
	
	        FormContainer.prototype.onChange = function onChange() {
	            this.setState(this.calculateState(this.state, this.props));
	        };
	
	        FormContainer.prototype.startEdit = function startEdit() {
	            _FormActions2.default.startEditFormItem(this.state.formId, this.props.item);
	        };
	
	        FormContainer.prototype.calculateState = function calculateState(prevState, prevProps) {
	            var formId = prevState && prevState.formId || prevProps && prevProps.formId;
	            var formValidation = FormStore.getValidation(formId);
	            var formValid = this.isFormValid(formValidation);
	            return {
	                formId: formId,
	                formData: FormStore.getItem(formId),
	                originalFormData: FormStore.getOriginalItem(formId),
	                formValidation: formValidation,
	                formError: FormStore.getError(formId),
	                isEditing: FormStore.isEditing(formId),
	                isSaving: FormStore.isSaving(formId),
	                isEdited: FormStore.isEdited(formId),
	                formValid: formValid
	            };
	        };
	
	        FormContainer.prototype.isFormValid = function isFormValid(formValidation) {
	            return _formValidationUtil2.default.isFormValid(formValidation);
	        };
	
	        FormContainer.prototype.handleFormChange = function handleFormChange(data, validation) {
	            _FormActions2.default.changedEditFormItem(this.state.formId, data, validation);
	        };
	
	        FormContainer.prototype.submitForm = function submitForm() {
	            this.props.onFormSubmit(this.state.formData, this.state.formValidation, this.state.formId);
	        };
	
	        FormContainer.prototype.cancelForm = function cancelForm() {
	            _FormActions2.default.stopEditFormItem(this.state.formId);
	        };
	
	        FormContainer.prototype.resetForm = function resetForm() {
	            _FormActions2.default.resetForm(this.state.formId);
	        };
	
	        FormContainer.prototype.render = function render() {
	            return _react2.default.createElement(FormComponent, _extends({}, this.props, {
	                onChange: this.handleFormChange.bind(this),
	                cancel: this.cancelForm.bind(this),
	                submit: this.submitForm.bind(this),
	                reset: this.resetForm.bind(this),
	                startEdit: this.startEdit.bind(this),
	                formId: this.state.formId,
	                formData: this.state.formData,
	                formValid: this.state.formValid,
	                isEdited: this.state.editRequired ? this.state.isEdited : true,
	                isEditing: this.state.isEditing,
	                isSaving: this.state.isSaving,
	                formError: this.state.formError,
	                originalFormData: this.state.originalFormData,
	                formValidation: this.state.formValidation
	            }));
	        };
	
	        return FormContainer;
	    }(_react2.default.Component);
	
	    FormContainer.propTypes = {
	        formId: _propTypes2.default.string.isRequired,
	        onFormSubmit: _propTypes2.default.func.isRequired,
	        editRequired: _propTypes2.default.bool,
	        item: _propTypes2.default.object
	    };
	
	    FormContainer.displayName = 'Connect(' + getDisplayName(FormComponent) + ')';
	
	    return FormContainer;
	}

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   * Author: Carsten Hibbeler
	                                                                                                                                                                                                                                                                   * Date: 20.06.2016
	                                                                                                                                                                                                                                                                   *
	                                                                                                                                                                                                                                                                   */
	
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CustomModalComponents = __webpack_require__(118);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _translation = __webpack_require__(123);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FormContainer = __webpack_require__(116);
	
	var _FormContainer2 = _interopRequireDefault(_FormContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapWithCommonFormContainer = function wrapWithCommonFormContainer(FormComponent) {
	    var includeFormLogic = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	
	    var WrappedWithCommonFormContainer = function WrappedWithCommonFormContainer(props) {
	        var _props$submitButtonTe = props.submitButtonText,
	            submitButtonText = _props$submitButtonTe === undefined ? 'OK' : _props$submitButtonTe,
	            _props$cancelButtonTe = props.cancelButtonText,
	            cancelButtonText = _props$cancelButtonTe === undefined ? 'Abbrechen' : _props$cancelButtonTe,
	            formError = props.formError;
	
	
	        var message = '';
	        if (formError && formError.error) {
	            message = formError.error.message;
	            if (formError.exception && formError.exception === 'java.lang.SecurityException' && message.indexOf('Access denied to') === 0) {
	                message = 'Versuchen Sie die Seite erneut zu laden und sich ggf. erneut anzumelden. ' + message;
	            }
	            if (formError.exception && formError.exception === 'de.lubw.fliwas.activationmatrix.exception.IndicatorInUseException') {
	                if (message.indexOf('IndicatorInUseException') >= 0) {
	                    message = 'Der Indikator wird noch verwendet und kann deswegen nicht gelöscht werden.';
	                } else if (message.indexOf("UsedInDraft") >= 0) {
	                    message = 'Der Indikator wird in einem Maßnahmen Entwurf verwendet und kann deswegen nicht gelöscht werden.';
	                }
	            }
	        }
	
	        return _react2.default.createElement(
	            _CustomModalComponents.CustomModal,
	            _extends({
	                show: props.isEditing,
	                onHide: props.cancel,
	                context: props.context
	            }, props.modalProps, {
	                hideFooter: true
	            }),
	            _react2.default.createElement(
	                _CustomModalComponents.CustomModalBody,
	                null,
	                _react2.default.createElement(FormComponent, props)
	            ),
	            _react2.default.createElement(
	                _CustomModalComponents.CustomModalFooter,
	                null,
	                props.cancel && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', onClick: props.cancel },
	                    cancelButtonText
	                ),
	                props.submit && !props.isSaving && props.isEdited && props.formValid && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', onClick: props.submit },
	                    submitButtonText
	                ),
	                props.submit && (props.isSaving || !(props.formValid && props.isEdited)) && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    { variant: 'primary', onClick: props.submit, disabled: true },
	                    submitButtonText
	                )
	            ),
	            props.formError && props.formError.error && _react2.default.createElement(
	                'div',
	                { className: 'd-flex align-items-end flex-column px-3' },
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    _translation2.default.transException(props.formError.exception)
	                ),
	                _react2.default.createElement(
	                    'h4',
	                    null,
	                    message
	                )
	            )
	        );
	    };
	
	    WrappedWithCommonFormContainer.propTypes = _extends({}, FormComponent.propTypes, {
	        isSaving: _propTypes2.default.bool,
	        isEdited: _propTypes2.default.bool,
	        onChange: _propTypes2.default.func,
	        cancel: _propTypes2.default.func,
	        submit: _propTypes2.default.func,
	        reset: _propTypes2.default.func,
	        context: _propTypes2.default.object,
	        submitButtonText: _propTypes2.default.string,
	        cancelButtonText: _propTypes2.default.string,
	        modalProps: _propTypes2.default.object,
	        formError: _propTypes2.default.object,
	        formValidation: _propTypes2.default.object,
	        showReset: _propTypes2.default.bool
	    });
	
	    return includeFormLogic ? (0, _FormContainer2.default)(WrappedWithCommonFormContainer) : WrappedWithCommonFormContainer;
	};
	
	exports.default = wrapWithCommonFormContainer;

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.TitleContainerContext = exports.CustomModalBody = exports.CustomModalFooter = exports.CustomModal = undefined;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	__webpack_require__(119);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TitleContainerContext = _react2.default.createContext(null);
	
	/**
	 * Wraps content (children) into a modal-container with header, and footer.
	 */
	
	var CustomModal = function (_React$Component) {
	  _inherits(CustomModal, _React$Component);
	
	  function CustomModal(props) {
	    _classCallCheck(this, CustomModal);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.setTitleRef = function (element) {
	      _this.titleRef = element;
	      _this.setState({
	        titleRefSet: true
	      });
	    };
	    return _this;
	  }
	
	  CustomModal.prototype.getChildContext = function getChildContext() {
	    return { contextId: this.context && this.context.contextId && this.context.contextId + '_Modal' || this.props.context && this.props.context.contextId + '_Modal' };
	  };
	
	  CustomModal.prototype.render = function render() {
	    var _props = this.props,
	        show = _props.show,
	        onHide = _props.onHide,
	        children = _props.children,
	        hideFooter = _props.hideFooter,
	        _props$aboveLiferayDi = _props.aboveLiferayDialog,
	        aboveLiferayDialog = _props$aboveLiferayDi === undefined ? false : _props$aboveLiferayDi,
	        _props$size = _props.size,
	        size = _props$size === undefined ? 'lg' : _props$size,
	        _props$className = _props.className,
	        className = _props$className === undefined ? '' : _props$className;
	
	    var classNames = '' + className + (aboveLiferayDialog ? ' above-liferay-dialog' : '');
	    return _react2.default.createElement(
	      _reactBootstrap.Modal,
	      {
	        backdrop: 'static',
	        show: show,
	        size: size,
	        onEscapeKeyDown: onHide,
	        onHide: onHide,
	        animation: false,
	        backdropClassName: aboveLiferayDialog ? 'above-liferay-backdrop' : '',
	        className: classNames,
	        scrollable: true,
	        centered: true
	      },
	      _react2.default.createElement(
	        _reactBootstrap.Modal.Header,
	        { closeLabel: 'Modal Schlie\xDFen' },
	        _react2.default.createElement('h3', { className: 'modal-title', ref: this.setTitleRef }),
	        _react2.default.createElement(
	          _reactBootstrap.Button,
	          {
	            variant: 'outline-primary',
	            onClick: onHide,
	            className: 'custom-close'
	          },
	          _react2.default.createElement('span', { className: 'fa fa-times' })
	        )
	      ),
	      _react2.default.createElement(
	        TitleContainerContext.Provider,
	        { value: this.titleRef },
	        children
	      ),
	      !hideFooter && _react2.default.createElement(CustomModalFooter, { onHide: onHide })
	    );
	  };
	
	  return CustomModal;
	}(_react2.default.Component);
	
	var CustomModalFooter = function CustomModalFooter(_ref) {
	  var children = _ref.children,
	      onHide = _ref.onHide;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal.Footer,
	    null,
	    !children && _react2.default.createElement(
	      _reactBootstrap.Button,
	      { variant: 'primary', type: 'button', onClick: onHide },
	      'Schlie\xDFen'
	    ),
	    children && children
	  );
	};
	
	var CustomModalBody = _react2.default.forwardRef(function (_ref2, ref) {
	  var children = _ref2.children;
	  return _react2.default.createElement(
	    _reactBootstrap.Modal.Body,
	    { ref: ref },
	    children
	  );
	});
	
	CustomModal.propTypes = {
	  show: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  onHide: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  aboveLiferayDialog: _propTypes2.default.bool,
	  size: _propTypes2.default.string,
	  hideFooter: _propTypes2.default.bool,
	  context: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	
	CustomModal.childContextTypes = {
	  contextId: _propTypes2.default.string
	};
	
	CustomModalFooter.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element]),
	  onHide: _propTypes2.default.func
	};
	
	CustomModalBody.propTypes = {
	  children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.element])
	};
	
	exports.CustomModal = CustomModal;
	exports.CustomModalFooter = CustomModalFooter;
	exports.CustomModalBody = CustomModalBody;
	exports.TitleContainerContext = TitleContainerContext;

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(120);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(122)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_modal.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_modal.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(121)();
	// imports
	
	
	// module
	exports.push([module.id, ".above-liferay-dialog{z-index:2500!important}.above-liferay-backdrop{z-index:2250!important}", ""]);
	
	// exports


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 27.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	var cache = {};
	
	requestCache();
	
	function requestCache() {
	    var xhttp = new XMLHttpRequest();
	    var value = undefined;
	    var url = location.origin + '/delegate/languageCache/' + Liferay.ThemeDisplay.getLanguageId();
	
	    xhttp.onreadystatechange = function () {
	        if (xhttp.readyState === 4 && xhttp.status === 200) {
	            if (xhttp.responseText && xhttp.responseText.length > 0) {
	                cache = JSON.parse(xhttp.responseText);
	            }
	        }
	    };
	
	    xhttp.open('GET', url, false);
	    xhttp.setRequestHeader('X-CSRF-Token', Liferay.authToken);
	    xhttp.send();
	
	    return value;
	}
	
	function applyExtraParams(translation, extraParams) {
	    var i = 0;
	    if (extraParams && Array.isArray(extraParams) && extraParams.length > 0) {
	        extraParams.forEach(function (param) {
	            var r = '{' + i + '}';
	            if (translation.indexOf(r) < 0) {
	                console.warn('No matching extraParam ' + i + ' found for translation: ', translation, extraParams);
	            }
	            translation = translation.replace(r, param);
	            i++;
	        });
	    }
	    return translation;
	}
	
	var requestTranslation = function requestTranslation(key) {
	    var url = location.origin + '/delegate/language/' + Liferay.ThemeDisplay.getLanguageId() + '/' + key + '/';
	    var xhttp = new XMLHttpRequest();
	    xhttp.onreadystatechange = function () {
	        if (xhttp.readyState === 4 && xhttp.status === 200) {
	            var txt = xhttp.responseText;
	            cache[key] = txt.length === 0 || txt === key ? noTranslation(key) : txt;
	        }
	    };
	    xhttp.open('GET', url);
	    xhttp.setRequestHeader('X-CSRF-Token', Liferay.authToken);
	    xhttp.send();
	    return xhttp;
	};
	
	var getTranslation = function getTranslation(key, extraParams) {
	    var v = cache[key];
	    if (!v) {
	        console.warn('Missing translation "' + key + "'");
	        requestTranslation(key);
	        cache[key] = v = noTranslation(key);
	    }
	    return applyExtraParams(v, extraParams);
	};
	
	var noTranslation = function noTranslation(key) {
	    return '###.' + key + '.###';
	};
	
	exports.default = {
	    trans: function trans(key) {
	        var extraParams = arguments.length >= 2 ? Array.prototype.slice.call(arguments, 1) : undefined;
	        return getTranslation(key, extraParams);
	    },
	    transException: function transException(key) {
	        if (key) {
	            var extraParams = arguments.length >= 2 ? Array.prototype.slice.call(arguments, 1) : undefined;
	            var parts = key.split('.');
	            return getTranslation(parts[parts.length > 0 ? parts.length - 1 : 0], extraParams);
	        }
	        return '';
	    }
	};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Title = __webpack_require__(125);
	
	var _Title2 = _interopRequireDefault(_Title);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _CommonFormContainer = __webpack_require__(117);
	
	var _CommonFormContainer2 = _interopRequireDefault(_CommonFormContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Copyright 2016 xdot GmbH
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              * Author: Carsten Hibbeler
	                                                                                                                                                                                                                              * Date: 20.06.2016
	                                                                                                                                                                                                                              *
	                                                                                                                                                                                                                              */
	
	
	var ConfirmFormContainer = (0, _CommonFormContainer2.default)(function (_ref) {
	    var title = _ref.title,
	        Content = _ref.Content,
	        otherProps = _objectWithoutProperties(_ref, ['title', 'Content']);
	
	    return _react2.default.createElement(
	        _reactBootstrap.Container,
	        { className: 'py-3' },
	        title && _react2.default.createElement(_Title2.default, { title: title }),
	        typeof Content === 'string' ? Content : _react2.default.createElement(Content, otherProps)
	    );
	});
	
	exports.default = ConfirmFormContainer;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CustomModalComponents = __webpack_require__(118);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SimpleTitle = function SimpleTitle(_ref) {
	    var title = _ref.title,
	        id = _ref.id,
	        icon = _ref.icon,
	        additionalText = _ref.additionalText,
	        listAdd = _ref.listAdd,
	        plain = _ref.plain;
	
	
	    if (plain) {
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            icon && icon,
	            _react2.default.createElement(
	                'span',
	                { className: "title" },
	                title + (additionalText ? ' (' + additionalText + ')' : '')
	            ),
	            listAdd && listAdd,
	            id ? _react2.default.createElement(
	                'span',
	                { className: 'stat-percent text-navy' },
	                '#',
	                id
	            ) : null
	        );
	    }
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'ibox-heading fullwidth' },
	        _react2.default.createElement(
	            'h3',
	            { className: 'widget-title' },
	            icon && icon,
	            title + (additionalText ? ' (' + additionalText + ')' : ''),
	            listAdd && listAdd,
	            id ? _react2.default.createElement(
	                'span',
	                { className: 'stat-percent text-navy' },
	                '#',
	                id
	            ) : null
	        )
	    );
	};
	
	var Title = function (_React$Component) {
	    _inherits(Title, _React$Component);
	
	    function Title() {
	        _classCallCheck(this, Title);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Title.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        if (this.props.title !== prevProps.title) {
	            this.renderTitle();
	        }
	    };
	
	    Title.prototype.attach = function attach(ref) {
	        var elem = ref;
	        for (; elem && elem !== document; elem = elem.parentNode) {
	            if (elem.classList.contains('portlet-container')) {
	                var titles = elem.getElementsByClassName('portlet-subtitle'); //portlet-title-text
	                if (titles.length > 0) {
	                    this.titleElement = titles[0];
	                    this.renderTitle();
	                    return;
	                }
	            }
	        }
	        console.warn('No portlet title element found!');
	    };
	
	    Title.prototype.renderTitle = function renderTitle() {
	        if (this.titleElement) {
	            this.titleElement.innerHTML = this.props.title;
	        }
	    };
	
	    Title.prototype.render = function render() {
	        var _this2 = this;
	
	        var children = this.props.children;
	
	
	        return _react2.default.createElement(
	            _CustomModalComponents.TitleContainerContext.Consumer,
	            null,
	            function (titleRef) {
	                if (titleRef) {
	                    _this2.titleRef = titleRef;
	                    if (_react2.default.Children.count(children) > 0) {
	                        return _reactDom2.default.createPortal(children, titleRef);
	                    }
	
	                    return _reactDom2.default.createPortal(_react2.default.createElement(SimpleTitle, _extends({}, _this2.props, { plain: true })), titleRef);
	                }
	
	                return _react2.default.createElement(SimpleTitle, _this2.props);
	            }
	        );
	    };
	
	    return Title;
	}(_react2.default.Component);
	
	SimpleTitle.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    additionalText: _propTypes2.default.string,
	    icon: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	    id: _propTypes2.default.number,
	    header: _propTypes2.default.bool,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array])
	};
	
	Title.propTypes = _extends({}, SimpleTitle.propTypes);
	
	exports.default = Title;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 27.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _translation = __webpack_require__(123);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _ScrollableDataComponent = __webpack_require__(127);
	
	var _ScrollableDataComponent2 = _interopRequireDefault(_ScrollableDataComponent);
	
	var _FlagHOC = __webpack_require__(128);
	
	var _DataListHoc = __webpack_require__(133);
	
	var _DataListHoc2 = _interopRequireDefault(_DataListHoc);
	
	var _dataUtil = __webpack_require__(134);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableDataList = function (_ScrollableDataCompon) {
	    _inherits(ScrollableDataList, _ScrollableDataCompon);
	
	    function ScrollableDataList() {
	        _classCallCheck(this, ScrollableDataList);
	
	        return _possibleConstructorReturn(this, _ScrollableDataCompon.apply(this, arguments));
	    }
	
	    ScrollableDataList.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.listGroupDom = null;
	    };
	
	    ScrollableDataList.prototype.getScrollContainerDomNode = function getScrollContainerDomNode() {
	        if (!this.listGroupDom) {
	            this.listGroupDom = _reactDom2.default.findDOMNode(this.listGroup);
	        }
	        return this.listGroupDom;
	    };
	
	    ScrollableDataList.prototype.renderComponent = function renderComponent() {
	        var _this2 = this;
	
	        var _props = this.props,
	            list = _props.list,
	            ListItem = _props.ListItem,
	            onClick = _props.onClick,
	            propName = _props.propName,
	            activeIds = _props.activeIds,
	            disabledIds = _props.disabledIds,
	            _props$listSize = _props.listSize,
	            listSize = _props$listSize === undefined ? 'list-medium' : _props$listSize,
	            loadMoreRows = _props.loadMoreRows,
	            _props$style = _props.style,
	            style = _props$style === undefined ? {} : _props$style,
	            otherProps = _objectWithoutProperties(_props, ['list', 'ListItem', 'onClick', 'propName', 'activeIds', 'disabledIds', 'listSize', 'loadMoreRows', 'style']);
	
	        var l = (0, _dataUtil.asArray)(list);
	        var listItems = l && l.map ? l.map(function (item, index) {
	            var id = propName ? item[propName] : item.id ? item.id : index;
	            return _react2.default.createElement(ListItem, _extends({}, otherProps, {
	                key: id,
	                index: index,
	                item: item,
	                disabled: !!disabledIds[id],
	                active: !!activeIds[id],
	                onClick: onClick
	            }));
	        }) : [];
	
	        if (listItems.length === 0 && !(list && list._more)) {
	            listItems.push(_react2.default.createElement(
	                'div',
	                { key: -1, className: 'error-message' },
	                _translation2.default.trans('no-entries')
	            ));
	        }
	
	        return _react2.default.createElement(
	            'section',
	            { className: 'list-group-wrapper' },
	            _react2.default.createElement(
	                _reactBootstrap.ListGroup,
	                {
	                    className: 'scrollable-list-group ' + listSize,
	                    style: style,
	                    ref: function ref(e) {
	                        return _this2.listGroup = e;
	                    },
	                    onScroll: this.onScroll.bind(this, list),
	                    as: 'div'
	                },
	                _react2.default.createElement(
	                    _FlagHOC.FlagComponent,
	                    { item: list },
	                    listItems
	                ),
	                !list._loading && list._more && _react2.default.createElement(
	                    _reactBootstrap.Button,
	                    {
	                        className: 'load-more-spacer',
	                        onClick: loadMoreRows,
	                        variant: 'default'
	                    },
	                    _react2.default.createElement('i', { className: 'icon icon-fliwas-loader' })
	                )
	            )
	        );
	    };
	
	    return ScrollableDataList;
	}(_ScrollableDataComponent2.default);
	
	ScrollableDataList.propTypes = {
	    ListItem: _propTypes2.default.func.isRequired,
	    activeIds: _propTypes2.default.object,
	    disabledIds: _propTypes2.default.object,
	    list: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	    propName: _propTypes2.default.string,
	    loadMoreRows: _propTypes2.default.func.isRequired,
	    onClick: _propTypes2.default.func,
	    listSize: _propTypes2.default.oneOf(['list-auto', 'list-small', 'list-medium', 'list-large']),
	    style: _propTypes2.default.object
	};
	
	exports.default = (0, _DataListHoc2.default)(ScrollableDataList);

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 27.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _appContext = __webpack_require__(67);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableDataComponent = function (_React$Component) {
	    _inherits(ScrollableDataComponent, _React$Component);
	
	    function ScrollableDataComponent() {
	        _classCallCheck(this, ScrollableDataComponent);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ScrollableDataComponent.prototype.componentDidMount = function componentDidMount() {
	        this.mounted = true;
	    };
	
	    ScrollableDataComponent.prototype.getScrollContainerDomNode = function getScrollContainerDomNode() {
	        console.warn("Implement getScrollContainerDomNode() ");
	        return _reactDom2.default.findDOMNode(this);
	    };
	
	    ScrollableDataComponent.prototype.componentDidUpdate = function componentDidUpdate() {
	        var list = this.props.list;
	
	        var scrollContainer = this.getScrollContainerDomNode();
	
	        if (scrollContainer) {
	            var position = scrollContainer.scrollTop;
	            var maxHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
	            if (!list._loading && list._more && !list._error) {
	                if (list._end < _appContext.AppContext.DEFAULT_LIST_SIZE) {
	                    //TODO is this hack really the best solution?
	                    console.warn('initial list item size to small');
	                    this.props.loadMoreRows({
	                        startIndex: list._end,
	                        stopIndex: list._end + _appContext.AppContext.DEFAULT_LIST_SIZE
	                    });
	                }
	            }
	        } else if (this.mounted) {
	            console.warn("ScrollContainerDomNode not found!", this);
	        }
	    };
	
	    ScrollableDataComponent.prototype.onScroll = function onScroll(list) {
	        var scrollContainer = this.getScrollContainerDomNode();
	        if (!list._loading && list._more) {
	            var maxHeight = scrollContainer.scrollHeight - scrollContainer.clientHeight;
	            if (maxHeight - scrollContainer.scrollTop < 1) {
	                this.props.loadMoreRows({
	                    startIndex: list._end,
	                    stopIndex: list._end + _appContext.AppContext.DEFAULT_LIST_SIZE
	                });
	            }
	        }
	    };
	
	    ScrollableDataComponent.prototype.render = function render() {
	        return this.renderComponent();
	    };
	
	    return ScrollableDataComponent;
	}(_react2.default.Component);
	
	ScrollableDataComponent.propTypes = {
	    ListItem: _propTypes2.default.func.isRequired,
	    activeIds: _propTypes2.default.object,
	    disabledIds: _propTypes2.default.object,
	    list: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	    className: _propTypes2.default.string,
	    propName: _propTypes2.default.string,
	    onClick: _propTypes2.default.func,
	    loadMoreRows: _propTypes2.default.func.isRequired
	};
	
	exports.default = ScrollableDataComponent;

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.FlagComponent = undefined;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(129);
	
	var _reactBootstrap = __webpack_require__(111);
	
	var _translation = __webpack_require__(123);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	__webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line react/prop-types
	/**
	 * Created by Nikolai Gorte
	 * User: n.gorte on 30.08.2016
	 * Copyright: xdot GmbH 2016
	 */
	var Error = function Error(_ref) {
	    var _error = _ref._error,
	        sendErrorMail = _ref.sendErrorMail;
	
	    return _react2.default.createElement(
	        _reactBootstrap.Alert,
	        { variant: 'danger' },
	        _react2.default.createElement(
	            'h3',
	            null,
	            'Es ist ein Fehler aufgetreten.'
	        ),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Fehlernachrichten: '
	        ),
	        _error.map(function (e, i) {
	            return _react2.default.createElement(
	                'p',
	                { key: i },
	                e.error && e.error.message || e
	            );
	        }),
	        _react2.default.createElement(
	            'h4',
	            null,
	            'Fehlertyp:'
	        ),
	        _react2.default.createElement('p', null),
	        _error.map(function (e, i) {
	            return _react2.default.createElement(
	                'p',
	                { key: i },
	                _translation2.default.transException(e.exception)
	            );
	        }),
	        sendErrorMail && _react2.default.createElement(
	            _reactBootstrap.Button,
	            { variant: 'warning', onClick: function onClick() {
	                    return sendErrorMail(_error[0]);
	                } },
	            'Fehler per E-Mail senden'
	        )
	    );
	};
	
	var Loader = function Loader() {
	    return _react2.default.createElement(
	        'div',
	        { className: 'spinner-container' },
	        _react2.default.createElement(
	            'div',
	            { className: 'sk-circle spinner' },
	            _react2.default.createElement('div', { className: 'sk-circle1 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle2 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle3 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle4 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle5 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle6 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle7 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle8 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle9 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle10 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle11 sk-child' }),
	            _react2.default.createElement('div', { className: 'sk-circle12 sk-child' })
	        )
	    );
	};
	
	function sendErrorMail(_error) {
	    window.location = 'mailto:fliwas@komm.one?subject=FLIWAS Benutzer-Fehlermeldung&body=Automatisierte%20Fehlermeldung%0D%0A%0D%0AException:%20' + _translation2.default.transException(_error.exception) + '%0D%0A%0D%0AMessage:%20' + (_error.error && _error.error.message) + '%0D%0A%0D%0A%0D%0A%0D%0ABenutzerhinweis:%20Bitte%20hier%20eine%20Beschreibung%20einfügen.';
	}
	
	var defaultDataPropNames = ['item', 'list', 'dataItem', 'dataList'];
	
	var flagHOC = function flagHOC(WrappedComponent, dataPropNames) {
	
	    var propNames = dataPropNames || defaultDataPropNames;
	    if (!dataPropNames) {
	        console.warn('Use explicit binding!');
	    }
	
	    var FlagHOC = function FlagHOC(props) {
	
	        var items = propNames.map(function (propName) {
	            return props[propName];
	        }).filter(function (i) {
	            return !!i;
	        });
	
	        var _loading = false,
	            _error = [];
	
	        items.forEach(function (item) {
	            _loading = _loading || item._loading;
	            if (item._error) {
	                _error.push(item._error);
	            }
	        });
	
	        if (items.length > 1) {
	            console.warn('DO not use FlagHOC with multiple data items in props', items);
	        }
	
	        return _react2.default.createElement(
	            _react2.default.Fragment,
	            null,
	            items.length > 0 ? _error.length > 0 ? _react2.default.createElement(Error, { _error: _error, sendErrorMail: sendErrorMail }) : _react2.default.createElement(WrappedComponent, props) :
	            //(JSON.stringify(Object.keys(props))) //TODO should this really be displayed??
	            '',
	            _loading && _react2.default.createElement(Loader, null)
	        );
	    };
	
	    FlagHOC.propTypes = {
	        item: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	        list: _propTypes2.default.object,
	        dataItem: _propTypes2.default.object,
	        dataList: _propTypes2.default.object
	    };
	
	    return FlagHOC;
	};
	
	exports.default = flagHOC;
	
	
	var FlagComponent = function FlagComponent(props) {
	    return props.children;
	};
	
	var C = flagHOC(FlagComponent, ['item']);
	
	exports.FlagComponent = C;

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(130);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(122)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_spinner.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_spinner.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(121)();
	// imports
	
	
	// module
	exports.push([module.id, ".sk-circle{width:40px!important;height:40px!important;position:absolute;left:50%;top:50%;transform:translate(-50%,-50%)}.spinner-container{right:0;bottom:0;background:hsla(0,0%,100%,.35)}.sk-circle .sk-child,.spinner-container{top:0;left:0;height:100%;width:100%;position:absolute}.sk-circle .sk-child:before{content:\"\";display:block;margin:0 auto;width:15%;height:15%;background-color:#333;border-radius:100%;animation:sk-circleBounceDelay 1.2s infinite ease-in-out both}.sk-circle .sk-circle2{transform:rotate(30deg)}.sk-circle .sk-circle3{transform:rotate(60deg)}.sk-circle .sk-circle4{transform:rotate(90deg)}.sk-circle .sk-circle5{transform:rotate(120deg)}.sk-circle .sk-circle6{transform:rotate(150deg)}.sk-circle .sk-circle7{transform:rotate(180deg)}.sk-circle .sk-circle8{transform:rotate(210deg)}.sk-circle .sk-circle9{transform:rotate(240deg)}.sk-circle .sk-circle10{transform:rotate(270deg)}.sk-circle .sk-circle11{transform:rotate(300deg)}.sk-circle .sk-circle12{transform:rotate(330deg)}.sk-circle .sk-circle2:before{animation-delay:-1.1s}.sk-circle .sk-circle3:before{animation-delay:-1s}.sk-circle .sk-circle4:before{animation-delay:-.9s}.sk-circle .sk-circle5:before{animation-delay:-.8s}.sk-circle .sk-circle6:before{animation-delay:-.7s}.sk-circle .sk-circle7:before{animation-delay:-.6s}.sk-circle .sk-circle8:before{animation-delay:-.5s}.sk-circle .sk-circle9:before{animation-delay:-.4s}.sk-circle .sk-circle10:before{animation-delay:-.3s}.sk-circle .sk-circle11:before{animation-delay:-.2s}.sk-circle .sk-circle12:before{animation-delay:-.1s}@keyframes sk-circleBounceDelay{0%,80%,to{transform:scale(0)}40%{transform:scale(1)}}", ""]);
	
	// exports


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(132);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(122)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_flags.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_flags.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(121)();
	// imports
	
	
	// module
	exports.push([module.id, ".aui .flags-container{position:relative;min-height:60px;margin-bottom:10px}.aui .flags-container .alert{overflow:hidden;border-radius:0;-webkit-border-radius:0;-moz-border-radius:0;padding:15px}.aui .flags-container .alert p{word-break:break-all;margin:1em 0 2em}.aui .flags-container .alert h3,.aui .flags-container .alert h4{font-weight:600;line-height:130%}.aui .flags-container .alert h3{margin-bottom:1em}", ""]);
	
	// exports


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dataUtil = __webpack_require__(134);
	
	var DataUtil = _interopRequireWildcard(_dataUtil);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _debounce = __webpack_require__(135);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by n.gorte on 28.06.2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var dataListHOC = function dataListHOC(WrappedComponent) {
	    var DataListHOC = function (_React$Component) {
	        _inherits(DataListHOC, _React$Component);
	
	        function DataListHOC(props) {
	            _classCallCheck(this, DataListHOC);
	
	            var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	            var activeIds = props.activeIds,
	                disabledIds = props.disabledIds,
	                propName = props.propName;
	
	
	            _this.state = {
	                activeIds: DataUtil.idMap(activeIds, propName),
	                disabledIds: DataUtil.idMap(disabledIds, propName),
	                didScrollToSelected: false
	            };
	
	            _this.loadMoreRows = (0, _debounce2.default)(_this.loadMoreRows.bind(_this), 500);
	            _this.pendingLoadingRows = [];
	            return _this;
	        }
	
	        DataListHOC.prototype.scrollToItemId = function scrollToItemId(id, listEnd) {
	            var list = DataUtil.asArray(this.props.list);
	
	            if (!list) {
	                console.warn('list as Array is false in DataListHoc', this.props.list);
	            } else {
	                var propName = this.props.propName,
	                    idx = list.findIndex(function (item) {
	                    return propName ? item[propName] : item.id === id;
	                });
	
	
	                if (idx >= 0) {
	                    if (this.wc && this.wc.scrollToIndex) {
	                        this.wc.scrollToIndex(idx);
	                    } else {
	                        console.warn('Cannot call scrollToIndex on', this.wc);
	                    }
	                    this.setState({
	                        didScrollToSelected: true
	                    });
	                } else {
	                    /*const startIndex = list._end;
	                    this.loadMoreRows({ stopIndex: startIndex + 25 });*/
	                    if (this.wc && this.wc.scrollToIndex) {
	                        this.wc.scrollToIndex(listEnd - 1);
	                    } else {
	                        console.warn('Cannot call scrollToIndex on', this.wc);
	                    }
	                    this.setState({
	                        didScrollToSelected: false
	                    });
	                }
	            }
	        };
	
	        DataListHOC.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	            var _state = this.state,
	                activeIds = _state.activeIds,
	                disabledIds = _state.disabledIds;
	
	            var nextActiveIds = activeIds,
	                nextDisabledIds = disabledIds;
	
	            if (!(0, _shallowEqual2.default)(this.props.activeIds, nextProps.activeIds)) {
	                nextActiveIds = DataUtil.idMap(nextProps.activeIds, nextProps.propName);
	            }
	
	            if (!(0, _shallowEqual2.default)(this.props.disabledIds, nextProps.disabledIds)) {
	                nextDisabledIds = DataUtil.idMap(nextProps.disabledIds, nextProps.propName);
	            }
	
	            var list = nextProps.list;
	
	            var listItems = DataUtil.asArray(list);
	
	            if (nextActiveIds && (activeIds !== nextActiveIds || !this.state.didScrollToSelected) && Object.keys(nextActiveIds).length > 0) {
	                this.scrollToItemId(parseInt(Object.keys(nextActiveIds)[0]), list._end);
	            }
	
	            this.pendingLoadingRows = this.pendingLoadingRows.filter(function (pending) {
	                if (listItems[pending.range.startIndex] && listItems[pending.range.stopIndex]) {
	                    pending.resolve();
	                } else {
	                    return true;
	                }
	            });
	
	            this.setState({
	                activeIds: nextActiveIds,
	                disabledIds: nextDisabledIds
	            });
	        };
	
	        DataListHOC.prototype.loadMoreRows = function loadMoreRows(range) {
	            var _this2 = this;
	
	            var stopIndex = range.stopIndex,
	                offset = stopIndex - DataUtil.asArray(this.props.list).length;
	
	
	            this.props.onClickMore && this.props.onClickMore({ offset: offset + 1 });
	
	            return new Promise(function (resolve) {
	                _this2.pendingLoadingRows.push({
	                    resolve: resolve,
	                    range: {
	                        startIndex: DataUtil.asArray(_this2.props.list).length - 1,
	                        stopIndex: stopIndex
	                    }
	                });
	            });
	        };
	
	        DataListHOC.prototype.render = function render() {
	            var _this3 = this;
	
	            var _state2 = this.state,
	                activeIds = _state2.activeIds,
	                disabledIds = _state2.disabledIds;
	            // eslint-disable-next-line no-unused-vars
	
	            var _props = this.props,
	                onClickMore = _props.onClickMore,
	                rest = _objectWithoutProperties(_props, ['onClickMore']);
	
	            return _react2.default.createElement(WrappedComponent, _extends({
	                ref: function ref(wc) {
	                    return _this3.wc = wc;
	                },
	                loadMoreRows: this.loadMoreRows,
	                activeIds: activeIds,
	                disabledIds: disabledIds
	            }, rest));
	        };
	
	        return DataListHOC;
	    }(_react2.default.Component);
	
	    DataListHOC.propTypes = {
	        disabled: _propTypes2.default.object,
	        list: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
	        activeIds: _propTypes2.default.object,
	        disabledIds: _propTypes2.default.object,
	        onClickMore: _propTypes2.default.func,
	        propName: _propTypes2.default.string
	    };
	
	    return DataListHOC;
	};
	
	exports.default = dataListHOC;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 15.02.2016.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.getClassName = getClassName;
	exports.asObject = asObject;
	exports.asArray = asArray;
	exports.asItem = asItem;
	exports.idMap = idMap;
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *
	 * @param o
	 * @returns {Array|*}
	 */
	
	function isObject(o) {
	    return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && !Array.isArray(o);
	}
	
	function getClassName(data) {
	    return data && data.className;
	}
	
	function asObject(data) {
	    return data && (data.hasOwnProperty('item') ? data.item : data);
	}
	
	function asArray(data) {
	    var d = asObject(data);
	    (0, _warning2.default)(!d || Array.isArray(d), 'Array or DataList expected %s', data);
	    return d;
	}
	
	function asItem(data) {
	    var d = asObject(data);
	
	    (0, _warning2.default)(d && d.id || !data || data && (data._invalid || data._loading || data._error), 'item invalid and no id but properties!', data);
	    (0, _warning2.default)(!d || isObject(d), 'object or DataItem expected %s', data);
	
	    return d;
	}
	
	function idMap(data, propName) {
	
	    if (propName) {
	        console.error('Propname is used!');
	        //debugger;
	    }
	
	    var map = {};
	    if (data) {
	        var item = asObject(data);
	        if (item) {
	            if (Array.isArray(item)) {
	                item.forEach(function (i) {
	                    var id = propName ? i[propName] : i.id;
	                    if (id) {
	                        map[id] = true;
	                    } else {
	                        map[i] = true;
	                    }
	                });
	            } else {
	                var id = propName ? item[propName] : item.id;
	                if (id) {
	                    map[id] = true;
	                }
	            }
	        }
	    }
	    return map;
	}

/***/ }),
/* 135 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = debounce;
	/**
	 * Created by Nikolai Gorte
	 * User: n.gorte on 22.08.2016
	 * Copyright: xdot GmbH 2016
	 */
	
	/*export default function debounce(fn, delay) {
	    let timer = null;
	    return function () {
	        const context = this, args = arguments;
	        clearTimeout(timer);
	        timer = setTimeout(() => {
	            fn.apply(context, args);
	        }, delay);
	    };
	}*/
	
	function debounce(func, wait, immediate) {
	    var timeout;
	    return function () {
	        var context = this,
	            args = arguments;
	        var later = function later() {
	            timeout = null;
	            if (!immediate) func.apply(context, args);
	        };
	        var callNow = immediate && !timeout;
	        clearTimeout(timeout);
	        timeout = setTimeout(later, wait);
	        if (callNow) func.apply(context, args);
	    };
	}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 27.01.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	//Includes
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _appContext = __webpack_require__(67);
	
	var _translation = __webpack_require__(123);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	var _FlagHOC = __webpack_require__(128);
	
	var _DataListHoc = __webpack_require__(133);
	
	var _DataListHoc2 = _interopRequireDefault(_DataListHoc);
	
	var _reactVirtualized = __webpack_require__(137);
	
	var _dataUtil = __webpack_require__(134);
	
	var DataUtil = _interopRequireWildcard(_dataUtil);
	
	var _debounce = __webpack_require__(135);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScrollableDataListRV = function (_React$Component) {
	  _inherits(ScrollableDataListRV, _React$Component);
	
	  function ScrollableDataListRV(props) {
	    _classCallCheck(this, ScrollableDataListRV);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.rowRenderer = _this.rowRenderer.bind(_this);
	    _this.isRowLoaded = _this.isRowLoaded.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	
	    _this._cache = new _reactVirtualized.CellMeasurerCache({
	      fixedWidth: true,
	      minHeight: 50,
	      rowHeight: _this.props.rowHeight
	    });
	    return _this;
	  }
	
	  ScrollableDataListRV.prototype.componentDidMount = function componentDidMount() {
	    window.onresize = (0, _debounce2.default)(this.onResize, 50);
	  };
	
	  ScrollableDataListRV.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
	    if (!(0, _shallowEqual2.default)(this.props.activeIds, nextProps.activeIds) || !(0, _shallowEqual2.default)(this.props.disabledIds !== nextProps.disabledIds) || this.props.list._end !== nextProps.list._end) {
	      this.loader && this.loader._registeredChild.forceUpdateGrid();
	    }
	  };
	
	  ScrollableDataListRV.prototype.componentWillUnmount = function componentWillUnmount() {
	    window.onresize = undefined;
	  };
	
	  ScrollableDataListRV.prototype.onResize = function onResize() {
	    this.forceUpdate();
	  };
	
	  ScrollableDataListRV.prototype.scrollToIndex = function scrollToIndex(idx) {
	    this.loader && this.loader._registeredChild.scrollToRow(idx);
	  };
	
	  ScrollableDataListRV.prototype.checkInIdList = function checkInIdList(item, idItem, propName) {
	    var id = propName ? item[propName] : item.id;
	    var active = false;
	    if (idItem) {
	      if (idItem.item) {
	        if (Array.isArray(idItem.item)) {
	          var items = DataUtil.asArray(idItem);
	          items.forEach(function (i) {
	            var itemId = i && propName ? i[propName] : i.id;
	            if (id === itemId) {
	              active = true;
	            }
	          });
	        } else {
	          var item2 = DataUtil.asItem(idItem);
	          if (item2) {
	            var itemId = propName ? item2[propName] : item2.id;
	            if (id === itemId) {
	              return true;
	            }
	          }
	        }
	      } else {
	        var _itemId = propName ? idItem[propName] : idItem.id;
	        if (id === _itemId) {
	          return true;
	        }
	      }
	    }
	    return active;
	  };
	
	  ScrollableDataListRV.prototype.rowRenderer = function rowRenderer(_ref) {
	    var _this2 = this;
	
	    var index = _ref.index,
	        key = _ref.key,
	        parent = _ref.parent,
	        style = _ref.style;
	
	    //TODO We should only propagate known props
	    var _props = this.props,
	        list = _props.list,
	        ListItem = _props.ListItem,
	        onClick = _props.onClick,
	        propName = _props.propName,
	        activeIds = _props.activeIds,
	        disabledIds = _props.disabledIds,
	        loadMoreRows = _props.loadMoreRows,
	        otherProps = _objectWithoutProperties(_props, ['list', 'ListItem', 'onClick', 'propName', 'activeIds', 'disabledIds', 'loadMoreRows']);
	
	    var item = DataUtil.asArray(list)[index];
	
	    return _react2.default.createElement(
	      _reactVirtualized.CellMeasurer,
	      {
	        cache: this._cache,
	        columnIndex: 0,
	        key: key,
	        rowIndex: index,
	        parent: parent
	      },
	      function (_ref2) {
	        var measure = _ref2.measure;
	
	        if (!item) {
	          return null;
	        }
	        var active = _this2.checkInIdList(item, activeIds, propName);
	        var disabled = _this2.checkInIdList(item, disabledIds, propName);
	
	        return _react2.default.createElement(
	          'div',
	          { style: _extends({}, style), key: key },
	          _react2.default.createElement(ListItem, _extends({}, otherProps, {
	            index: index,
	            item: item,
	            disabled: disabled,
	            active: active,
	            onClick: onClick,
	            onLoad: measure,
	            list: list
	          }))
	        );
	      }
	    );
	  };
	
	  ScrollableDataListRV.prototype.isRowLoaded = function isRowLoaded(_ref3) {
	    var index = _ref3.index;
	
	    return index < DataUtil.asArray(this.props.list).length;
	  };
	
	  ScrollableDataListRV.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props2 = this.props,
	        list = _props2.list,
	        loadMoreRows = _props2.loadMoreRows,
	        _props2$size = _props2.size,
	        size = _props2$size === undefined ? 'small' : _props2$size,
	        _props2$rowHeight = _props2.rowHeight,
	        rowHeight = _props2$rowHeight === undefined ? 50 : _props2$rowHeight,
	        selectedNamedList = _props2.selectedNamedList,
	        otherProps = _objectWithoutProperties(_props2, ['list', 'loadMoreRows', 'size', 'rowHeight', 'selectedNamedList']);
	
	    var listSize = selectedNamedList ? selectedNamedList.entries.length : list && list._count || 0;
	    var listItems = list && list.item;
	    var height = 345;
	
	    if (window.innerWidth < 1200) {
	      height = 345;
	    } else {
	      if (size === 'medium') {
	        height = 500;
	      } else if (size === 'large') {
	        height = 920;
	      } else if (isFinite(size)) {
	        height = parseInt(size);
	      }
	    }
	
	    if (listItems && listItems.length === 0 && !(list && list._more)) {
	      return _react2.default.createElement(
	        _FlagHOC.FlagComponent,
	        { item: list },
	        _react2.default.createElement(
	          'div',
	          { style: { height: height },
	            className: 'error-message' },
	          _translation2.default.trans('no-entries')
	        )
	      );
	    }
	
	    return _react2.default.createElement(
	      _reactVirtualized.InfiniteLoader,
	      {
	        ref: function ref(loader) {
	          return _this3.loader = loader;
	        },
	        isRowLoaded: this.isRowLoaded,
	        loadMoreRows: loadMoreRows,
	        rowCount: listSize,
	        minimumBatchSize: _appContext.AppContext.DEFAULT_LIST_SIZE,
	        threshold: 15 },
	      function (_ref4) {
	        var onRowsRendered = _ref4.onRowsRendered,
	            registerChild = _ref4.registerChild;
	        return _react2.default.createElement(
	          _reactVirtualized.AutoSizer,
	          { disableHeight: true },
	          function (_ref5) {
	            var width = _ref5.width;
	            return _react2.default.createElement(_reactVirtualized.List, _extends({}, otherProps, {
	              height: height,
	              ref: registerChild,
	              onRowsRendered: onRowsRendered,
	              rowCount: listSize,
	              rowHeight: rowHeight || _this3._cache.rowHeight,
	              rowRenderer: _this3.rowRenderer,
	              width: width
	            }));
	          }
	        );
	      }
	    );
	  };
	
	  return ScrollableDataListRV;
	}(_react2.default.Component);
	
	ScrollableDataListRV.propTypes = {
	  ListItem: _propTypes2.default.func.isRequired,
	  activeIds: _propTypes2.default.object,
	  disabledIds: _propTypes2.default.object,
	  list: _propTypes2.default.object,
	  className: _propTypes2.default.string,
	  propName: _propTypes2.default.string,
	  loadMoreRows: _propTypes2.default.func.isRequired,
	  onClick: _propTypes2.default.func,
	  rowHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
	  useResponsiveHeight: _propTypes2.default.bool,
	  selectedNamedList: _propTypes2.default.object,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};
	
	exports.default = (0, _DataListHoc2.default)(ScrollableDataListRV);

/***/ }),
/* 137 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_137__;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /**
	                                                                                                                                                                                                                                                                   * Created by Nikolai Gorte
	                                                                                                                                                                                                                                                                   * User: n.gorte on 05.09.2016
	                                                                                                                                                                                                                                                                   * Copyright: xdot GmbH 2016
	                                                                                                                                                                                                                                                                   */
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBeautifulDnd = __webpack_require__(139);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var grid = 8;
	var getItemStyle = function getItemStyle(isDragging, draggableStyle, active) {
	  return _extends({
	    userSelect: 'none',
	    margin: '0 0 ' + grid + 'px 0',
	    padding: grid * 2,
	    boxShadow: 'rgba(0, 0, 0, 0.2) 0px 1px 2px 0px',
	    background: isDragging ? '#fbfbbc' : active ? '#eaeaea' : 'white',
	    display: 'flex',
	    flexDirection: 'row',
	    alignItems: 'center'
	  }, draggableStyle);
	};
	
	var getScrollableStyles = function getScrollableStyles(isScrollable, maxHeight) {
	  if (!isScrollable) {
	    return { maxHeight: 'none' };
	  }
	  if (maxHeight === 'small') {
	    return { maxHeight: 340, overflowY: 'auto' };
	  }
	  if (maxHeight === 'large') {
	    return { maxHeight: 740, overflowY: 'auto' };
	  }
	  return { maxHeight: 600, overflowY: 'auto' };
	};
	
	var getListStyle = function getListStyle(isScrollable, maxHeight) {
	  return _extends({
	    background: 'transparent',
	    padding: grid
	  }, getScrollableStyles(isScrollable, maxHeight));
	};
	
	function reorder(list, startIndex, endIndex) {
	  var result = Array.from(list);
	
	  var _result$splice = result.splice(startIndex, 1),
	      removed = _result$splice[0];
	
	  result.splice(endIndex, 0, removed);
	  return result;
	}
	
	function DraggableList(_ref) {
	  var changeOrder = _ref.changeOrder,
	      DragItem = _ref.DragItem,
	      list = _ref.list,
	      onEditElement = _ref.onEditElement,
	      onDeleteElement = _ref.onDeleteElement,
	      _onClick = _ref.onClick,
	      maxHeight = _ref.maxHeight,
	      isScrollable = _ref.isScrollable,
	      _ref$keyProp = _ref.keyProp,
	      keyProp = _ref$keyProp === undefined ? 'id' : _ref$keyProp,
	      active = _ref.active;
	
	
	  var onDragEnd = function onDragEnd(result) {
	    if (!result.destination) {
	      return;
	    }
	    var items = reorder(list, result.source.index, result.destination.index);
	    changeOrder(items);
	  };
	
	  return _react2.default.createElement(
	    _reactBeautifulDnd.DragDropContext,
	    { onDragEnd: onDragEnd },
	    _react2.default.createElement(
	      _reactBeautifulDnd.Droppable,
	      { droppableId: 'droppable' },
	      function (provided, snapshot) {
	        return _react2.default.createElement(
	          'div',
	          _extends({}, provided.droppableProps, {
	            ref: provided.innerRef,
	            style: getListStyle(isScrollable, maxHeight)
	          }),
	          list && list.map(function (item, index) {
	            return _react2.default.createElement(
	              _reactBeautifulDnd.Draggable,
	              {
	                key: item[keyProp],
	                draggableId: item[keyProp] && item[keyProp].toString() || index.toString(),
	                index: index
	              },
	              function (provided, snapshot) {
	                return _react2.default.createElement(
	                  'div',
	                  _extends({
	                    ref: provided.innerRef
	                  }, provided.draggableProps, provided.dragHandleProps, {
	                    style: getItemStyle(snapshot.isDragging, provided.draggableProps.style, active && active[keyProp] === item[keyProp]),
	                    onClick: function onClick() {
	                      return _onClick && _onClick(item);
	                    }
	                  }),
	                  _react2.default.createElement('i', { className: 'fa fa-sort mr-3' }),
	                  _react2.default.createElement(DragItem, {
	                    item: item,
	                    onEdit: onEditElement && onEditElement,
	                    onDelete: onDeleteElement && onDeleteElement,
	                    position: index
	                  })
	                );
	              }
	            );
	          })
	        );
	      }
	    )
	  );
	}
	
	DraggableList.propTypes = {
	  list: _propTypes2.default.array,
	  changeOrder: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onDeleteElement: _propTypes2.default.func,
	  onEditElement: _propTypes2.default.func,
	  DragItem: _propTypes2.default.func,
	  active: _propTypes2.default.object,
	  itemHeight: _propTypes2.default.number,
	  margin: _propTypes2.default.number,
	  isScrollable: _propTypes2.default.bool,
	  maxHeight: _propTypes2.default.oneOf(['none', 'small', 'medium', 'large']),
	  keyProp: _propTypes2.default.string
	};
	
	exports.default = DraggableList;

/***/ }),
/* 139 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_139__;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _translation = __webpack_require__(123);
	
	var _translation2 = _interopRequireDefault(_translation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LiferayFormComponent = function LiferayFormComponent(_ref) {
	    var formData = _ref.formData,
	        formValidation = _ref.formValidation,
	        propName = _ref.propName,
	        required = _ref.required,
	        className = _ref.className,
	        children = _ref.children;
	
	    return _react2.default.createElement(
	        'div',
	        {
	            className: 'control-group input-String-wrapper ' + (propName ? ' ' + propName + ' ' : '') + (className ? className : '') + (formData && formValidation && propName && formValidation[propName] && formValidation[propName].length ? ' error' : '') },
	        _react2.default.createElement(
	            'label',
	            { className: 'control-label' },
	            _translation2.default.trans(propName) + ' ',
	            required && _react2.default.createElement(
	                'span',
	                { className: 'label-required' },
	                '(Erforderlich)'
	            )
	        ),
	        children && children,
	        formData && formValidation && propName && formValidation[propName] && formValidation[propName].length > 0 && _react2.default.createElement(
	            'div',
	            { className: 'form-validator-stack help-inline' },
	            _react2.default.createElement(
	                'div',
	                { role: 'alert', className: 'required' },
	                formValidation[propName]
	            )
	        )
	    );
	}; /**
	    * Created by Carsten Bühler
	    * User: c.buehler on 11.04.2017
	    * Copyright: xdot GmbH 2015
	    */
	
	
	LiferayFormComponent.propTypes = {
	    children: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array, _propTypes2.default.element]),
	    formData: _propTypes2.default.object,
	    propName: _propTypes2.default.string,
	    formValidation: _propTypes2.default.object,
	    required: _propTypes2.default.bool,
	    className: _propTypes2.default.string
	};
	
	exports.default = LiferayFormComponent;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 17.02.2016
	 * Copyright: xdot GmbH 2015
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaIcon = function FaIcon(_ref) {
	    var name = _ref.name,
	        title = _ref.title,
	        onClick = _ref.onClick;
	
	    return _react2.default.createElement('span', {
	        className: 'fa fa-' + name,
	        onClick: onClick,
	        title: title || ''
	    });
	};
	
	FaIcon.propTypes = {
	    name: _propTypes2.default.string,
	    propName: _propTypes2.default.string,
	    title: _propTypes2.default.string,
	    onClick: _propTypes2.default.func
	};
	
	exports.default = FaIcon;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * User: n.gorte
	 * Date: 28.03.2019
	 * Time: 11:28
	 */
	'use strict';
	
	exports.__esModule = true;
	exports.WYSIWYGEditor = undefined;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactQuill = __webpack_require__(143);
	
	var _reactQuill2 = _interopRequireDefault(_reactQuill);
	
	__webpack_require__(144);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	__webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_MODULES = {
	    toolbar: [[{ 'header': [4, false] }], ['bold', 'italic', 'underline', 'strike'], [{ 'list': 'ordered' }, { 'list': 'bullet' }], ['link']]
	};
	
	var DEFAULT_FORMATS = ['header', 'bold', 'italic', 'underline', 'strike', 'list', 'bullet', 'link'];
	
	var WYSIWYGEditor = exports.WYSIWYGEditor = function WYSIWYGEditor(_ref) {
	    var placeholder = _ref.placeholder,
	        style = _ref.style,
	        value = _ref.value,
	        onChange = _ref.onChange,
	        _ref$formats = _ref.formats,
	        formats = _ref$formats === undefined ? DEFAULT_FORMATS : _ref$formats,
	        _ref$modules = _ref.modules,
	        modules = _ref$modules === undefined ? DEFAULT_MODULES : _ref$modules;
	
	
	    var onEditorChange = function onEditorChange(value, delta, source, editor) {
	        //Every change of value seems to trigger a direct onChange.
	        //If to or more changes a queued in the async dispatcher this may cause a loop where every change causes a new change.
	        //Because of this we filter out all api changes. This should work as long as no external changes are made over the api.
	        if (source === 'api') {
	            console.log('onEditorChange api', value, source);
	        } else {
	            onChange(value);
	        }
	    };
	
	    return _react2.default.createElement(_reactQuill2.default, {
	        className: 'fliwas-wysiwyg-editor',
	        style: style,
	        placeholder: placeholder,
	        value: value,
	        onChange: onEditorChange,
	        modules: modules,
	        formats: formats
	    });
	};
	
	WYSIWYGEditor.propTypes = {
	    placeholder: _propTypes2.default.string,
	    style: _propTypes2.default.object,
	    value: _propTypes2.default.string.isRequired,
	    onChange: _propTypes2.default.func.isRequired,
	    formats: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    modules: _propTypes2.default.object
	};

/***/ }),
/* 143 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_143__;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_144__;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(146);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(122)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_wysiwyg.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_wysiwyg.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(121)();
	// imports
	
	
	// module
	exports.push([module.id, ".fliwas-wysiwyg-editor{z-index:100;position:relative}.fliwas-wysiwyg-editor .ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]:before,.fliwas-wysiwyg-editor .ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]:before{content:\"Titel\"}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip{left:0!important}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip[data-mode=link]:before{content:\"Link hier einf\\FCgen:\"}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip:before{content:\"URL besuchen:\"}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip a.ql-action:after{content:\"Bearbeiten\"}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip a.ql-remove:before{content:\"L\\F6schen\"}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip.ql-editing{left:0!important}.fliwas-wysiwyg-editor .ql-snow .ql-tooltip.ql-editing a.ql-action:after{content:\"Speichern\"}.fliwas-wysiwyg-editor .ql-container{height:250px}", ""]);
	
	// exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Header = undefined;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactBootstrap = __webpack_require__(111);
	
	__webpack_require__(148);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * User: n.gorte
	 * Date: 24.06.2022
	 * Time: 12:30
	 */
	
	var Header = exports.Header = function Header(_ref) {
	    var onClose = _ref.onClose,
	        children = _ref.children;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'fliwas-header' },
	        children,
	        onClose && _react2.default.createElement(
	            _reactBootstrap.Button,
	            {
	                variant: 'outline-primary',
	                className: 'fliwas-header__button fliwas-header__button-close',
	                onClick: onClose
	            },
	            _react2.default.createElement('span', { className: 'icon icon-map-x leaflet-sidebar__close-icon' })
	        )
	    );
	};
	
	Header.propTypes = {
	    onClose: _propTypes2.default.func,
	    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
	};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(149);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(122)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_header.scss", function() {
				var newContent = require("!!../../../../../../../node_modules/css-loader/index.js!../../../../../../../node_modules/sass-loader/index.js!./_header.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(121)();
	// imports
	
	
	// module
	exports.push([module.id, ".fliwas-header{position:sticky;top:0;display:flex;flex-direction:row;align-items:center;justify-content:space-between;padding:16px;color:#fff;background-color:#326487;box-shadow:0 0 4px #333301;margin-bottom:16px;z-index:1}@media (min-width:768px){.fliwas-header{color:#326487;background-color:#fff;box-shadow:none;margin-bottom:0}}.fliwas-header__button{height:32px;width:32px;padding:0;margin-bottom:0;border-color:#fff;color:#fff;display:flex;align-items:center;justify-content:center}.fliwas-header__button:hover{color:#fff}@media (min-width:768px){.fliwas-header__button-close{display:none}}.fliwas-header__close-icon{font-size:20px}", ""]);
	
	// exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.PdfViewer = PdfViewer;
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function PdfViewer(_ref) {
	  var url = _ref.url,
	      _ref$className = _ref.className,
	      className = _ref$className === undefined ? '' : _ref$className,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? '100%' : _ref$height,
	      _ref$width = _ref.width,
	      width = _ref$width === undefined ? '100%' : _ref$width;
	
	  var objectRef = (0, _react.useRef)();
	
	  var _useState = (0, _react.useState)(false),
	      error = _useState[0],
	      setError = _useState[1];
	
	  (0, _react.useEffect)(function () {
	    function setUp() {
	      fetch(url).then(function (res) {
	        if (!res.ok) {
	          throw new Error('Network response was not ok');
	        }
	        return res.blob();
	      }).then(function (blob) {
	        var pdfBlob = new Blob([blob], { type: 'application/pdf' });
	        objectRef.current.data = URL.createObjectURL(pdfBlob);
	      }).catch(function (e) {
	        setError(true);
	        console.error('ERROR', e);
	      });
	    }
	
	    setUp();
	  }, [url]);
	
	  if (error) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'span',
	        { className: 'd-block' },
	        'PDF konnte nicht geladen werden!'
	      ),
	      _react2.default.createElement(
	        'a',
	        { className: 'd-block', href: url, target: '_blank', rel: 'noreferrer' },
	        url
	      )
	    );
	  }
	  return _react2.default.createElement('object', {
	    ref: objectRef,
	    type: 'application/pdf',
	    className: className,
	    height: height,
	    width: width,
	    data: ''
	  });
	}
	
	PdfViewer.propTypes = {
	  url: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
	};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Created by Carsten Hibbeler on 06.02.2016.
	 *
	 * Based on FluxContainer by Facebook, Inc.
	 */
	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _FluxStoreGroup = __webpack_require__(152);
	
	var _FluxStoreGroup2 = _interopRequireDefault(_FluxStoreGroup);
	
	var _invariant = __webpack_require__(153);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _shallowEqual = __webpack_require__(99);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _uidUtil = __webpack_require__(100);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEFAULT_OPTIONS = {
	    pure: true,
	    withProps: false
	};
	
	/**
	 * A FluxContainer is used to subscribe a react component to multiple stores.
	 * The stores that are used must be returned from a static `getStores()` method.
	 *
	 * The component receives information from the stores via state. The state
	 * is generated using a static `calculateState()` method that each container
	 * must implement. A simple container may look like:
	 */
	
	function create(Base, options) {
	    enforceInterface(Base);
	
	    // Construct the options using default, override with user values as necessary.
	    var realOptions = _extends({}, DEFAULT_OPTIONS, options || {});
	
	    var FluxContainerClass = function (_Base) {
	        _inherits(FluxContainerClass, _Base);
	
	        // _fluxContainerStoreGroup: FluxStoreGroup;
	        // _fluxContainerSubscriptions: Array<{remove: Function}>;
	
	        function FluxContainerClass(props) {
	            _classCallCheck(this, FluxContainerClass);
	
	            var _this = _possibleConstructorReturn(this, _Base.call(this, props));
	
	            _this.uid = _this.uid || (0, _uidUtil.generateId)(Base.name);
	            _this.DATA = _this.DATA || {};
	            _this.state = realOptions.withProps ? Base.calculateState(_this.state, props, _this.DATA) : Base.calculateState(_this.state, undefined, _this.DATA);
	            return _this;
	        }
	
	        FluxContainerClass.prototype.withCtx = function withCtx(s) {
	            return (this.uid || (this.uid = (0, _uidUtil.generateId)(Base.name))) + '.' + s;
	        };
	
	        FluxContainerClass.prototype.componentDidMount = function componentDidMount() {
	            var _this2 = this;
	
	            if (_Base.prototype.componentDidMount) {
	                _Base.prototype.componentDidMount.call(this);
	            }
	
	            var stores = Base.getStores();
	
	            // This tracks when any store has changed and we may need to update.
	            var changed = false;
	            var setChanged = function setChanged() {
	                changed = true;
	            };
	
	            // This adds subscriptions to stores. When a store changes all we do is
	            // set changed to true.
	            this._fluxContainerSubscriptions = stores.map(function (store) {
	                return store.addListener(setChanged);
	            });
	
	            // This callback is called after the dispatch of the relevant stores. If
	            // any have reported a change we update the state, then reset changed.
	            var callback = function callback() {
	                if (changed) {
	                    _this2.setState(function (prevState) {
	                        return realOptions.withProps ? Base.calculateState(prevState, _this2.props, _this2.DATA) : Base.calculateState(prevState, undefined, _this2.DATA);
	                    });
	                }
	                changed = false;
	            };
	            this._fluxContainerStoreGroup = new _FluxStoreGroup2.default(stores, callback);
	        };
	
	        FluxContainerClass.prototype.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
	            if (_Base.prototype.UNSAFE_componentWillReceiveProps) {
	                _Base.prototype.UNSAFE_componentWillReceiveProps.call(this, nextProps, nextContext);
	            }
	
	            // Don't do anything else if the container is not configured to use props.
	            if (!realOptions.withProps) {
	                return;
	            }
	
	            // If it's pure we can potentially optimize out the calculate state.
	            if (realOptions.pure && (0, _shallowEqual2.default)(this.props, nextProps)) {
	                return;
	            }
	
	            // Finally update the state using the new props.
	            this.setState(function (prevState) {
	                return Base.calculateState(prevState, nextProps);
	            });
	        };
	
	        FluxContainerClass.prototype.componentWillUnmount = function componentWillUnmount() {
	            if (_Base.prototype.componentWillUnmount) {
	                _Base.prototype.componentWillUnmount.call(this);
	            }
	
	            this._fluxContainerStoreGroup.release();
	            for (var _iterator = this._fluxContainerSubscriptions, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
	                var _ref;
	
	                if (_isArray) {
	                    if (_i >= _iterator.length) break;
	                    _ref = _iterator[_i++];
	                } else {
	                    _i = _iterator.next();
	                    if (_i.done) break;
	                    _ref = _i.value;
	                }
	
	                var subscription = _ref;
	
	                subscription.remove();
	            }
	            this._fluxContainerSubscriptions = [];
	        };
	
	        return FluxContainerClass;
	    }(Base);
	
	    // Make sure we override shouldComponentUpdate only if the pure option is
	    // specified. We can't override this above because we don't want to override
	    // the default behavior on accident. Super works weird with react ES6 classes
	    // right now.
	
	
	    var container = realOptions.pure ? createPureContainer(FluxContainerClass) : FluxContainerClass;
	
	    // Update the name of the container before returning.
	    var componentName = Base.displayName || Base.name;
	    container.displayName = 'FluxContainer(' + componentName + ')';
	
	    return container;
	}
	
	// TODO: typecheck this better.
	function createPureContainer(FluxContainerBase) {
	    var PureFluxContainerClass = function (_FluxContainerBase) {
	        _inherits(PureFluxContainerClass, _FluxContainerBase);
	
	        function PureFluxContainerClass() {
	            _classCallCheck(this, PureFluxContainerClass);
	
	            return _possibleConstructorReturn(this, _FluxContainerBase.apply(this, arguments));
	        }
	
	        PureFluxContainerClass.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	            return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	        };
	
	        return PureFluxContainerClass;
	    }(FluxContainerBase);
	
	    return PureFluxContainerClass;
	}
	
	function enforceInterface(o) {
	    (0, _invariant2.default)(o.getStores, 'Components that use FluxContainer must implement `static getStores()`');
	    (0, _invariant2.default)(o.calculateState, 'Components that use FluxContainer must implement `static calculateState()`');
	}
	
	exports.default = { create: create };

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxStoreGroup
	 * 
	 */
	
	'use strict';
	
	function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var invariant = __webpack_require__(71);
	/**
	 * FluxStoreGroup allows you to execute a callback on every dispatch after
	 * waiting for each of the given stores.
	 */
	var FluxStoreGroup = /*#__PURE__*/function () {
	  function FluxStoreGroup(stores, callback) {
	    var _this = this;
	    _defineProperty(this, "_dispatcher", void 0);
	    _defineProperty(this, "_dispatchToken", void 0);
	    this._dispatcher = _getUniformDispatcher(stores);
	
	    // Precompute store tokens.
	    var storeTokens = stores.map(function (store) {
	      return store.getDispatchToken();
	    });
	
	    // Register with the dispatcher.
	    this._dispatchToken = this._dispatcher.register(function (payload) {
	      _this._dispatcher.waitFor(storeTokens);
	      callback();
	    });
	  }
	  var _proto = FluxStoreGroup.prototype;
	  _proto.release = function release() {
	    this._dispatcher.unregister(this._dispatchToken);
	  };
	  return FluxStoreGroup;
	}();
	function _getUniformDispatcher(stores) {
	  !(stores && stores.length) ?  false ? invariant(false, 'Must provide at least one store to FluxStoreGroup') : invariant(false) : void 0;
	  var dispatcher = stores[0].getDispatcher();
	  if (false) {
	    var _iterator = _createForOfIteratorHelper(stores),
	      _step;
	    try {
	      for (_iterator.s(); !(_step = _iterator.n()).done;) {
	        var store = _step.value;
	        !(store.getDispatcher() === dispatcher) ? process.env.NODE_ENV !== "production" ? invariant(false, 'All stores in a FluxStoreGroup must use the same dispatcher') : invariant(false) : void 0;
	      }
	    } catch (err) {
	      _iterator.e(err);
	    } finally {
	      _iterator.f();
	    }
	  }
	  return dispatcher;
	}
	module.exports = FluxStoreGroup;

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	
	    if (false) {
	        if (format === undefined) {
	            throw new Error('invariant requires an error message argument');
	        }
	    }
	
	    if (!condition) {
	        var error = void 0;
	        if (format === undefined) {
	            error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	        } else {
	            var args = [a, b, c, d, e, f];
	            var argIndex = 0;
	            error = new Error(format.replace(/%s/g, function () {
	                return args[argIndex++];
	            }));
	            error.name = 'Invariant Violation';
	        }
	
	        error.framesToPop = 1; // we don't care about invariant's own frame
	        throw error;
	    }
	}
	
	module.exports = invariant;

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(109);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(110);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlagHOC = __webpack_require__(128);
	
	var _FlagHOC2 = _interopRequireDefault(_FlagHOC);
	
	var _FluxContainer = __webpack_require__(155);
	
	var _FluxContainer2 = _interopRequireDefault(_FluxContainer);
	
	var _warning = __webpack_require__(78);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DEPRECATION = 'Old binding style dataName="xxx" is deprecated! Use bound prop name with the remote data name as value: list="xxx". ';
	
	//TODO as optimization we could use fluxcontainer only for multi store bindings. From flux doc: A FluxContainer is used to subscribe a react component to multiple stores.
	var DataLinkContainer = {
	
	    /**
	     * Binds props to (RemoteData)Stores.
	     * Set the props of the returning Component to the dataName.
	     * (In future we may also support names of store methodes for non RemoteData Stores)
	     *
	     * 1. Style - Bind a prop to a store
	     * link(BaseComponent, 'prop', store);
	     *
	     * 2. Style - Bind multiple props to one store
	     * link(BaseComponent, ['prop1','prop2','prop3'], store);
	     *
	     * 3. Style - Bind multiple props to different stores
	     * link(BaseComponent, { 'prop1': storeA ,'prop2': storeB ,'prop3': storeC });
	     */
	    link: function link(Base, bindings, Store) {
	        var noFlagHoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
	
	
	        var baseName = Base.name;
	
	        if (typeof bindings === 'string' || bindings instanceof String) {
	            var _bindings;
	
	            if (!Store) {
	                throw new Error('Store expected');
	            }
	            bindings = (_bindings = {}, _bindings[bindings] = Store, _bindings);
	        } else if (Array.isArray(bindings)) {
	            if (!Store) {
	                throw new Error('Store expected');
	            }
	            bindings = bindings.reduce(function (b, prop) {
	                b[prop] = Store;
	                return b;
	            }, {});
	        }
	
	        var boundProps = Object.keys(bindings);
	
	        var stores = boundProps.reduce(function (stores, prop) {
	            var store = bindings[prop];
	
	            stores.indexOf(store) < 0 && stores.push(store);
	            return stores;
	        }, []);
	
	        if (!noFlagHoc) {
	            Base = (0, _FlagHOC2.default)(Base, boundProps);
	        }
	
	        var RemoteDataLinkComponent = function (_React$Component) {
	            _inherits(RemoteDataLinkComponent, _React$Component);
	
	            function RemoteDataLinkComponent() {
	                _classCallCheck(this, RemoteDataLinkComponent);
	
	                return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	            }
	
	            RemoteDataLinkComponent.getStores = function getStores() {
	                return stores;
	            };
	
	            RemoteDataLinkComponent.calculateState = function calculateState(prevState, props) {
	                var newState = void 0;
	                boundProps.forEach(function (prop) {
	                    var current = prevState && prevState[prop],
	                        store = bindings[prop];
	                    var dataName = props[prop];
	
	                    if (props.dataName) {
	                        if (boundProps.length === 1) {
	                            (0, _warning2.default)(false, DEPRECATION + ' > ' + baseName);
	                            dataName = props.dataName;
	                        } else {
	                            throw new Error(DEPRECATION + ' > ' + baseName);
	                        }
	                    }
	                    (0, _warning2.default)(dataName, 'No dataName for bound prop: ' + prop + ' found!');
	
	                    var next = store.getRemoteData(dataName);
	
	                    if (!next) {
	                        //  console.warn('Linked Data \'' + dataName + '\' not initialized');
	                    }
	
	                    if (!current || current !== next) {
	                        if (!newState) {
	                            newState = _extends({}, prevState);
	                        }
	                        newState[prop] = next;
	                    }
	                });
	
	                return newState || prevState;
	            };
	
	            RemoteDataLinkComponent.prototype.render = function render() {
	                return _react2.default.createElement(Base, _extends({}, this.props, this.state));
	            };
	
	            return RemoteDataLinkComponent;
	        }(_react2.default.Component);
	
	        return _FluxContainer2.default.create(RemoteDataLinkComponent, { withProps: true });
	    }
	};
	
	DataLinkContainer.propTypes = {
	    dataName: _propTypes2.default.string.isRequired
	};
	
	exports.default = DataLinkContainer;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainer
	 * 
	 */
	
	'use strict';
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var FluxContainerSubscriptions = __webpack_require__(156);
	var React = __webpack_require__(157);
	var invariant = __webpack_require__(71);
	var shallowEqual = __webpack_require__(158);
	var Component = React.Component;
	var DEFAULT_OPTIONS = {
	  pure: true,
	  withProps: false,
	  withContext: false
	};
	
	/**
	 * A FluxContainer is used to subscribe a react component to multiple stores.
	 * The stores that are used must be returned from a static `getStores()` method.
	 *
	 * The component receives information from the stores via state. The state
	 * is generated using a static `calculateState()` method that each container
	 * must implement. A simple container may look like:
	 *
	 *   class FooContainer extends Component {
	 *     static getStores() {
	 *       return [FooStore];
	 *     }
	 *
	 *     static calculateState() {
	 *       return {
	 *         foo: FooStore.getState(),
	 *       };
	 *     }
	 *
	 *     render() {
	 *       return <FooView {...this.state} />;
	 *     }
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer);
	 *
	 * Flux container also supports some other, more advanced use cases. If you need
	 * to base your state off of props as well:
	 *
	 *   class FooContainer extends Component {
	 *     ...
	 *
	 *     static calculateState(prevState, props) {
	 *       return {
	 *         foo: FooStore.getSpecificFoo(props.id),
	 *       };
	 *     }
	 *
	 *     ...
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer, {withProps: true});
	 *
	 * Or if your stores are passed through your props:
	 *
	 *   class FooContainer extends Component {
	 *     ...
	 *
	 *     static getStores(props) {
	 *       const {BarStore, FooStore} = props.stores;
	 *       return [BarStore, FooStore];
	 *     }
	 *
	 *     static calculateState(prevState, props) {
	 *       const {BarStore, FooStore} = props.stores;
	 *       return {
	 *         bar: BarStore.getState(),
	 *         foo: FooStore.getState(),
	 *       };
	 *     }
	 *
	 *     ...
	 *   }
	 *
	 *   module.exports = FluxContainer.create(FooContainer, {withProps: true});
	 */
	function create(Base, options) {
	  enforceInterface(Base);
	
	  // Construct the options using default, override with user values as necessary.
	  var realOptions = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options || {});
	  var getState = function getState(state, maybeProps, maybeContext) {
	    var props = realOptions.withProps ? maybeProps : undefined;
	    var context = realOptions.withContext ? maybeContext : undefined;
	    return Base.calculateState(state, props, context);
	  };
	  var getStores = function getStores(maybeProps, maybeContext) {
	    var props = realOptions.withProps ? maybeProps : undefined;
	    var context = realOptions.withContext ? maybeContext : undefined;
	    return Base.getStores(props, context);
	  };
	
	  // Build the container class.
	  var ContainerClass = /*#__PURE__*/function (_Base) {
	    _inheritsLoose(ContainerClass, _Base);
	    function ContainerClass(props, context) {
	      var _this;
	      _this = _Base.call(this, props, context) || this;
	      _defineProperty(_assertThisInitialized(_this), "_fluxContainerSubscriptions", void 0);
	      _this._fluxContainerSubscriptions = new FluxContainerSubscriptions();
	      _this._fluxContainerSubscriptions.setStores(getStores(props, context));
	      _this._fluxContainerSubscriptions.addListener(function () {
	        _this.setState(function (prevState, currentProps) {
	          return getState(prevState, currentProps, context);
	        });
	      });
	      var calculatedState = getState(undefined, props, context);
	      _this.state = _objectSpread(_objectSpread({}, _this.state || {}), calculatedState);
	      return _this;
	    }
	    var _proto = ContainerClass.prototype;
	    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
	      if (_Base.prototype.UNSAFE_componentWillReceiveProps) {
	        _Base.prototype.UNSAFE_componentWillReceiveProps.call(this, nextProps, nextContext);
	      }
	      if (_Base.prototype.componentWillReceiveProps) {
	        _Base.prototype.componentWillReceiveProps.call(this, nextProps, nextContext);
	      }
	      if (realOptions.withProps || realOptions.withContext) {
	        // Update both stores and state.
	        this._fluxContainerSubscriptions.setStores(getStores(nextProps, nextContext));
	        this.setState(function (prevState) {
	          return getState(prevState, nextProps, nextContext);
	        });
	      }
	    };
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      if (_Base.prototype.componentWillUnmount) {
	        _Base.prototype.componentWillUnmount.call(this);
	      }
	      this._fluxContainerSubscriptions.reset();
	    };
	    return ContainerClass;
	  }(Base); // Make sure we override shouldComponentUpdate only if the pure option is
	  // specified. We can't override this above because we don't want to override
	  // the default behavior on accident. Super works weird with react ES6 classes.
	  var container = realOptions.pure ? createPureComponent(ContainerClass) : ContainerClass;
	
	  // Update the name of the container before returning
	  var componentName = Base.displayName || Base.name;
	  container.displayName = 'FluxContainer(' + componentName + ')';
	  return container;
	}
	function createPureComponent(BaseComponent) {
	  var PureComponent = /*#__PURE__*/function (_BaseComponent) {
	    _inheritsLoose(PureComponent, _BaseComponent);
	    function PureComponent() {
	      return _BaseComponent.apply(this, arguments) || this;
	    }
	    var _proto2 = PureComponent.prototype;
	    _proto2.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	      return !shallowEqual(this.props, nextProps) || !shallowEqual(this.state, nextState);
	    };
	    return PureComponent;
	  }(BaseComponent);
	  return PureComponent;
	}
	function enforceInterface(o) {
	  !o.getStores ?  false ? invariant(false, 'Components that use FluxContainer must implement `static getStores()`') : invariant(false) : void 0;
	  !o.calculateState ?  false ? invariant(false, 'Components that use FluxContainer must implement `static calculateState()`') : invariant(false) : void 0;
	}
	
	/**
	 * This is a way to connect stores to a functional stateless view. Here's a
	 * simple example:
	 *
	 *   // FooView.js
	 *
	 *   function FooView(props) {
	 *     return <div>{props.value}</div>;
	 *   }
	 *
	 *   module.exports = FooView;
	 *
	 *
	 *   // FooContainer.js
	 *
	 *   function getStores() {
	 *     return [FooStore];
	 *   }
	 *
	 *   function calculateState() {
	 *     return {
	 *       value: FooStore.getState();
	 *     };
	 *   }
	 *
	 *   module.exports = FluxContainer.createFunctional(
	 *     FooView,
	 *     getStores,
	 *     calculateState,
	 *   );
	 *
	 */
	function createFunctional(viewFn, _getStores, _calculateState, options) {
	  var FunctionalContainer = /*#__PURE__*/function (_Component) {
	    _inheritsLoose(FunctionalContainer, _Component);
	    function FunctionalContainer() {
	      var _this2;
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	      _this2 = _Component.call.apply(_Component, [this].concat(args)) || this;
	      _defineProperty(_assertThisInitialized(_this2), "state", void 0);
	      return _this2;
	    }
	    FunctionalContainer.getStores = function getStores(props, context) {
	      return _getStores(props, context);
	    };
	    FunctionalContainer.calculateState = function calculateState(prevState, props, context) {
	      return _calculateState(prevState, props, context);
	    };
	    var _proto3 = FunctionalContainer.prototype;
	    _proto3.render = function render() {
	      return viewFn(this.state);
	    };
	    return FunctionalContainer;
	  }(Component); // Update the name of the component before creating the container.
	  var viewFnName = viewFn.displayName || viewFn.name || 'FunctionalContainer';
	  FunctionalContainer.displayName = viewFnName;
	  return create(FunctionalContainer, options);
	}
	module.exports = {
	  create: create,
	  createFunctional: createFunctional
	};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) Meta Platforms, Inc. and affiliates. All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FluxContainerSubscriptions
	 * 
	 */
	
	'use strict';
	
	function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
	function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
	var FluxStoreGroup = __webpack_require__(152);
	function shallowArrayEqual(a, b) {
	  if (a === b) {
	    return true;
	  }
	  if (a.length !== b.length) {
	    return false;
	  }
	  for (var i = 0; i < a.length; i++) {
	    if (a[i] !== b[i]) {
	      return false;
	    }
	  }
	  return true;
	}
	var FluxContainerSubscriptions = /*#__PURE__*/function () {
	  function FluxContainerSubscriptions() {
	    _defineProperty(this, "_callbacks", void 0);
	    _defineProperty(this, "_storeGroup", void 0);
	    _defineProperty(this, "_stores", void 0);
	    _defineProperty(this, "_tokens", void 0);
	    this._callbacks = [];
	  }
	  var _proto = FluxContainerSubscriptions.prototype;
	  _proto.setStores = function setStores(stores) {
	    var _this = this;
	    if (this._stores && shallowArrayEqual(this._stores, stores)) {
	      return;
	    }
	    this._stores = stores;
	    this._resetTokens();
	    this._resetStoreGroup();
	    var changed = false;
	    var changedStores = [];
	    if (false) {
	      // Keep track of the stores that changed for debugging purposes only
	      this._tokens = stores.map(function (store) {
	        return store.addListener(function () {
	          changed = true;
	          changedStores.push(store);
	        });
	      });
	    } else {
	      var setChanged = function setChanged() {
	        changed = true;
	      };
	      this._tokens = stores.map(function (store) {
	        return store.addListener(setChanged);
	      });
	    }
	    var callCallbacks = function callCallbacks() {
	      if (changed) {
	        _this._callbacks.forEach(function (fn) {
	          return fn();
	        });
	        changed = false;
	        if (false) {
	          // Uncomment this to print the stores that changed.
	          // console.log(changedStores);
	          changedStores = [];
	        }
	      }
	    };
	    this._storeGroup = new FluxStoreGroup(stores, callCallbacks);
	  };
	  _proto.addListener = function addListener(fn) {
	    this._callbacks.push(fn);
	  };
	  _proto.reset = function reset() {
	    this._resetTokens();
	    this._resetStoreGroup();
	    this._resetCallbacks();
	    this._resetStores();
	  };
	  _proto._resetTokens = function _resetTokens() {
	    if (this._tokens) {
	      this._tokens.forEach(function (token) {
	        return token.remove();
	      });
	      this._tokens = null;
	    }
	  };
	  _proto._resetStoreGroup = function _resetStoreGroup() {
	    if (this._storeGroup) {
	      this._storeGroup.release();
	      this._storeGroup = null;
	    }
	  };
	  _proto._resetStores = function _resetStores() {
	    this._stores = null;
	  };
	  _proto._resetCallbacks = function _resetCallbacks() {
	    this._callbacks = [];
	  };
	  return FluxContainerSubscriptions;
	}();
	module.exports = FluxContainerSubscriptions;

/***/ }),
/* 157 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_157__;

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  } // Test for A's keys different from B.
	
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keymirror = __webpack_require__(73);
	
	var _keymirror2 = _interopRequireDefault(_keymirror);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _keymirror2.default)({
	  PAGE_SELECTED: null
	}); /**
	     * Created by Carsten Bühler
	     * User: CBuehler on 18.02.2016
	     * Copyright: xdot GmbH 2015
	     */

/***/ }),
/* 160 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = detectIE;
	function detectIE() {
	    var ua = window.navigator.userAgent;
	
	    var msie = ua.indexOf('MSIE ');
	    if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	
	    var trident = ua.indexOf('Trident/');
	    if (trident > 0) {
	        // IE 11 => return version number
	        var rv = ua.indexOf('rv:');
	        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
	    }
	
	    /*const edge = ua.indexOf('Edge/');
	    if (edge > 0) {
	        // Edge (IE 12+) => return version number
	        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
	    }*/
	
	    // other browser
	    return undefined;
	}

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _reactDom = __webpack_require__(80);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Liferay.on('closePortlet', function (e) {
	    _reactDom2.default.unmountComponentAtNode(document.getElementById('widget-container_' + e.portletId));
	}); /**
	     * Created by Carsten Hibbeler on 25.01.2016.
	     */
	
	AUI().use('node-base', function (Y) {
	    // Liferay (AUI) tests node.getDOMNode to check if a node is a Y_Node (node-core.js).
	    // Because react nodes also implements getDOMNode the result of Y.Node.one is wrong.
	    Y.Node.foo = 1;
	    var UID = '_yuid';
	    var Y_Node = Y.Node;
	    Y.Node.one = Y.one = function (node) {
	        var instance = null,
	            cachedNode = void 0,
	            uid = void 0;
	
	        if (node) {
	            if (typeof node === 'string') {
	                node = Y_Node._fromString(node);
	                if (!node) {
	                    return null; // NOTE: return
	                }
	            } else if (node.getDOMNode && (!node.dataset || !node.dataset.reactid)) {
	                return node; // NOTE: return
	            }
	
	            if (node.nodeType || Y.DOM.isWindow(node)) {
	                // avoid bad input (numbers, boolean, etc)
	                uid = node.uniqueID && node.nodeType !== 9 ? node.uniqueID : node._yuid;
	                instance = Y_Node._instances[uid]; // reuse exising instances
	                cachedNode = instance ? instance._node : null;
	                if (!instance || cachedNode && node !== cachedNode) {
	                    // new Node when nodes don't match
	                    instance = new Y_Node(node);
	                    if (node.nodeType !== 11) {
	                        // dont cache document fragment
	                        Y_Node._instances[instance[UID]] = instance; // cache node
	                    }
	                }
	            }
	        }
	
	        return instance;
	    };
	});

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _appContext = __webpack_require__(67);
	
	var _amdUtils = __webpack_require__(115);
	
	var _ActionTypesCommon = __webpack_require__(75);
	
	var _ActionTypesCommon2 = _interopRequireDefault(_ActionTypesCommon);
	
	var _RemoteDataActions = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by Carsten Hibbeler on 14.09.2016.
	 * Copyright: xdot GmbH 2015
	 */
	
	var DataEventSocket = undefined;
	
	//Connect the FLIWAS-Objects to the Websockets needed for States and Measurements
	var ADDITIONAL_TOPICS = {
	    Group: ['StateValue', 'Organization'],
	    FloodProtectionObjectPoint: ['StateValue'],
	    FloodProtectionObjectLine: ['StateValue'],
	    CriticalObject: ['StateValue'],
	    FloodRetentionBasin: ['StateValue', 'BasinFillLevel', 'BasinFillDegree', 'WaterLevel', 'WaterFlow'],
	    PrecipitationStation: ['StateValue', 'PrecipitationValue'],
	    RealPrecipitationStation: ['StateValue', 'PrecipitationValue'],
	    GaugingStation: ['StateValue', 'WaterLevel', 'WaterFlow']
	};
	
	function onMessageCb(modelUpdate) {
	    _appContext.AppContext.getDispatcher().dispatch({
	        type: _ActionTypesCommon2.default.DATA_UPDATE_MESSAGE,
	        payload: modelUpdate
	    });
	}
	
	if (!_appContext.AppContext.getWebsocketUnsupported()) {
	    (0, _amdUtils.amdRequire)(['DataEventSocketSupport'], function (module) {
	        if (module && module.DataEventSocket) {
	            DataEventSocket = new module.DataEventSocket({ onMessageCb: onMessageCb });
	            DataEventSocket.connect(function () {
	                _appContext.AppContext.getDispatcher().registerAfterDispatchListener(connectDataListener);
	                connectDataListener();
	            });
	        } else {
	            _appContext.AppContext.setWebsocketConnected(function () {
	                return DataEventSocket.isConnected();
	            });
	            _appContext.AppContext.getDispatcher().registerAfterDispatchListener(function () {
	                //Todo do something about async--event-chains like change-records
	            });
	        }
	    }, function (err) {
	        console.info('DataEvebntsocketSupport invalid', err);
	
	        _appContext.AppContext.setWebsocketUnsupported(true);
	        _appContext.AppContext.getDispatcher().registerAfterDispatchListener(function () {
	            //Todo do something about async--event-chains like change-records
	        });
	    });
	}
	
	function connectDataListener() {
	    var classNames = {};
	    (0, _RemoteDataActions.activeStores)().forEach(function (store) {
	        if (store.getContainedClassnames) {
	            Object.keys(store.getContainedClassnames()).forEach(function (className) {
	                classNames[className] = true;
	            });
	        }
	    });
	    registerClassNames(classNames);
	}
	
	function registerClassNames(classNames) {
	    var all = {};
	    Object.keys(classNames).forEach(function (cn) {
	        all[cn] = true;
	        if (ADDITIONAL_TOPICS[cn]) {
	            ADDITIONAL_TOPICS[cn].forEach(function (c) {
	                return all[c] = true;
	            });
	        }
	    });
	    DataEventSocket.registerTopics(Object.keys(all));
	}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Created by Carsten Bühler
	 * User: CBuehler on 23.10.2015
	 * Copyright: xdot GmbH 2015
	 */
	
	var toBoolean = function toBoolean(value) {
	    var defaultUndefinedValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    if (value === undefined || value === null) {
	        return defaultUndefinedValue;
	    }
	    if (typeof value === 'boolean') {
	        return value;
	    }
	    if (typeof value === 'string') {
	        return value.toLowerCase() === 'true';
	    }
	    throw new Error('unexpected value for toBoolean' + value);
	};
	
	exports.toBoolean = toBoolean;

/***/ }),
/* 164 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isOrganizationAdmin = isOrganizationAdmin;
	/**
	 * Created by Carsten Bühler
	 * User: c.buehler on 10.03.2017
	 * Copyright: xdot GmbH 2015
	 */
	
	function isOrganizationAdmin(roles) {
	    for (var roleIdx in roles) {
	
	        switch (roles[roleIdx].name) {
	            case 'Administrator':
	                return true;
	            case 'Organization Owner':
	                return true;
	            case 'Organization Administrator':
	                return true;
	        }
	    }
	    return false;
	}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*var testObject = {
	   prop1: 'test',
	   prop2: 2,
	   prop3: null,
	   prop4: undefined,
	   prop5: true,
	   prop6: false,
	   prop7: new File(['file content'], 'my_file.txt'),
	   prop8: new Date('05 January 2020 16:52:00 GMT'),
	   prop9: {
	       prop1: 'test',
	       prop2: 2,
	       prop3: null,
	       prop4: undefined,
	       prop5: true,
	       prop6: false,
	       prop7: ['test', 2, null, undefined, true, false]
	   }
	};*/
	
	function isJsonObject(v) {
	    return !Array.isArray(v) && (typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object' && !!v && !(v instanceof Blob) && !(v instanceof Date);
	}
	
	function convertRecursively(o, func) {
	    var context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	    if (isJsonObject(o)) {
	        for (var key in o) {
	            if (o.hasOwnProperty(key)) {
	                context.push(key);
	                convertRecursively(o[key], func, context);
	                context.pop();
	            }
	        }
	    } else if (Array.isArray(o) || o instanceof FileList) {
	        for (var j = 0; j < o.length; j++) {
	            context.push(j);
	            convertRecursively(o[j], func, context);
	            context.pop();
	        }
	    } else {
	        func(context, o);
	    }
	}
	
	function toKey(c) {
	    return c.map(function (v, i) {
	        return Number.isInteger(v) ? '[' + v + ']' : (i > 0 ? '.' : '') + v;
	    }).join('');
	}
	
	function addToFormData(formData, c, v) {
	    var key = toKey(c);
	    console.log(key, v);
	    if (v instanceof Blob) {
	        formData.append(key, v, v.name);
	    } else if (v instanceof Date) {
	        formData.append(key, v.toISOString());
	    } else if (v == null) {
	        formData.append(key, '__NULL__');
	    } else {
	        formData.append(key, v);
	    }
	}
	
	var toFormData = exports.toFormData = function toFormData(o, customConvert) {
	    var formData = new FormData();
	    convertRecursively(o, function (c, v) {
	        if (customConvert) {
	            v = customConvert(v, c);
	        }
	        addToFormData(formData, c, v);
	    });
	    return formData;
	};

/***/ })
/******/ ])))
});
;


// WEBPACK FOOTER //
// liferay-widgets-react-web.js